import 'babel-polyfill';
import { put, takeEvery, select, throttle } from 'redux-saga/effects';
import sagaUtil from './sagaUtil';
import posSagaUtil from './posSagaUtil';
import reportsSagaUtil from './reportsSagaUtil';
import auditSagaUtil from './auditSagaUtil';
import * as types from 'constants/actionTypes';
import LOOKUP from 'constants/lookup';
import dashboardApi from 'utils/dashboardApi';
import reportsUtil from 'utils/reportsApi';
import reporsByxlsxUtil from 'utils/ExportApi';

//LOGIN
function* login(model) {
  yield sagaUtil.fetch(
    'token',
    model.login,
    (r) => ({
      type: types.LOGIN_REQUEST_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.LOGIN_REQUEST_FAILED,
      data: r ? r.error : "Sorry, this username or password isn't correct",
    })
  );
}

function* createUser(model) {
  yield sagaUtil.fetch(
    'accounts/createuser',
    model.user,
    (r) => ({
      type: types.USER_CREATED,
      user: r.data,
    }),
    (r) => ({
      type: types.CREATE_USER_ERROR,
      data: r,
    })
  );
}

function* changePassword(model) {
  yield sagaUtil.fetch(
    'accounts/changepassword',
    model.changepassword,
    (r) => ({
      type: types.USER_PASSWORD_CHANGED,
      user: r.data,
    }),
    (r) => ({
      type: types.CHANGE_USER_PASSWORD_ERROR,
      data: r,
    })
  );
}

function* changeEmployeePassword(model) {
  yield sagaUtil.fetch(
    `accounts/changeemployeepassword`,
    model.changeemployeepassword,
    (r) => ({
      type: types.EMPLOYEE_PASSWORD_CHANGED,
      user: r.data,
    }),
    (r) => ({
      type: types.CHANGE_EMPLOYEE_PASSWORD_ERROR,
      data: r,
    })
  );
}

function* resetPassword(model) {
  yield sagaUtil.fetch(
    `accounts/resetpassword/${model.username}`,
    null,
    (r) => ({
      type: types.USER_PASSWORDRESET,
      user: r.data,
    }),
    (r) => ({
      type: types.RESETPASSWORD_USER_ERROR,
      data: r,
    })
  );
}

function* forgetPassword(model) {
  yield sagaUtil.fetch(
    `token/forgotpassword/${model.username}`,
    null,
    (r) => ({
      type: types.USER_FORGOTPASSWORD,
      user: r.data,
    }),
    (r) => ({
      type: types.FORGOTPASSWORD_USER_ERROR,
      data: r,
    })
  );
}

function* verifyCredential({ model }) {
  yield sagaUtil.fetch(
    `accounts/verifycredential`,
    model,
    (r) => ({
      type: types.VERIFY_CREDENTIAL_SUCCESS,
      data: r.success,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: r.error,
    })
  );
}

function* getRoles() {
  yield sagaUtil.fetch(`accounts/roles`, null, (r) => ({
    type: types.GET_USER_ROLES_SUCCESS,
    roles: r.data.list,
  }));
}

function* getRole(model) {
  yield sagaUtil.fetch(
    `accounts/role/${model.id}`,
    null,
    (r) => ({
      type: types.GET_ROLE_SUCCESS,
      data: r.data,
      compName: model.compName,
    }),
    (r) => ({
      type: types.GET_ROLE_ERROR,
      data: r.error,
      compName: model.compName,
    })
  );
}

function* saveRole({ model }) {
  yield sagaUtil.fetch(
    `accounts/role/create`,
    model,
    (r) => ({
      type: types.SAVE_ROLE_SUCCESS,
      role: r.data,
      compName: model.compName,
    }),
    (r) => ({
      type: types.SAVE_ROLE_FAILED,
      error: r.error,
      compName: model.compName,
    })
  );
}

function* updateRole({ model }) {
  yield sagaUtil.fetch(
    `accounts/role/update`,
    model,
    (r) => ({
      type: types.UPDATE_ROLE_SUCCESS,
      data: r.data,
      compName: model.compName,
    }),
    (r) => ({
      type: types.UPDATE_ROLE_FAILED,
      error: r.error,
      compName: model.compName,
    })
  );
}

function* deleteRole({ id }) {
  yield sagaUtil.fetch(
    `accounts/role/delete/${id}`,
    null,
    (r) => ({
      type: types.DELETE_ROLE_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.DIALOG_ALERT_OPEN,
      message: r.error,
    })
  );
}

function* getPolicies() {
  yield sagaUtil.fetch(
    `accounts/policies`,
    null,
    (r) => ({
      type: types.GET_POLICIES_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_POLICIES_FAILED,
      error: r.error,
    })
  );
}

function* getUserReportRole(model) {
  yield sagaUtil.fetch(
    `userrolereport/access/${model.id}`,
    null,
    (r) => ({
      type: types.USERROLE_GET_REPORT_SUCCESS,
      userRoleReport: r.data,
    }),
    (r) => ({
      type: types.USERROLE_GET_REPORT_FAILED,
      userRoleReport: r.error,
    })
  );
}

function* getUserPageRole(model) {
  yield sagaUtil.fetch(
    `userrolepage/access/${model.id}`,
    null,
    (r) => ({
      type: types.USERROLE_GET_PAGE_SUCCESS,
      userRolePage: r.data,
    }),
    (r) => ({
      type: types.USERROLE_GET_PAGE_FAILED,
      userRolePage: r.error,
    })
  );
}

function* getUserRoleReportByName(model) {
  yield sagaUtil.fetch(
    `userrolereport/access/role/${model.roleName}`,
    null,
    (r) => ({
      type: types.USERROLE_GET_REPORTBYNAME_SUCCESS,
      userRoleReport: r.data,
    }),
    (r) => ({
      type: types.USERROLE_GET_REPORT_FAILED,
      userRoleReport: r.error,
    })
  );
}

function* getUserRolePageByName(model) {
  yield posSagaUtil.fetch(
    `userrolepage/access/role/${model.roleName}`,
    null,
    (r) => ({
      type: types.USERROLE_GET_PAGEBYNAME_SUCCESS,
      userRolePage: r.data,
    }),
    (r) => ({
      type: types.USERROLE_GET_PAGE_FAILED,
      userRolePage: r.error,
    })
  );
}

function* saveUserReportRole(model) {
  //const userroles = { ...model.userRole };
  yield sagaUtil.fetch(
    'userrolereport/access/updateorcreate',
    model.userRole,
    (r) => ({
      type: types.USERROLE_REPORT_SAVED,
      userRoleReport: r.data,
      compName: model.compName,
    }),
    (r) => ({
      type: types.USERROLE_REPORT_SAVE_FAILED,
      error: r.error,
      compName: model.compName,
    })
  );
}

function* saveUserPageRole(model) {
  //const userroles = { ...model.userRole };
  yield sagaUtil.fetch(
    'userrolepage/access/updateorcreate',
    model.userRole,
    (r) => ({
      type: types.USERROLE_PAGE_SAVED,
      userRolePage: r.data,
      compName: model.compName,
    }),
    (r) => ({
      type: types.USERROLE_PAGE_SAVE_FAILED,
      error: r.error,
      compName: model.compName,
    })
  );
}

function* getUserBranches(userName) {
  yield posSagaUtil.fetch(
    `accounts/branches/${userName.userName}`,
    null,
    (r) => ({
      type: types.GET_USER_BRANCHES_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_USER_BRANCHES_ERROR,
      data: r,
    })
  );
}

function* unlockAccount(username) {
  yield sagaUtil.fetch(
    `accounts/unlockaccount/${username.username}`,
    null,
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: 'Account Unlocked',
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: 'Unable To Unlock Account',
    })
  );
}

function* unlockPatientAccount(model) {
  yield sagaUtil.fetch(
    `accounts/shopunlockaccount/${model.username}`,
    null,
    (r) => ({
      type: types.PATIENT_ACCOUNT_UNLOCKED,
      onlineUserLockedOut: false,
      compName: model.compName,
    }),
    (r) => ({
      type: types.PATIENT_ACCOUNT_UNLOCKED,
      onlineUserLockedOut: true,
      compName: model.compName,
    })
  );
}

function* handlePatientUnlock(action) {
  if (!action.onlineUserLockedOut)
    yield put({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: 'Account Unlocked',
    });
  else
    yield put({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: 'Unable To Unlock Account',
    });
}

//PRODUCT
function* getProducts({ model }) {
  yield sagaUtil.fetch(`products`, model, (r) => ({
    type: types.PRODUCTS_GOT,
    products: r.data,
  }));
}

function* getProductsCampaign({ model }) {
  yield sagaUtil.fetch(`products/campaignsearch`, model, (r) => ({
    type: types.PRODUCTS_GOT_CAMPAIGN,
    products: r.data,
  }));
}

function* getProductsCarousel({ model }) {
  yield sagaUtil.fetch(`products/carouselsearch`, model, (r) => ({
    type: types.PRODUCTS_GOT_CAROUSEL,
    products: r.data,
  }));
}

function* getAccessoryVendors() {
  yield sagaUtil.fetch(
    `products/getAccessoryVendors`,
    null,
    (r) => ({
      type: types.GET_ACCESSORY_VENDORS_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.DIALOG_ALERT_OPEN,
      message: r.error
        ? r.error
        : 'An error occurred while getting accessory vendors. Please try again later.',
    })
  );
}

function* editProductUPC({ model }) {
  yield sagaUtil.fetch(
    `products/editUPC`,
    model,
    (r) => ({
      type: types.PRODUCT_GOT,
      product: r.data,
      compName: model.compName,
    }),
    (r) =>
      r.error.indexOf(
        'This BarCode is already registered by another product.'
      ) != -1
        ? {
          type: types.UPC_EDIT_BARCODE_EXIST,
          message: r.error,
        }
        : {
          type: types.DIALOG_ALERT_OPEN,
          message: r.error
            ? r.error
            : 'An error occurred while updating the upc. Please try again later.',
        },
    false,
    'UPC updated successfully.'
  );
}

function* updateUnitPriceDatabase({ model }) {
  yield sagaUtil.fetch(
    `purchaseorders/unitprice`,
    model,
    (r) => ({
      type: types.UPDATE_PURCHASE_ORDER,
      message: r.message,
      id: r.id,
      price: r.price,
      subtotal: r.subtotal,
      notes: r.notes,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: r.error,
    })
  );
}

function* unreceivePOProduct({ model }) {
  yield sagaUtil.fetch(
    `purchaseorders/unreceive`,
    model,
    (r) => ({
      type: types.UPDATE_PO_UNRECEIVE,
      message: r.message,
      id: r.id,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: r.error,
    })
  );
}

function* unreceiveAll({ model }) {
  yield sagaUtil.fetch(
    `purchaseorders/unreceiveAll/${model}`,
    null,
    (r) => ({
      type: types.UNRECEIVE_ALL_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: r.error,
    })
  );
}

function* deletePO({ model }) {
  yield sagaUtil.fetch(
    `purchaseorders/delete/${model}`,
    null,
    (r) => ({
      type: types.DELETE_PO_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: r.error,
    })
  );
}

function* getProductsByCategory(model) {
  yield sagaUtil.fetch(
    `products/category/${model.typeId}/${model.branchId}`,
    null,
    (r) => ({
      type: types.PRODUCTS_BY_CATEGORY_GOT,
      products: r.data,
    })
  );
}

function* getProductCategories({ branchId }) {
  yield sagaUtil.fetch(`products/categories/getAll/${branchId}`, null, (r) => ({
    type: types.PRODUCTS_CATEGORIES_GOT,
    categories: r.data,
  }));
}

function* getProductCategoriesDropdown(model) {
  const isCannabis = model.isCannabis;
  const url =
    isCannabis !== undefined
      ? `products/getCategories/${isCannabis}`
      : 'products/getCategories';
  yield sagaUtil.fetch(url, null, (r) => ({
    type: types.PRODUCTS_CATEGORIES_DROPDOWN_GOT,
    categories: r.data,
  }));
}

function* getProduct(model) {
  yield sagaUtil.fetch(
    `products/${model.productId}/${model.branchId}`,
    null,
    (r) => ({
      type: types.PRODUCT_GOT,
      product: r.data,
      compName: model.compName,
    })
  );
}

function* getProductById(model) {
  yield sagaUtil.fetch(
    `products/details/${model.productId}/${model.branchId}`,
    null,
    (r) => ({
      type: types.PRODUCT_BY_ID_SUCCESS,
      product: r.data.product,
      matrix: r.data.matrix,
    })
  );
  //Add error Handling
}

function* getProductBarcode({ barcode, branchId }) {
  const model = {
    barcode: barcode,
    branchId: branchId,
  };
  yield posSagaUtil.fetch(
    `pos/barcodeScanToSell`,
    model,
    (r) => ({
      type: types.GET_PRODUCT_BY_BARCODE_SUCCESS,
      data: r.data,
    }),
    () => ({
      type: types.GET_PRODUCT_BY_BARCODE_FAIL,
    })
  );
}

function* saveProduct(model) {
  const product = {
    ...model.product,
  };
  //EDIT
  if (product.Id) {
    yield sagaUtil.fetch(
      'products/update',
      product,
      (r) => ({
        type: types.PRODUCT_CREATED,
        data: r.data,
        compName: model.compName,
      }),
      (r) => ({
        type: types.PRODUCT_CREATE_FAILED,
        data: r,
        compName: model.compName,
      })
    );
  }
  //CREATE
  else {
    yield sagaUtil.fetch(
      'products/create',
      product,
      (r) => ({
        type: types.PRODUCT_CREATED,
        data: r.data,
        compName: model.compName,
      }),
      (r) => ({
        type: types.PRODUCT_CREATE_FAILED,
        data: r,
        compName: model.compName,
      })
    );
  }
}

function* getProductTypes() {
  let branchId = parseInt(localStorage.getItem('TECHPOS_SELECTED_BRANCH'));
  yield sagaUtil.fetch(`products/types/${branchId}`, null, (r) => ({
    type: types.PRODUCT_TYPES_GOT,
    types: r.data,
  }));
}

function* getProductLocations({ branchId }) {
  yield sagaUtil.fetch(
    `products/getLocations/${branchId}`,
    null,
    (r) => ({
      type: types.GET_PRODUCT_LOCATIONS_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_PRODUCT_LOCATIONS_FAIL,
      data: r,
    })
  );
}

function* getProductOrders(model) {
  yield sagaUtil.fetch(`orders/getWithFilters`, model.model, (r) => ({
    type: types.GOT_PRODUCT_ORDERS,
    data: r.data,
  }));
}

function* getProductCatalogList(model) {
  yield reporsByxlsxUtil.get(model.url, model.name);
}

function* getCampaignList({ data }) {
  yield sagaUtil.fetch(
    `campaigns/${data.productId}/${data.branchId}/${data.page}/${data.itemsPerPage}`,
    null,
    (r) => ({
      type: types.GOT_CAMPAIGN_LIST,
      data: r.data,
    })
  );
}

function* getPurchaseOrderList({ data }) {
  yield sagaUtil.fetch(
    `purchaseorders/${data.productId}/${data.page}/${data.itemsPerPage}/${data.branchId}`,
    null,
    (r) => ({
      type: types.GOT_PURCHASE_ORDER_LIST,
      data: r.data,
    })
  );
}

function* deleteProduct({ model }) {
  yield sagaUtil.fetch(
    `products/productdelete/${model.productId}`,
    model,
    (r) => ({
      type: types.DELETE_PRODUCT_SUCCESS,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: 'Unable to delete product',
    })
  );
}

function* uploadProducts({ model }) {
  yield sagaUtil.fetch(
    `products/upload`,
    model,
    (r) => ({
      type: types.UPLOAD_PRODUCT_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.DIALOG_ALERT_OPEN,
      message: r.error
        ? r.error
        : 'An error occurred while uploading products. Please try again later.',
    })
  );
}

// PRODUCT CATEGORY
function* getCategories({ branchId }) {
  yield sagaUtil.fetch(
    `products/categories/getAll/${branchId}`,
    null,
    (r) => ({
      type: types.GET_PRODUCT_CATEGORIES_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_PRODUCT_CATEGORIES_ERROR,
      data: r,
    })
  );
}

// PRODUCT CATEGORY
function* getAllByBranches({ branchIds }) {
  yield sagaUtil.fetch(
    `products/categories/GetAllByBranches/${branchIds}`,
    null,
    (r) => ({
      type: types.GET_PRODUCT_CATEGORIES_BYBRANCHS_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_PRODUCT_CATEGORIES_ERROR,
      data: r,
    })
  );
}

function* getCategoryTree({ branchId }) {
  yield sagaUtil.fetch(
    `products/categories/getCategoryTree/${branchId}`,
    null,
    (r) => ({
      type: types.GET_CATEGORY_TREE_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_CATEGORY_TREE_FAIL,
      data: r,
    })
  );
}

function* getCategory(model) {
  yield sagaUtil.fetch(
    `products/categories/${model.id}`,
    null,
    (r) => ({
      type: types.GET_PRODUCT_CATEGORY_SUCCESS,
      data: r.data,
      compName: model.compName,
    }),
    (r) => ({
      type: types.GET_PRODUCT_CATEGORY_ERROR,
      data: r,
      compName: model.compName,
    })
  );
}

function* saveCategory(model) {
  const category = {
    ...model.model,
  };
  //EDIT
  if (category.Id) {
    yield sagaUtil.fetch(
      `products/categories/${category.Id}`,
      category,
      (r) => ({
        type: types.SAVE_PRODUCT_CATEGORY_SUCCESS,
        data: r.data,
        compName: model.compName,
      }),
      (r) => ({
        type: types.SAVE_PRODUCT_CATEGORY_ERROR,
        data: r,
        compName: model.compName,
      })
    );
  }
  //CREATE
  else {
    yield sagaUtil.fetch(
      `products/categories`,
      category,
      (r) => ({
        type: types.SAVE_PRODUCT_CATEGORY_SUCCESS,
        data: r.data,
        compName: model.compName,
      }),
      (r) => ({
        type: types.SAVE_PRODUCT_CATEGORY_ERROR,
        data: r,
        compName: model.compName,
      })
    );
  }
}

function* getProductInfo(model) {
  yield sagaUtil.fetch(
    `productImages/GetByProduct/${model.productId}`,
    null,
    (r) => ({
      type: types.GET_PRODUCT_INFO_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_PRODUCT_INFO_FAILED,
      data: r,
    })
  );
}

function* postNewProductImage(model) {
  try {
    yield sagaUtil.fetch(`productImages/AddImageToProduct`, { ...model.model });
    yield put({
      type: types.POST_NEW_PRODUCT_IMAGE_SUCCESS,
    });
  } catch (r) {
    yield put({
      type: types.POST_NEW_PRODUCT_IMAGE_FAILED,
      data: r,
    });
  }
}

function* deleteProductImage(model) {
  try {
    const response = yield sagaUtil.fetch(
      `productImages/RemoveImageOfProduct`,
      { ...model.model }
    );
    yield put({
      type: types.DELETE_PRODUCT_IMAGE_SUCCESS,
    });
  } catch (r) {
    yield put({
      type: types.DELETE_PRODUCT_IMAGE_FAILED,
      data: r,
    });
  }
}

//VENDOR
function* getVendors(model) {
  yield sagaUtil.fetch(
    `vendors/${model.page}/${model.itemsPerPage}`,
    null,
    (r) => ({
      type: types.VENDORS_GOT,
      vendors: r.data,
    })
  );
}

function* getVendorsByCountryState(model) {
  yield sagaUtil.fetch(
    `vendors/country/${model.country}/${model.state}`,
    null,
    (r) => ({
      type: types.VENDORS_GOT,
      vendors: r.data,
    })
  );
}

function* getVendor(model) {
  yield sagaUtil.fetch(`vendors/${model.vendorId}`, null, (r) => ({
    type: types.VENDOR_GOT,
    vendor: r.data,
    compName: model.compName,
  }));
}

function* saveVendor(model) {
  const vendor = {
    ...model.vendor,
  };

  //EDIT
  if (vendor.Id) {
    yield sagaUtil.fetch(
      'vendors/update',
      vendor,
      (r) => ({
        type: types.VENDOR_SAVED,
        success: true,
        data: r.data,
        compName: model.compName,
      }),
      (r) => ({
        type: types.VENDOR_SAVED_FAILED,
        success: false,
        data: r,
        compName: model.compName,
      })
    );
  }
  //CREATE
  else {
    yield sagaUtil.fetch(
      'vendors/create',
      vendor,
      (r) => ({
        type: types.VENDOR_SAVED,
        success: true,
        data: r.data,
        compName: model.compName,
      }),
      (r) => ({
        type: types.VENDOR_SAVED_FAILED,
        success: false,
        data: r,
        compName: model.compName,
      })
    );
  }
}

function* createCategory(model) {
  yield put({
    type: types.CATEGORY_CREATED,
    data: model.category,
  });
}

// PURCHASE ORDER

function* savePurchaseOrder(model) {
  let purchaseOrder = {
    ...model.purchaseOrder,
  };
  //EDIT
  if (purchaseOrder.Id) {
    yield sagaUtil.fetch(
      `purchaseorders/${purchaseOrder.Id}`,
      purchaseOrder,
      (r) => ({
        type: types.PURCHASE_ORDER_EDITED,
        compName: model.compName,
        data: r.data,
      }),
      (r) => ({
        type: types.PURCHASE_ORDER_SAVE_ERROR,
        compName: model.compName,
        error: r.error,
      })
    );
  }
  //CREATE
  else {
    yield sagaUtil.fetch(
      'purchaseorders',
      purchaseOrder,
      (r) => ({
        type: types.PURCHASE_ORDER_CREATED,
        compName: model.compName,
        data: r.data,
      }),
      (r) => ({
        type: types.PURCHASE_ORDER_SAVE_ERROR,
        compName: model.compName,
        error: r.error,
      })
    );
  }
}

function* getPurchaseOrder(model) {
  yield sagaUtil.fetch(
    `purchaseorders/${model.id}/${model.branchId}`,
    null,
    (r) => ({
      type: types.PURCHASE_FORM_LOADED,
      purchaseOrder: r.data,
      compName: model.compName,
    })
  );
}

function* getPurchaseOrderProduct(model) {
  yield sagaUtil.fetch(
    `purchaseorders/getPurchaseOrderProduct/${model.id}`,
    null,
    (r) => ({
      type: types.PURCHASE_PRODUCT_LOADED,
      product: r.data,
    })
  );
}

function* getPurchaseOrders({ model }) {
  yield sagaUtil.fetch(`purchaseorders/filter`, model, (r) => ({
    type: types.PO_LIST_LOADED,
    purchaseOrders: r.data,
  }));
}

function* getPurchaseOrderForBulkTransfer({ model }) {
  yield sagaUtil.fetch(`purchaseorders/filterforbulktransfer`, model, (r) => ({
    type: types.PO_LIST_LOADED,
    purchaseOrders: r.data,
  }));
}

function* cancelPurchaseOrder(model) {
  yield sagaUtil.fetch(
    `purchaseorders/${model.id}/cancel`,
    model,
    () => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: model.msg,
    }),
    (r) => ({
      type: types.PO_STATUS_SAVE_FAILED,
      compName: model.compName,
      error: r.error,
    })
  );
}

function* openPurchaseOrder(model) {
  yield sagaUtil.fetch(
    `purchaseorders/${model.id}/open`,
    model,
    () => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: model.msg,
    }),
    (r) => ({
      type: types.PO_STATUS_SAVE_FAILED,
      compName: model.compName,
      error: r.error,
    })
  );
}

function* onOrderPurchaseOrder(model) {
  yield sagaUtil.fetch(
    `purchaseorders/${model.id}/onOrder`,
    model,
    () => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: model.msg,
    }),
    (r) => ({
      type: types.PO_STATUS_SAVE_FAILED,
      compName: model.compName,
      error: r.error,
    })
  );
}

function* importPO(model) {
  yield sagaUtil.fetch(
    `purchaseorders/importPO`,
    model.model,
    (r) => ({
      type: types.PURCHASE_ORDER_IMPORT_SUCCESS,
      data: r.branchId,
    }),
    (r) => ({
      type: types.PURCHASE_ORDER_IMPORT_FAIL,
      error: r.error
        ? r.error
        : 'An error occurred while receiving the product. Please try again later.',
    })
  );
}

function* importPOSOrderTemplate(model) {
    yield sagaUtil.fetch(
        `orders/importPOSOrderTemplate`,
        model.model,
        (r) => ({
            type: types.POS_ORDER_IMPORT_TEMPLATE_SUCCESS,
            compName: model.compName,
            data: r.data,
            currentCashFlow: r.data && r.data.currentCashFlow ? r.data.currentCashFlow : null,
            resultSKUs: r.failSKUs
        }),
        (r) => (
        r.data.redislocked ?
        {
            type: types.SAVE_POS_ORDER_ERROR,
            compName: model.compName,
            data: r,
            message: r.message
        }
        :    
        {
            type: types.POS_ORDER_IMPORT_TEMPLATE_FAIL,
            resultSKUs: r.failSKUs,
            message: r.error ?
                r.error :
                "An error occurred while receiving the product. Please try again later.",
            data: r.data
        })
    );
}

function* importPOCannabisTemplate(model) {
  yield sagaUtil.fetch(
    `purchaseorders/importPOCannabisTemplate`,
    model.model,
    (r) => ({
      type: types.PURCHASE_ORDER_CANNABIS_TEMPLATE_SUCCESS,
      data: r.branchId,
      createdSKUs: r.createdSKUs,
    }),
    (r) => ({
      type: types.DIALOG_ALERT_OPEN,
      message: r.error
        ? r.error
        : 'An error occurred while receiving the product. Please try again later.',
    })
  );
}

function* importPOVapeTemplate(model) {
  yield sagaUtil.fetch(
    `purchaseorders/importPOVapeTemplate`,
    model.model,
    (r) => ({
      type: types.PURCHASE_ORDER_IMPORT_SUCCESS,
      data: r.branchId,
      createdSKUs: r.createdSKUs,
    }),
    (r) => ({
      type: types.DIALOG_ALERT_OPEN,
      message: r.error
        ? r.error
        : 'An error occurred while receiving the product. Please try again later.',
    })
  );
}

function* importPOTemplate(model) {
  yield sagaUtil.fetch(
    `purchaseorders/importPOTemplate`,
    model.model,
    (r) => ({
      type: types.PURCHASE_ORDER_IMPORT_SUCCESS,
      data: r.branchId,
    }),
    (r) => ({
      type: types.DIALOG_ALERT_OPEN,
      message: r.error
        ? r.error
        : 'An error occurred while receiving the product. Please try again later.',
    })
  );
}

function* importPOTemplateSuccess(data) {
  let model = {
    id: null,
    branchId: data.data || 0,
    description: '',
    paymentDueDate: null,
    dateExpected: null,
    createdDate: null,
    status: 'None',
    total: null,
    orderBy: 'DESC',
    sortBy: '',
    page: 1,
    itemsPerPage: 25,
  };
  yield put({
    type: types.SNACKBAR_SHOW_MESSAGE,
    message: 'PO Imported Successfully.',
  });
  yield put({
    type: types.PO_LIST_LOAD,
    model,
  });
}

function* importEmployeeTemplate(model) {
  yield sagaUtil.fetch(
    `employees/importTemplate`,
    model.model,
    (r) => ({
      type: types.EMPLOYEE_IMPORT_TEMPLATE_SUCCESS,
      data: r.branchId,
    }),
    (r) => ({
      type: types.DIALOG_ALERT_OPEN,
      message: r.error
        ? r.error
        : 'An error occurred while receiving the Employees. Please try again later.',
    })
  );
}

function* importEmployeeTemplateSuccess(data) {
  const model = {
    id: 0,
    firstName: '',
    lastName: '',
    role: '',
    status: 'Active',
    orderBy: 'DESC',
    sortBy: 'id',
    branchId: data.data,
  };
  yield sagaUtil.fetch(`employees`, model, (r) => ({
    type: types.EMPLOYEE_LIST_LOADED,
    employees: r.data,
  }));
}

//INVENTORY ADJUST

function* getInventoryAdjust({ model }) {
  yield sagaUtil.fetch(
    `warehouses/inventoryAdjust`,
    model,
    (r) => ({
      type: types.GET_INVENTORY_ADJUST_SUCCESS,
      data: r.data,
    }),
    () => ({
      type: types.GET_INVENTORY_ADJUST_FAIL,
    })
  );
}

function* saveInventoryAdjust({ model }) {
  yield sagaUtil.fetch(
    `warehouses/updateInventoryAdjust`,
    model,
    (r) => ({
      type: types.PRODUCT_WAREHOUSE_REFRESH,
    }),
    () => ({
      type: types.SAVE_INVENTORY_ADJUST_FAIL,
    })
  );
}

// TRANSFERPRODUCT
function* getWarehouses({ branchId }) {
  yield sagaUtil.fetch(
    `warehouses/${branchId}`,
    null,
    (r) => ({
      type: types.WAREHOUSES_GET_SUCCESS,
      data: r.data,
    }),
    () => ({
      type: types.WAREHOUSES_GET_ERROR,
    })
  );
}

function* getProductsFromWarehouse({ model }) {
  yield sagaUtil.fetch(
    `warehouses/filter`,
    model,
    (r) => ({
      type: types.PRODUCTWAREHOUSE_LIST_LOADED,
      productsWarehouse: r.data,
      isTransfer: model.isTransfer,
    }),
    () => ({
      type: types.DIALOG_ALERT_OPEN,
      message: LOOKUP.common.genericError,
    })
  );
}

function* getProductsGroupedFromWarehouse({ model }) {
  yield sagaUtil.fetch(
    `warehouses/filtergrouped`,
    model,
    (r) => ({
      type: types.PRODUCTWAREHOUSE_GROUPED_LIST_LOADED,
      productsWarehouse: r.data,
      isTransfer: model.isTransfer,
      productId: model.productId,
    }),
    () => ({
      type: types.DIALOG_ALERT_OPEN,
      message: LOOKUP.common.genericError,
    })
  );
}

function* sendBulkTransfer({ model }) {
  yield sagaUtil.fetch(
    `warehouses/transfer/bulk`,
    model,
    (r) => ({
      type: types.BULK_TRANSFER_SUCCESS,
    }),
    () => ({
      type: types.BULK_TRANSFER_FAIL,
    })
  );
}

function* getProductsAutocompleteFromWarehouse({ model }) {
  yield sagaUtil.fetch(
    `warehouses/autocomplete`,
    model,
    (r) =>
      r.data && r.data.isScanned
        ? {
          type: types.BULK_TRANSFER_SCAN_PRODUCT_SUCCESS,
          bulkTransferScanProductData: r.data.list,
        }
        : {
          type: types.PRODUCTWAREHOUSE_AUTOCOMPLETE_LIST_LOADED,
          productsWarehouse: r.data,
        },
    (r) => ({
      type: types.DIALOG_ALERT_OPEN,
      message: r.error ? r.error : LOOKUP.common.genericError,
    })
  );
}

function* getProductsFromExcelBulkTransfer({ model }) {
  yield sagaUtil.fetch(
    `warehouses/excelupload`,
    model,
    (r) => ({
      type: types.BULK_TRANSFER_EXCEL_SEARCH_LIST_LOADED,
      bulkTransferExcelProducts: r.data,
    }),
    (r) => ({
      type: types.DIALOG_ALERT_OPEN,
      message: r.error ? r.error : LOOKUP.common.genericError,
    })
  );
}

function* confirmBulkTransfers({ id }) {
  yield sagaUtil.fetch(
    `warehouses/bulkTransfer/confirm`,
    id,
    (r) => ({
      type: types.BULK_TRANSFER_CONFIRM_SUCCESS,
      bulkTransferNoQuantity: r.noTransferQuantity,
    }),
    (r) => ({
      type: types.DIALOG_ALERT_OPEN,
      message: r.error ? r.error : LOOKUP.common.genericError,
    })
  );
}

function* getPendingBulkTransferProducts({ model }) {
  yield sagaUtil.fetch(
    `warehouses/bulkTransfer/pendingProducts`,
    model,
    (r) => ({
      type: types.GET_PENDING_BULK_TRANSFER_PRODUCTS_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.DIALOG_ALERT_OPEN,
      message: r.error ? r.error : LOOKUP.common.genericError,
    })
  );
}

function* getBulkTransfers({ model }) {
  yield sagaUtil.fetch(
    `warehouses/bulkTransfer`,
    model,
    (r) => ({
      type: types.BULK_TRANSFER_LIST_LOADED,
      data: r.data,
    }),
    () => ({
      type: types.DIALOG_ALERT_OPEN,
      message: LOOKUP.common.genericError,
    })
  );
}

function* getBulkTransferById({ id }) {
  yield sagaUtil.fetch(
    `warehouses/bulkTransfer/${id}`,
    null,
    (r) => ({
      type: types.BULK_TRANSFER_LOADED,
      data: r.data,
    }),
    () => ({
      type: types.DIALOG_ALERT_OPEN,
      message: LOOKUP.common.genericError,
    })
  );
}

function* getProductQuantity({ model }) {
  yield sagaUtil.fetch(
    `warehouses/getProductQuantity`,
    model,
    (r) => ({
      type: types.PRODUCT_QUANTITY_LOADED,
      data: r.data,
    }),
    () => ({
      type: types.DIALOG_ALERT_OPEN,
      message: LOOKUP.common.genericError,
    })
  );
}

function* receiveProduct({ model }) {
  yield sagaUtil.fetch(
    `purchaseorders/receive/${model.purchaseOrderProductId}/${model.branchId}`,
    model,
    () => ({
      type: types.PRODUCT_PO_RECEIVED,
    }),
    (r) =>
      r.error.indexOf(
        'This BarCode is already registered by another product.'
      ) != -1
        ? {
          type: types.PO_RECEIVE_BARCODE_EXIST,
          message: r.error,
        }
        : {
          type: types.DIALOG_ALERT_OPEN,
          message: r.error
            ? r.error
            : 'An error occurred while receiving the product. Please try again later.',
        },
    false,
    'Product received successfully.'
  );
}

function* getProductsInTransit(model) {
  yield sagaUtil.fetch(
    `purchaseorders/items/intrasit/${model.branchId}`,
    null,
    (r) => ({
      type: types.PRODUCTS_IN_TRANSIT_LOADED,
      productsInTransit: r.data,
    }),
    () => ({
      type: types.DIALOG_ALERT_OPEN,
      message: LOOKUP.common.genericError,
    })
  );
}

function* transferProductToWarehouse(model) {
  yield sagaUtil.fetch(
    `warehouses/transfer/one`,
    model.model,
    () => ({
      type: types.PRODUCT_WAREHOUSE_TRANSFERED,
      model: model.model,
    }),
    () => ({
      type: types.DIALOG_ALERT_OPEN,
      message: LOOKUP.transferProduct.transferProductError,
    })
  );
}

function* getProductsBarcodeInventoryAudit({ model }) {
  yield sagaUtil.fetch(
    `warehouses/inventoryAuditBarcode`,
    model,
    (r) => ({
      type: types.GET_PRODUCT_BARCODE_INVENTORY_AUDIT_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.DIALOG_ALERT_OPEN,
      message: r.error ? r.error : LOOKUP.common.genericError,
    })
  );
}

//trigger types.PRODUCT_WAREHOUSE_TRANSFERED
//SUCCESS MSG WHEN TRANSFER OR ADJUSTED
//SHOULD RECEIVE BRANCHID AND MESSAGE
function* transferProductToWarehouseSuccess(data) {
  const model = {
    branchId: data.model.branchId,
    categoryId: null,
    itemsPerPage: 45,
    orderBy: 'DESC',
    page: 1,
    productName: '',
    quantity: null,
    sortBy: 'productId',
    warehouseId: null,
  };

  yield put({
    type: types.SNACKBAR_SHOW_MESSAGE,
    message: data.model.message || 'Warehouse updated successfully.',
  });
  yield put({
    type: types.PRODUCT_WAREHOUSE_REFRESH,
  });
  yield put({
    type: types.PRODUCTWAREHOUSE_GROUPED_LIST_LOAD,
    model,
  });
}

function* mergeProductWarehouse(model) {
  yield sagaUtil.fetch(
    `warehouses/merge`,
    model.model,
    () => ({
      type: types.PRODUCT_WAREHOUSE_MERGED,
      branchId: model.model.branchId,
    }),
    () => ({
      type: types.DIALOG_ALERT_OPEN,
      message: LOOKUP.transferProduct.transferProductError,
    })
  );
}

function* mergeProductWarehouseSuccess(branchId) {
  const model = {
    branchId: branchId.branchId,
    categoryId: null,
    itemsPerPage: 45,
    orderBy: 'DESC',
    page: 1,
    productName: '',
    quantity: null,
    sortBy: 'productId',
    warehouseId: null,
  };
  yield put({
    type: types.SNACKBAR_SHOW_MESSAGE,
    message: LOOKUP.transferProduct.mergeProductSuccess,
  });
  yield put({
    type: types.PRODUCT_WAREHOUSE_REFRESH,
  });
  yield put({
    type: types.PRODUCTWAREHOUSE_GROUPED_LIST_LOAD,
    model,
  });
}

function* adjustProductWarehouse(model) {
  yield sagaUtil.fetch(
    `warehouses/adjust`,
    model.model,
    () => ({
      type: types.ADJUST_PRODUCT_WAREHOUSE_SUCCESS,
      model: model.model,
    }),
    () => ({
      type: types.DIALOG_ALERT_OPEN,
      message: LOOKUP.transferProduct.adjustProductError,
    })
  );
}

function* adjustProductQty(model) {
  yield sagaUtil.fetch(
    `warehouses/adjust`,
    model.model,
    () => ({
      type: types.ADJUST_PRODUCT_QTY_SUCCESS,
      model: model.model,
    }),
    () => ({
      type: types.DIALOG_ALERT_OPEN,
      message: LOOKUP.transferProduct.adjustProductError,
    })
  );
}

function* convertBulkToUnit(model) {
  yield sagaUtil.fetch(
    `warehouses/bulktounitconvert`,
    model.model,
    () => ({
      type: types.CONVERT_BULK_TO_UNIT_SUCCESS,
      model: model.model,
    }),
    () => ({
      type: types.DIALOG_ALERT_OPEN,
      message: LOOKUP.transferProduct.adjustProductError,
    })
  );
}

function* clearOnHoldQty(model) {
  yield sagaUtil.fetch(
    `warehouses/clearOnHoldQty/${model.model.branchId}/${model.model.ProductId}`,
    null,
    () => ({
      type: types.PRODUCT_WAREHOUSE_TRANSFERED,
      model: model.model,
    }),
    () => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: 'Clear onhold quantity fail',
    })
  );
}

function* getProductInventoryByBranch(model) {
  yield sagaUtil.fetch(
    `warehouses/getProductInventoryByBranch/${model.model.branchId}/${model.model.ProductId}`,
    null,
    (r) => ({
      type: types.GET_PRODUCT_INVENTORY_BY_BRANCH_SUCCESS,
      data: r.data,
      mode: model.model.type,
    }),
    (r) => ({
      type: types.GET_PRODUCT_INVENTORY_BY_BRANCH_FAIL,
      message: r.error,
    })
  );
}

function* WpInventorySyncronization({ model }) {
  // let branchId = ""+model.branchId;
  yield sagaUtil.fetch(
    `wp/product/updateall/${model.branchId}`,
    null,
    () => ({
      type: types.WORDPRESS_SYNC_ALL_PRODUCTS_SUCCESS,
      model: model.model,
    }),
    () => ({
      type: types.DIALOG_ALERT_OPEN,
      message: LOOKUP.transferProduct.WpSyncError,
    })
  );
}

function* lookupWordpressUnmappedProducts({ model }) {
  // let branchId = ""+model.branchId;
  yield sagaUtil.fetch(
    `wp/product/syncwordpressproducts/${model.branchId}`,
    null,
    (r) => ({
      type: types.DIALOG_ALERT_OPEN,
      message: r.message,
    }),
    () => ({
      type: types.DIALOG_ALERT_OPEN,
      message: LOOKUP.transferProduct.WpSyncError,
    })
  );
}

//FOR TRANSFER
function* adjustProductWarehouseSuccess(model) {
  yield put({
    type: types.PRODUCT_WAREHOUSE_TRANSFERED,
    model: model.model,
  });
  //location.reload();
}

//AUDIT
function* getAudit({ model }) {
  yield sagaUtil.fetch(
    `audit/${model.branchId}/${model.Id}/${model.getQuantities}`,
    model,
    (r) => ({
      type: types.GET_AUDIT_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: `Get Audit failed.`,
    })
  );
}

function* getAudits({ model }) {
  yield sagaUtil.fetch(
    `audit/${model.branchId}`,
    model,
    (r) => ({
      type: types.GET_AUDITS_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: `Get Audits failed. ${r.error}`,
    })
  );
}

function* saveAudit(model) {
  const audit = model.model;

  if (audit.Id != 0) {
    yield sagaUtil.fetch(
      `audit/${audit.BranchId}/update`,
      audit,
      (r) => ({
        type: types.AUDIT_SAVE_SUCCESS,
        compName: model.compName,
        data: r.data,
      }),
      (r) => ({
        type: types.SNACKBAR_SHOW_MESSAGE,
        message: r.error,
      })
    );
  } else {
    yield sagaUtil.fetch(
      `audit/${audit.BranchId}/create`,
      audit,
      (r) => ({
        type: types.AUDIT_SAVE_SUCCESS,
        compName: model.compName,
        data: r.data,
        createdId: r.createdId,
      }),
      (r) => ({
        type: types.SNACKBAR_SHOW_MESSAGE,
        message: r.error,
      })
    );
  }
}

function* addProductsToAduit({ model }) {
  yield sagaUtil.fetch(
    `audit/addProductsToAduit`,
    model,
    (r) => ({
      type: types.AUDIT_UPDATE_SUCCESS,
      compName: model.compName,
      data: r.data,
      scanned: r.scanned,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: r.error,
    })
  );
}

function* deleteAudit({ model, branchId, itemId }) {
  yield sagaUtil.fetch(
    `audit/Remove/${itemId}/${branchId}`,
    model,
    (r) => ({
      type: types.GET_AUDITS_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: `Get Audits failed. ${r.error}`,
    })
  );
}

function* filterAuditListStatus({ model }) {
  yield sagaUtil.fetch(
    `audit/${model.branchId}`,
    model,
    (r) => ({
      type: types.GET_AUDITS_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: `Get Audits failed. ${r.error}`,
    })
  );
}

function* removeProductInAduit({ model }) {
  yield sagaUtil.fetch(
    `audit/removeProductInAduit/${model.BranchId}/${model.AuditId}/${model.ProductId}`,
    model,
    (r) => ({
      type: types.AUDIT_UPDATE_SUCCESS,
      compName: model.compName,
      data: r.data,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: r.error,
    })
  );
}

function* updateAuditName({ model }) {
  yield auditSagaUtil.fetch(
    `audit/updateAuditName/${model.BranchId}/${model.AuditId}/${model.Name}`,
    model,
    (r) => ({
      type: types.AUDIT_UPDATE_PART_SUCCESS,
      compName: model.compName,
      data: r.data,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: r.error,
    })
  );
}

function* updateAuditProductQuantity({ model }) {
  yield auditSagaUtil.fetch(
    `audit/updateAuditProductQuantity/${model.BranchId}/${model.AuditId}/${model.ProductId}/${model.Quantity}/${model.WarehouseType}`,
    model,
    (r) => ({
      type: model.lockExpectedQuantity
        ? types.AUDIT_PRODUCT_QTY_WITH_LOCK_SUCCESS
        : types.AUDIT_UPDATE_PART_SUCCESS,
      compName: model.compName,
      data: r.data,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: r.error,
    })
  );
}

function* updateAuditProductExpectedQuantity({ model }) {
  yield auditSagaUtil.fetch(
    `audit/updateAuditProductExpectedQuantity/${model.BranchId}/${model.AuditId}/${model.ProductId}/${model.ExpectedQuantity}/${model.WarehouseType}`,
    model,
    (r) => ({
      type: types.AUDIT_PRODUCT_UPDATE_EXPECTED_QTY_SUCCESS,
      compName: model.compName,
      data: r.data,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: r.error,
    })
  );
}

function* updateAuditProductDiffQty({ model }) {
  yield auditSagaUtil.fetch(
    `audit/updateAuditProductDiffQty/${model.BranchId}/${model.AuditId}/${model.ProductId}/${model.CountedCost}/${model.DiffQty}/${model.DiffCost}/${model.WarehouseType}`,
    model,
    (r) => ({
      type: types.AUDIT_PRODUCT_UPDATE_DIFF_QTY_SUCCESS,
      compName: model.compName,
      data: r.data,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: r.error,
    })
  );
}

function* updateAuditProductNotes({ model }) {
  yield auditSagaUtil.fetch(
    `audit/updateAuditProductNotes`,
    model,
    (r) => ({
      type: types.AUDIT_UPDATE_PART_SUCCESS,
      compName: model.compName,
      data: r.data,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: r.error,
    })
  );
}

function* getAuditWarehouses({ model }) {
  yield sagaUtil.fetch(
    `audit/warehouses`,
    model,
    (r) => ({
      type: types.AUDIT_WAREHOUSES_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: `Get Audits Warehouses failed.`,
    })
  );
}

function* completeAudit({ model }) {
  yield sagaUtil.fetch(
    `audit/complete`,
    model,
    (r) => ({
      type: types.AUDIT_SAVE_SUCCESS,
      compName: 'InventoryAudit',
    }),
    (r) => ({
      type: types.DIALOG_ALERT_OPEN,
      message: r.error,
    })
  );
}

function* verifyAudit({ model }) {
  yield sagaUtil.fetch(
    `audit/verify/${model.BranchId}/${model.AuditId}`,
    model,
    () => ({
      type: types.AUDIT_SAVE_SUCCESS,
      compName: 'InventoryAudit',
    }),
    (r) => ({
      type: types.DIALOG_ALERT_OPEN,
      message: r.error,
    })
  );
}

function* recountAudit({ model }) {
  yield sagaUtil.fetch(
    `audit/recount/${model.BranchId}/${model.AuditId}/${model.ProductIds.join(',')}`,
    model,
    () => ({
      type: types.AUDIT_SAVE_SUCCESS,
      compName: 'InventoryAudit',
    }),
    (r) => ({
      type: types.DIALOG_ALERT_OPEN,
      message: r.error,
    })
  );
}

function* getAuditProducts({ model }) {
  yield sagaUtil.fetch(
    `products/audit`,
    model,
    (r) => ({
      type: types.PRODUCTS_AUDIT_GOT,
      data: r.data,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: `Get Products failed.`,
    })
  );
}

function* getAuditCategory({ model }) {
  yield sagaUtil.fetch(
    `products/auditcategory`,
    model,
    (r) => ({
      type: types.CATEGORY_AUDIT_GOT,
      data: r.data,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: r.error ? r.error : `Get Category failed.`,
    })
  );
}

function* getBrands() {
  let branchId = parseInt(localStorage.getItem('TECHPOS_SELECTED_BRANCH'));
  yield sagaUtil.fetch(`products/brands/${branchId}`, null, (r) => ({
    type: types.BRANDS_GOT_LIST,
    data: r.data,
  }));
}

function* getAuditBrand({ model }) {
  yield sagaUtil.fetch(
    `products/auditbrand`,
    model,
    (r) => ({
      type: types.BRAND_AUDIT_GOT,
      data: r.data,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: `Get Brand failed.`,
    })
  );
}

function* getUncountedByCategory({ model }) {
  yield sagaUtil.fetch(
    `audit/uncounted/${model.branchId}/${model.date}`,
    model,
    (r) => ({
      type: types.UNCOUNTED_AUDIT_GOT,
      data: r.data,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: r.error ? r.error : `Get uncounted failed.`,
    })
  );
}

function* getAuditCategories({ model }) {
  yield sagaUtil.fetch(
    `audit/categories/${model.branchId}`,
    model,
    (r) => ({
      type: types.CATEGORIES_AUDIT_GOT,
      data: r.data,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: r.error ? r.error : `Get audit categories failed.`,
    })
  );
}

//PATIENTS
function* getPatients({ model }) {
  yield sagaUtil.fetch(`patients/marketing`, model, (r) => ({
    type: types.PATIENT_LIST_LOADED,
    patients: r.data,
  }));
}

function* savePatient(model) {
  let patient = {
    ...model.patient,
  };
  // if id does not exists, it is a CREATE
  if (!patient.Id) {
    yield sagaUtil.fetch(
      'patients/create',
      model.patient,
      (r) => ({
        type: types.PATIENT_SAVED,
        compName: model.compName,
        data: r.data,
      }),
      (r) => ({
        type: types.DIALOG_ALERT_OPEN,
        message: r.error,
      })
    );
  }
  // EDIT
  else {
    yield sagaUtil.fetch(
      `patients/update`,
      model.patient,
      (r) => ({
        type: types.PATIENT_SAVED,
        compName: model.compName,
        data: r.data,
      }),
      (r) => ({
        type: types.DIALOG_ALERT_OPEN,
        message: r.error,
      })
    );
  }
}

function* getPatient(model) {
  yield sagaUtil.fetch('patients/' + model.id, null, (r) => ({
    type: types.PATIENT_FORM_LOADED,
    data: r.data,
    compName: model.compName,
  }));
}

function* getPatientSpringBigNotifications(model) {
  yield sagaUtil.fetch(
    'patients/springBigNotifications/' +
    model.model.branchId +
    '/' +
    model.model.patientId,
    null,
    (r) => ({
      type: types.PATIENT_FORM_LOADED,
      data: r.data,
      compName: model.model.compName,
    })
  );
}

function* getPatientDetails(model) {
  yield sagaUtil.fetch(
    'patients/details/' + model.model.id + '/' + model.model.branchId,
    null,
    (r) => ({
      type: types.GOT_PATIENT_DETAIL,
      data: r.data,
    })
  );
}

function* sendMemberMerge(model) {
  yield sagaUtil.fetch(
    `patients/mergeMember/${model.model.branchId}/${model.model.memberMain}/${model.model.memberMerge}`,
    null,
    (r) => ({
      type: types.MERMBER_MERGE_SUCCESS,
      data: r.data,
    })
  );
}

function* editEliteMembership({ model }) {
  yield sagaUtil.fetch(
    'patients/updateMembership',
    model,
    (r) => ({
      type: types.EDIT_ELITE_MEMBERSHIP_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.EDIT_ELITE_MEMBERSHIP_FAILED,
      message: r.error,
    })
  );
}

//DOCTORS
function* getDoctor(model) {
  yield sagaUtil.fetch(`doctors/${model.id}/${model.branchId}`, null, (r) => ({
    type: 'DOCTOR_EDIT_LOADED',
    data: r.data,
    compName: model.compName,
  }));
}

function* getDoctors(model) {
  yield sagaUtil.fetch(
    `doctors/${model.page}/${model.itemsPerPage}/${model.branchId}`,
    null,
    (r) => ({
      type: types.DOCTOR_LIST_LOADED,
      doctors: r.data,
    })
  );
}

function* saveDoctor(model) {
  const doctor = {
    ...model.doctor,
  };

  // if id does not exists, it is a CREATE
  if (!doctor.Id) {
    yield sagaUtil.fetch(
      'doctors',
      model.doctor,
      (r) => ({
        type: types.DOCTOR_CREATED,
        compName: model.compName,
        data: r.data,
      }),
      (r) => ({
        type: types.DOCTOR_SAVE_FAILED,
        compName: model.compName,
        error: r.error,
      })
    );
  }
  // EDIT
  else {
    yield sagaUtil.fetch(
      `doctors/${doctor.Id}`,
      model.doctor,
      (r) => ({
        type: types.DOCTOR_EDITED,
        compName: model.compName,
        data: r.data,
      }),
      (r) => ({
        type: types.DOCTOR_SAVE_FAILED,
        compName: model.compName,
        error: r.error,
      })
    );
  }
}

function* inactivateDoctor(model) {
  yield sagaUtil.fetch(
    `doctors/${model.id}/inactivate`,
    model,
    () => ({
      type: types.DOCTOR_LIST_LOAD,
      page: 1,
      itemsPerPage: model.itemsPerPage,
    }),
    (r) => ({
      type: types.DOCTOR_SAVE_FAILED,
      compName: model.compName,
      error: r.error,
    })
  );
}

function* activateDoctor(model) {
  yield sagaUtil.fetch(
    `doctors/${model.id}/activate`,
    model,
    () => ({
      type: types.DOCTOR_LIST_LOAD,
      page: 1,
      itemsPerPage: model.itemsPerPage,
    }),
    (r) => ({
      type: types.DOCTOR_SAVE_FAILED,
      compName: model.compName,
      error: r.error,
    })
  );
}

//EMPLOYEE
function* getEmployees({ model }) {
  yield sagaUtil.fetch(`employees`, model, (r) => ({
    type: types.EMPLOYEE_LIST_LOADED,
    employees: r.data,
  }));
}

function* getEmployee({ model }) {
  yield sagaUtil.fetch(`employees/${model.id}`, null, (r) => ({
    type: types.EMPLOYEE_GOT,
    employee: r.data,
    compName: model.compName,
  }));
}

function* getEmployeeDetails({ model }) {
  yield sagaUtil.fetch(`employees/details/${model.id}`, null, (r) => ({
    type: types.EMPLOYEE_GOT_DETAILS,
    employee: r.data,
    compName: model.compName,
  }));
}

function* getAllEmployees() {
  yield sagaUtil.fetch(`employees`, null, (r) => ({
    type: types.ALL_EMPLOYEES_GOT,
    employees: r.data.list,
  }));
}

function* getactiveEmployeesOfBranch({ model }) {
  yield sagaUtil.fetch(
    `employees/activeEmployeesOfBranch/${model.branchId}`,
    null,
    (r) => ({
      type: types.GET_ACTIVE_EMPLOYEE_BY_BRANCH_SUCCESS,
      employees: r.data.list,
    })
  );
}

function* getEmployeesByFilter({ model }) {
  yield sagaUtil.fetch(
    `employees/byFilter/${model.byEmail}/${model.bySMS}/${model.branchId}`,
    null,
    (r) => ({
      type: types.GET_EMPLOYEE_BY_FILTER_SUCCESS,
      employees: r.data.list,
    })
  );
}

function* getAuthenticatedEmployee(model) {
  yield sagaUtil.fetch(`employees/user/${model.username}`, null, (r) => ({
    type: types.AUTHENTICATED_EMPLOYEE_GOT,
    employee: r.data,
  }));
}

function* saveEmployee(model) {
  const employee = {
    ...model.employee,
  };

  // if id does not exists, it is a CREATE
  if (!employee.Id) {
    yield sagaUtil.fetch(
      'employees/create',
      model.employee,
      (r) => ({
        type: types.EMPLOYEE_SAVED,
        compName: model.compName,
        data: r.data,
      }),
      (r) => ({
        type: types.EMPLOYEE_SAVE_FAILED,
        compName: model.compName,
        error: r.error,
      })
    );
  }
  // EDIT
  else {
    yield sagaUtil.fetch(
      'employees/update',
      model.employee,
      (r) => ({
        type: types.EMPLOYEE_SAVED,
        compName: model.compName,
        data: r.data,
      }),
      (r) => ({
        type: types.EMPLOYEE_SAVE_FAILED,
        compName: model.compName,
        error: r.error,
      })
    );
  }
}

// WEIGHT
function* saveWeightSetting(model) {
  const weightSetting = {
    ...model.weightSetting,
  };
  //EDIT
  if (weightSetting.Id) {
    yield sagaUtil.fetch(
      `weightsettings/update`,
      weightSetting,
      (r) => ({
        type: types.WEIGHT_SETTING_SAVED,
        compName: model.compName,
        data: r.data,
      }),
      (r) => ({
        type: types.WEIGHT_SETTING_SAVE_ERROR,
        compName: model.compName,
        error: r.error,
      })
    );
  }
  //CREATE
  else {
    yield sagaUtil.fetch(
      'weightsettings/create',
      weightSetting,
      (r) => ({
        type: types.WEIGHT_SETTING_SAVED,
        compName: model.compName,
        data: r.data,
      }),
      (r) => ({
        type: types.WEIGHT_SETTING_SAVE_ERROR,
        compName: model.compName,
        error: r.error,
      })
    );
  }
}

function* getWeightSetting(model) {
  yield sagaUtil.fetch(`weightsettings/${model.id}`, null, (r) => ({
    type: types.WEIGHT_SETTING_GOT,
    weightSetting: r.data,
    compName: model.compName,
  }));
}

function* getWeightSettings() {
  yield sagaUtil.fetch(`weightsettings`, null, (r) => ({
    type: types.WEIGHT_SETTING_GOT_ALL,
    weightSettings: r.data,
  }));
}

// PRICE MATRIX
function* getPriceMatrices() {
  yield sagaUtil.fetch(`pricematrices`, null, (r) => ({
    type: types.PRICE_MATRIX_GOT_ALL,
    priceMatrices: r.data,
  }));
}

function* getPriceMatrix(model) {
  yield sagaUtil.fetch(`pricematrices/${model.id}`, null, (r) => ({
    type: types.PRICE_MATRIX_GOT,
    priceMatrix: r.data,
    compName: model.compName,
  }));
}

function* savePriceMatrix(model) {
  const priceMatrix = {
    ...model.priceMatrix,
  };
  //EDIT
  if (priceMatrix.Id) {
    yield sagaUtil.fetch(
      `pricematrices/update`,
      priceMatrix,
      (r) => ({
        type: types.PRICE_MATRIX_SAVED,
        compName: model.compName,
        data: r.data,
      }),
      (r) => ({
        type: types.PRICE_MATRIX_SAVE_ERROR,
        compName: model.compName,
        error: r.error,
      })
    );
  }
  //CREATE
  else {
    yield sagaUtil.fetch(
      'pricematrices/create',
      priceMatrix,
      (r) => ({
        type: types.PRICE_MATRIX_SAVED,
        compName: model.compName,
        data: r.data,
      }),
      (r) => ({
        type: types.PRICE_MATRIX_SAVE_ERROR,
        compName: model.compName,
        error: r.error,
      })
    );
  }
}

function* applyPriceMatrixToProducts(model) {
  yield sagaUtil.fetch(
    'pricematrices/updatepricematrix',
    model.model,
    (r) => ({
      type: types.PRICE_MATRIX_PRODUCTS_APPLIED,
      compName: model.compName,
      data: r.data,
    }),
    (r) => ({
      type: types.PRICE_MATRIX_PRODUCTS_APPLY_ERROR,
      compName: model.compName,
      error: r.error,
    })
  );
}

// POS
function* getPOS(model) {
  yield posSagaUtil.fetch(
    `pos/${model.deviceId}/${model.branchId}`,
    null,
    (r) => ({
      type: types.POS_GOT,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_POS_ERROR,
      error: r
        ? r.error
        : 'Failed to get pos information for device: ' + model.deviceId,
    })
  );
}

function* getSellableProducts(model) {
  yield posSagaUtil.fetch(
    'pos/products',
    model.model,
    (r) => ({
      type: types.SELLABLE_PRODUCTS_GOT,
      data: r.data,
      model: model.model,
    }),
    (r) => ({
      type: types.GET_SELLABLE_PRODUCTS_ERROR,
      error: r.error,
    })
  );
}

function* getSellableProductById({ model }) {
  yield posSagaUtil.fetch(
    `pos/${model.branchId}/products/${model.productId}`,
    model,
    (r) => ({
      type: types.SELABLE_BY_ID_GOT,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_SELLABLE_PRODUCT_BY_ID_ERROR,
      error: r,
    })
  );
}

function* getPOSPatients(model) {
  yield posSagaUtil.fetch(
    'pos/patients',
    model.model,
    (r) => ({
      type: types.POS_PATIENTS_GOT,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_POS_PATIENTS_ERROR,
      error: r.error,
    })
  );
}

function* assignMember({ model }) {
  yield sagaUtil.fetch(
    'orders/assignmember',
    model,
    (r) => ({
      type: types.POS_ORDER_SAVED,
      data: r.data,
    }),
    (r) => ({
      type: types.SAVE_POS_ORDER_ERROR,
      data: r,
    })
  );
}

function* addDutchieOrLeaflyAsOnlineOrder({ model }) {
  yield sagaUtil.fetch(
    'orders/dutchieOrLeaflyAsOnlineOrder',
    model,
    (r) => ({
      type: types.POS_ORDER_SAVED,
      data: r.data,
    }),
    (r) => ({
      type: types.SAVE_POS_ORDER_ERROR,
      data: r,
    })
  );
}

function* getProductSuggestion({ model }) {
  yield sagaUtil.fetch(
    'pos/productSuggestion',
    model,
    (r) => ({
      type: types.GET_PRODUCT_SUGGESTION_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.SAVE_POS_ORDER_ERROR,
      data: r,
    })
  );
}

function clearTempModel() {
  tempModel = '';
}

function* posEmailReceipt({ model }) {
  yield sagaUtil.fetch(
    `orders/${model.orderId}/receipt/email`,
    model,
    () => ({
      type: types.ORDER_EMAIL_RECEIPT_SENT,
    }),
    (r) => ({
      type: types.SEND_ORDER_EMAIL_RECEIPT_ERROR,
      error: r,
    })
  );
}

function* posSMSReceipt({ model }) {
  yield sagaUtil.fetch(
    `orders/${model.orderId}/receipt/sms`,
    model,
    () => ({
      type: types.ORDER_SMS_RECEIPT_SENT,
    }),
    (r) => ({
      type: types.SEND_ORDER_SMS_RECEIPT_ERROR,
      error: r,
    })
  );
}

function* addRefundOrder(model) {
  yield sagaUtil.fetch(
    `orders/${model.orderId}/refund`,
    model.refund,
    (r) => ({
      type: types.ADDED_REFUND_ORDER,
      data: r.data,
      compName: model.compName,
    }),
    (r) => ({
      type: types.ADD_REFUND_ORDER_ERROR,
      error: r,
      compName: model.compName,
    })
  );
}

var tempModel;
function* saveOrder(model) {
  if (JSON.stringify(model) == JSON.stringify(tempModel)) {
    alert('double scan! Please refresh page and try again!');
    return;
  }
  tempModel = model;
  const order = {
    ...model.order,
  };

  const orderFormatted = {
    Id: order.id,
    PatientId: order.patientId,
    DeviceId: order.deviceId,
    BranchId: order.branchId,
    Products: order.products,
    EmployeeId: order.employeeId,
    useFNTax: order.useFNTax,
    taxExemptAll: order.taxExemptAll,
  };

  if (order.id) {
    orderFormatted.modifiedDate = order.modifiedDate;
    yield posSagaUtil.fetch(
      `orders/update`,
      orderFormatted,
      (r) => ({
        type: types.POS_ORDER_SAVED,
        compName: model.compName,
        data: r.data,
        currentCashFlow:
          r.data && r.data.currentCashFlow ? r.data.currentCashFlow : null,
      }),
      (r) => ({
        type: types.SAVE_POS_ORDER_ERROR,
        compName: model.compName,
        data: r,
      })
    );
  } else {
    yield posSagaUtil.fetch(
      `orders/create`,
      orderFormatted,
      (r) => ({
        type: types.POS_ORDER_SAVED,
        compName: model.compName,
        data: r.data,
        currentCashFlow:
          r.data && r.data.currentCashFlow ? r.data.currentCashFlow : null,
      }),
      (r) => ({
        type: types.SAVE_POS_ORDER_ERROR,
        compName: model.compName,
        data: r,
      })
    );
  }
}

function* voidOrderProduct(model) {
  const formatted = {
    DeviceId: model.deviceId,
    EmployeeId: model.employeeId,
    BranchId: model.branchId,
    RemoveProduct: model.removeProduct,
    modifiedDate: model.modifiedDate,
  };
  const stackDiscountsEnabled = yield select(
    (state) => state.common.applicationSettings.stackDiscountsEnabled
  );
  const apiUrl = stackDiscountsEnabled ? 'voidWithStackDiscount' : 'void';
  const endpoint = `orders/${model.orderId}/product/${model.orderProductId}/${apiUrl}`;

  yield posSagaUtil.fetch(
    endpoint,
    formatted,
    (r) => ({
      type: types.POS_ORDER_SAVED,
      data: r.data,
      currentCashFlow:
        r.data && r.data.currentCashFlow ? r.data.currentCashFlow : null,
    }),
    (r) => ({
      type: types.VOID_POS_ORDER_PRODUCT_ERROR,
      error: r,
    })
  );
}

function* addPaymentToOrder(model) {
  yield posSagaUtil.fetch(
    `orders/${model.payment.orderId}/payment/${model.payment.paymentId}`,
    model.payment,
    (r) => ({
      type: types.POS_ORDER_SAVED_PRINT_RECEIPT,
      data: r.data,
      deviceBalance: r.deviceBalance,
      currentCashFlow: r && r.currentCashFlow ? r.currentCashFlow : null,
    }),
    (r) => ({
      type: types.ADD_PAYMENT_POS_ORDER_ERROR,
      error: r,
    })
  );
}

function* checkOrderUpdateTime(model) {
  yield posSagaUtil.fetch(
    `orders/checkOrderUpdateTime/${model.orderId}/${model.modifiedDate}`,
    null,
    (r) => ({
      type:
        model.updateType != 'refund'
          ? types.CHECK_ORDER_UPDATE_TIME_OK
          : types.CHECK_ORDER_UPDATE_TIME_REFUND_OK,
    }),
    (r) => ({
      type: types.CHECK_ORDER_UPDATE_TIME_FAIL,
      error: r,
    })
  );
}

function* clearTax(model) {
  yield posSagaUtil.fetch(
    `orders/clearTax/${model.orderId}`,
    null,
    (r) => ({
      type: types.CLEAR_TAX_POS_ORDER_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.CLEAR_TAX_POS_ORDER_FAIL,
      error: r,
    })
  );
}

function* addShippingCost(model) {
  yield posSagaUtil.fetch(
    `orders/shippingCost/${model.orderId}/${model.shippingCost}/${model.modifiedDate}`,
    null,
    (r) => ({
      type: types.POS_ORDER_SAVED,
      data: r.data,
    }),
    (r) => ({
      type: types.ADD_SHIPPING_COST_FAIL,
      error: r,
    })
  );
}

function* addTipAmount(model) {
  yield posSagaUtil.fetch(
    `orders/tipAmount/${model.orderId}/${model.tipAmount}/${model.modifiedDate}`,
    null,
    (r) => ({
      type: types.POS_ORDER_SAVED,
      data: r.data,
      currentCashFlow: r.data && r.data.cashFlow ? r.data.cashFlow : null,
    }),
    (r) => ({
      type: types.ADD_TIP_AMOUNT_FAIL,
      error: r,
    })
  );
}

function* getOrder(model) {
  yield posSagaUtil.fetch(
    `orders/${model.orderId}/${model.deviceId}/${model.branchId}`,
    null,
    (r) => ({
      type: types.POS_ORDER_SAVED,
      data: r.data,
      currentCashFlow:
        r.data && r.data.currentCashFlow ? r.data.currentCashFlow : null,
    }),
    (r) => ({
      type: types.GET_POS_ORDER_ERROR,
      error: r,
    })
  );
}

function* getCashFlowOrderDetail({ model }) {
  yield sagaUtil.fetch(
    `orders/cashFlowOrders/${model.branchId}/${model.cashFlowId}`,
    null,
    (r) => ({
      type: types.GET_CASHFLOW_ORDERS_DETAIL_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_CASHFLOW_ORDERS_DETAIL_FAIL,
      error: r,
    })
  );
}

function* cancelOrder(model) {
  yield posSagaUtil.fetch(
    `orders/${model.orderId}/cancel`,
    model.model,
    (r) => ({
      type: types.POS_ORDER_CANCELLED,
      data: r.data,
    }),
    (r) => ({
      type: types.CANCEL_POS_ORDER_ERROR,
      error: r,
    })
  );
}

function* cancelAllOpenOrders(model) {
  yield sagaUtil.fetch(
    `orders/cancelAllOpenOrders/${model.branchId}`,
    model.model,
    () => ({
      type: types.POS_ORDER_CANCELLED_ALL,
    }),
    (r) => ({
      type: types.CANCEL_POS_ORDER_ERROR,
      error: r,
    })
  );
}

function* setDiscount(model) {
  const stackDiscountsEnabled = yield select(
    (state) => state.common.applicationSettings.stackDiscountsEnabled
  );
  const apiUrl = stackDiscountsEnabled ? 'stackDiscounts' : 'discount';
  const endpoint = `orders/${model.model.OrderId}/${apiUrl}`;

  yield sagaUtil.fetch(
    endpoint,
    model.model,
    (r) => ({
      type: types.SET_ORDER_DISCOUNT_SUCCESS,
      data: r.data,
      compName: model.compName,
      currentCashFlow:
        r.data && r.data.currentCashFlow ? r.data.currentCashFlow : null,
    }),
    (r) => ({
      type: types.SET_ORDER_DISCOUNT_ERROR,
      error: r,
      compName: model.compName,
    })
  );
}

function* setVisitDiscount(model) {
  yield sagaUtil.fetch(
    `orders/${model.model.OrderId}/visitdiscount`,
    model.model,
    (r) => ({
      type: types.SET_ORDER_DISCOUNT_SUCCESS,
      data: r.data,
      compName: model.compName,
      currentCashFlow:
        r.data && r.data.currentCashFlow ? r.data.currentCashFlow : null,
    }),
    (r) => ({
      type: types.SET_ORDER_DISCOUNT_ERROR,
      error: r,
      compName: model.compName,
    })
  );
}

function* setProductsDiscount(model) {
  yield sagaUtil.fetch(
    `orders/${model.model.OrderId}/products/discount`,
    model.model,
    (r) => ({
      type: types.SET_ORDER_PRODUCT_DISCOUNT_SUCCESS,
      data: r.data,
      compName: model.compName,
      currentCashFlow:
        r.data && r.data.currentCashFlow ? r.data.currentCashFlow : null,
    }),
    (r) => ({
      type: types.SET_ORDER_PRODUCT_DISCOUNT_ERROR,
      error: r,
      compName: model.compName,
    })
  );
}

function* removeDiscountOrder(model) {
  const stackDiscountsEnabled = yield select(
    (state) => state.common.applicationSettings.stackDiscountsEnabled
  );
  const apiUrl = stackDiscountsEnabled ? 'stackDiscount' : 'discount';
  const endpoint = `orders/${model.model.orderId}/${apiUrl}/remove`;

  yield sagaUtil.fetch(
    endpoint,
    model.model,
    (r) => ({
      type: types.REMOVE_ORDER_DISCOUNT_SUCCESS,
      data: r.data,
      compName: model.compName,
    }),
    (r) => ({
      type: types.REMOVE_ORDER_DISCOUNT_ERROR,
      error: r,
      compName: model.compName,
    })
  );
}

function* removeDiscountProductOrder(model) {
  yield sagaUtil.fetch(
    `orders/${model.model.orderId}/products/discount/remove`,
    model.model,
    (r) => ({
      type: types.REMOVE_ORDER_PRODUCT_DISCOUNT_SUCCESS,
      data: r.data,
      compName: model.compName,
      currentCashFlow:
        r.data && r.data.currentCashFlow ? r.data.currentCashFlow : null,
    }),
    (r) => ({
      type: types.REMOVE_ORDER_PRODUCT_DISCOUNT_ERROR,
      error: r,
      compName: model.compName,
    })
  );
}

function* finalizeOrder(model) {
  yield sagaUtil.fetch(
    `orders/${model.orderId}/finalize`,
    model,
    (r) => ({
      type: types.FINALIZE_POS_ORDER_SUCCESS,
      data: r.data,
      currentCashFlow:
        r.data && r.data.currentCashFlow ? r.data.currentCashFlow : null,
    }),
    (r) => ({
      type: types.FINALIZE_POS_ORDER_ERROR,
      error: r,
    })
  );
}

function* checkPriceEstimation(model) {
  yield sagaUtil.fetch(
    `pos/${model.branchId}/product/${model.productId
    }/price/estimation/${model.amount.toFixed(2)}`,
    null,
    (r) => ({
      type: types.CHECK_PRICE_ESTIMATION_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.CHECK_PRICE_ESTIMATION_ERROR,
      error: r,
    })
  );
}

function* sendOrderToFulFillment(model) {
  const order = {
    ...model.order,
  };

  const orderFormatted = {
    Id: order.id,
    PatientId: order.patientId,
    DeviceId: order.deviceId,
    BranchId: order.branchId,
    Products: order.products,
    EmployeeId: order.employeeId,
  };

  yield posSagaUtil.fetch(
    `orders/sendToFulfillment`,
    orderFormatted,
    (r) => ({
      type: types.SEND_ORDER_TO_FULFILLMENT_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: r.error,
    })
  );
}

function* getManagerApproval(model) {
  yield sagaUtil.fetch(
    `orders/managerApproval`,
    model.model,
    (r) => ({
      type: types.MANAGER_APPROVAL_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.MANAGER_APPROVAL_FAILED,
      message: r.error,
    })
  );
}

// DEVICE
function* getDeviceByIP(model) {
  const state = yield select((state) => state);
  yield sagaUtil.fetch(
    `devices/getDeviceByIP/${model.branchId}/${model.ipAddress}`,
    null,
    (r) => {
      const applicationSettings = state.common.applicationSettings;
      localStorage.setItem(
        applicationSettings.deviceKeyName,
        JSON.stringify({ ...r.data })
      );
      return {
        type: types.GET_DEVICE_BY_IP_SUCCESS,
        data: r.data,
      };
    },
    (r) => ({
      type: types.GET_DEVICE_BY_IP_FAIL,
      error: r.error,
    })
  );
}

function* saveDevice(model) {
  const device = {
    ...model.device,
  };
  const state = yield select((state) => state);
  const applicationSettings = state.common.applicationSettings;
  const deviceKeyName = applicationSettings.deviceKeyName;

  //EDIT
  if (device.Id) {
    yield sagaUtil.fetch(
      `devices/update`,
      device,
      (r) => {
        localStorage.setItem(deviceKeyName, JSON.stringify({ ...r.data }));
        return {
          type: types.DEVICE_SAVED,
          compName: model.compName,
          data: r.data,
        };
      },
      (r) => {
        if (!r.success) {
          return {
            type: types.DEVICE_SAVE_ERROR,
            compName: model.compName,
            error: r.error,
          };
        }
      }
    );
  }
  //CREATE
  else {
    yield sagaUtil.fetch(
      'devices/create',
      device,
      (r) => {
        localStorage.setItem(deviceKeyName, JSON.stringify({ ...r.data }));
        return {
          type: types.DEVICE_SAVED,
          compName: model.compName,
          data: r.data,
        };
      },
      (r) => {
        if (!r.success) {
          return {
            type: types.DEVICE_SAVE_ERROR,
            compName: model.compName,
            error: r.error,
          };
        }
      }
    );
  }
}

function* updateDeviceIp(model) {
  const state = yield select((state) => state);
  yield sagaUtil.fetch(
    `devices/${model.id}/update/ip`,
    model.ip,
    (r) => {
      const applicationSettings = state.common.applicationSettings;
      localStorage.setItem(
        applicationSettings.deviceKeyName,
        JSON.stringify({ ...r.data })
      );
      return {
        type: types.DEVICE_IP_UPDATED,
        data: r.data,
      };
    },
    (r) => ({
      type: types.UPDATE_DEVICE_IP_ERROR,
      error: r && r.error ? r.error : 'Error to update ID Address',
    })
  );
}

function* getDevice(model) {
  yield sagaUtil.fetch(`devices/${model.id}/${model.branchId}`, null, (r) => ({
    type: types.DEVICE_GOT,
    device: r.data,
    compName: model.compName,
  }));
}

function* getDevices(model) {
  yield sagaUtil.fetch(
    `devices/${model.model.branchId}/status/${model.model.status}`,
    null,
    (r) => ({
      type: types.DEVICE_GOT_ALL,
      devices: r.data,
    })
  );
}

function* getStores() {
  yield sagaUtil.fetch(`stores`, null, (r) => ({
    type: types.STORES_GOT_ALL,
    stores: r.data,
  }));
}

// DEVICE TYPE
function* getDeviceTypes() {
  yield sagaUtil.fetch(`devices/types`, null, (r) => ({
    type: types.DEVICETYPE_GOT_ALL,
    deviceTypes: r.data,
  }));
}

// DEVICE ROLE
function* getDeviceRoles() {
  yield sagaUtil.fetch(`devices/roles`, null, (r) => ({
    type: types.DEVICEROLE_GOT_ALL,
    deviceRoles: r.data,
  }));
}

function* saveDeviceRole(model) {
  yield sagaUtil.fetch(
    'devices/roles/create',
    model.roleModel,
    (r) => ({
      type: types.DEVICEROLE_SAVED,
      compName: model.compName,
      data: r.data,
    }),
    (r) => ({
      type: types.SAVE_DEVICEROLE_ERROR,
      compName: model.compName,
      error: r.error,
    })
  );
}

// DEVICE ROLE
function* getDeviceWorkStations(model) {
  yield sagaUtil.fetch(`devices/workstations/${model.branchId}`, null, (r) => ({
    type: types.DEVICEWORKSTATION_GOT_ALL,
    deviceWorkStations: r.data,
  }));
}

function* saveDeviceWorkStation(model) {
  yield sagaUtil.fetch(
    'devices/workstations/create',
    model.workstationModel,
    (r) => ({
      type: types.DEVICEWORKSTATION_SAVED,
      compName: model.compName,
      data: r.data,
    }),
    (r) => ({
      type: types.DEVICEWORKSTATION_SAVE_ERROR,
      compName: model.compName,
      error: r.error,
    })
  );
}

// BANK DEPOSITS
function* getBankDeposits(model) {
  let url = `bankdeposits/filter?${sagaUtil.getQueryString(model)}`;
  yield sagaUtil.newFetch('GET', url, null, (r) => ({
    type: types.BANKDEPOSITS_GOT_ALL,
    response: r,
  }));
}

function* getBankDeposit(model) {
  let url = `bankdeposits/${model.id}`;
  yield sagaUtil.newFetch('GET', url, null, (r) => ({
    type: types.BANKDEPOSITS_GOT,
    response: r,
    compName: model.compName,
  }));
}

function* insertBankDeposit(action) {
  let model = action.model;
  yield sagaUtil.newFetch(
    'POST',
    'bankdeposits',
    model,
    (r) => ({
      type: types.BANKDEPOSITS_SAVED,
      response: r,
      compName: action.compName,
    }),
    (r) => ({
      type: types.BANKDEPOSITS_SAVED_ERROR,
      error: r.errorMessage,
      compName: action.compName,
    })
  );
}

function* updateBankDeposit(action) {
  let model = action.model;
  let url = `bankdeposits/${model.id}`;
  yield sagaUtil.newFetch(
    'PATCH',
    url,
    model,
    (r) => ({
      type: types.BANKDEPOSITS_SAVED,
      response: r,
      compName: action.compName,
    }),
    (r) => ({
      type: types.BANKDEPOSITS_SAVED_ERROR,
      error: r.errorMessage,
      compName: action.compName,
    })
  );
}

// SAFE MANAGEMENT
function* getSafeManagements({ model }) {
  let url = `safemanagement/filter?${sagaUtil.getQueryString(model)}`;
  yield sagaUtil.fetch(url, null, (r) => ({
    type: types.SAFEMANAGEMENT_GOT_ALL,
    response: { ...r.data, balance: r.balance },
  }));
}

function* saveSafeManagement(action) {
  let model = action.model;
  yield sagaUtil.fetch(
    'safemanagement',
    model,
    (r) => ({
      type: types.SAFEMANAGEMENT_SAVED,
      response: r.data,
      compName: action.compName,
    }),
    (r) => ({
      type: types.SAFEMANAGEMENT_SAVED_ERROR,
      error: r.error,
      compName: action.compName,
    })
  );
}

// CASH FLOW
function* cashInAmount(model) {
  const deviceId = model.deviceId;
  const cashInAmount = model.amount;

  yield sagaUtil.fetch(
    `cashflows/cashin/${deviceId}/${cashInAmount}/${model.branchId}`,
    model,
    (r) => ({
      type: types.CASHFLOW_SAVED_CASHIN,
      compName: model.compName,
      cashFlow: r.data,
    }),
    (r) => ({
      type: types.CASHFLOW_SAVED_CASHIN_ERROR,
      compName: model.compName,
      error: r,
    })
  );
}

function* cashOutAmount(model) {
  const deviceId = model.deviceId;
  const cashInAmount = model.amount;

  yield sagaUtil.fetch(
    `cashflows/${deviceId}/${cashInAmount}/`,
    null,
    (r) => ({
      type: types.CASHFLOW_SAVED_CASHOUT,
      compName: model.compName,
      cashFlow: r.data,
    }),
    (r) => ({
      type: types.CASHFLOW_SAVE_CASHINOUT_ERROR,
      compName: model.compName,
      error: r.error,
    })
  );
}

function* cashDrop(model) {
  yield sagaUtil.fetch(
    `cashflows/cashdrop`,
    model,
    (r) => ({
      type: types.CASHFLOW_SAVED_CASHDROP,
      cashFlow: r.data,
    }),
    (r) => ({
      type: types.CASHFLOW_SAVE_CASHDROP_ERROR,
      compName: model.compName,
      error: r.error,
    })
  );
}

function* closeRegister(model) {
  yield sagaUtil.fetch(
    `cashflows/closecashregister/${model.deviceId}/${model.branchId}/${model.cashoutAmount}`,
    model,
    (r) => ({
      type: model.fromCashIn
        ? types.CASHFLOW_REGISTERS_CLOSED_FROM_CASHIN
        : types.CASHFLOW_REGISTERS_CLOSED,
      cashFlow: r.data,
    }),
    (r) => ({
      type: types.CASHFLOW_CLOSE_REGISTERS_ERROR,
      error: r.error,
    })
  );
}

function* getCashFlow(model) {
  const cashFlowId = model.cashFlowId;
  yield sagaUtil.fetch(
    `cashflows/${cashFlowId}/${model.branchId}`,
    null,
    (r) => ({
      type: types.CASHFLOW_GOT,
      cashFlow: r.data,
    })
  );
}

function* getCashFlowOrders(model) {
  const cashFlowId = model.cashFlowId;
  yield sagaUtil.fetch(
    `cashflows/getCashFlowOrders/${cashFlowId}/${model.branchId}`,
    null,
    (r) => ({
      type: types.CASHFLOW_ORDERS_GOT,
      cashFlowOrders: r.data,
    }),
    (r) => ({
      type: types.CASHFLOW_ORDERS_GET_ERROR,
      error: r && r.error ? r.error : null,
    })
  );
}

function* verifyCashOut(model) {
  yield sagaUtil.fetch(
    `cashflows/${model.model.id}/cashout/verify`,
    model.model,
    (r) => ({
      type: types.CASHFLOW_CASHOUT_VERIFIED,
      data: r.data,
      compName: model.compName,
    }),
    (r) => ({
      type: types.CASHFLOW_CASHOUT_ERROR,
      error: r.error,
      compName: model.compName,
    })
  );
}

function* notVerifyCashOut(model) {
  yield sagaUtil.fetch(
    `cashflows/${model.model.id}/cashout/notVerify`,
    model.model,
    (r) => ({
      type: types.CASHFLOW_CASHOUT_NOT_VERIFIED,
      data: r.data,
      compName: model.compName,
    }),
    (r) => ({
      type: types.CASHFLOW_CASHOUT_ERROR,
      error: r.error,
      compName: model.compName,
    })
  );
}

function* getCashFlows({ model }) {
  yield sagaUtil.fetch(`cashflows/filter`, model, (r) => ({
    type: types.CASHFLOW_GOT_ALL,
    cashFlows: r.data,
  }));
}

function* closeRegisters(model) {
  yield sagaUtil.fetch(
    `cashflows/close`,
    model.model,
    (r) => ({
      type: types.CASHFLOW_REGISTERS_CLOSED,
      data: r.data,
      compName: model.compName,
    }),
    (r) => ({
      type: types.CASHFLOW_CLOSE_REGISTERS_ERROR,
      error: r.error,
      compName: model.compName,
    })
  );
}

function* closeClosingInProgressRegisters(model) {
  yield sagaUtil.fetch(
    `cashflows/closecip`,
    model.model,
    (r) => ({
      type: types.CASHFLOW_REGISTERS_CLOSED,
      data: r.data,
      compName: model.compName,
    }),
    (r) => ({
      type: types.CASHFLOW_CLOSE_REGISTERS_ERROR,
      error: r.error,
      compName: model.compName,
    })
  );
}

function* cashFlowNotes(model) {
  const cashFlowId = model.id;
  yield sagaUtil.fetch(
    `cashflows/notes/${cashFlowId}/${model.branchId}`,
    model.notes,
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: 'Cash register note saved',
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: 'Unable to save note',
    })
  );
}

function* cashFlowRegisterCountSave(model) {
  yield sagaUtil.fetch(
    `cashflows/countset`,
    model.model,
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: 'Saved cash register bill/coin count',
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: 'Unable to save cash register bill/coin count',
    })
  );
}

function* cashFlowRegisterCountGet(model) {
  yield sagaUtil.fetch(`cashflows/countget/${model.id}`, null, (r) => ({
    type: types.CASHFLOW_REGISTER_COUNT_GOT,
    data: r.data,
  }));
}

// PAYMENT
function* savePayment(model) {
  const payment = {
    ...model.payment,
  };
  //EDIT
  if (payment.Id) {
    yield sagaUtil.fetch(
      `payments/update`,
      payment,
      (r) => ({
        type: types.PAYMENT_SAVED,
        compName: model.compName,
        data: r.data,
      }),
      (r) => ({
        type: types.PAYMENT_SAVE_ERROR,
        compName: model.compName,
        error: r.error,
      })
    );
  }
  //CREATE
  else {
    yield sagaUtil.fetch(
      'payments/create',
      payment,
      (r) => ({
        type: types.PAYMENT_SAVED,
        compName: model.compName,
        data: r.data,
      }),
      (r) => ({
        type: types.PAYMENT_SAVE_ERROR,
        compName: model.compName,
        error: r.error,
      })
    );
  }
}

function* getPayment(model) {
  yield sagaUtil.fetch(`payments/${model.id}/${model.branchId}`, null, (r) => ({
    type: types.PAYMENT_GOT,
    payment: r.data,
    compName: model.compName,
  }));
}

function* getPayments(model) {
  yield sagaUtil.fetch(`payments/${model.branchId}`, null, (r) => ({
    type: types.PAYMENT_GOT_ALL,
    payments: r.data,
  }));
}

// TAXRATE
function* saveTaxRate(model) {
  const taxrate = {
    ...model.taxrate,
  };
  //EDIT
  if (taxrate.Id) {
    yield sagaUtil.fetch(
      `taxesrate/update`,
      taxrate,
      (r) => ({
        type: types.TAXRATE_SAVED,
        compName: model.compName,
        data: r.data,
      }),
      (r) => ({
        type: types.TAXRATE_SAVE_ERROR,
        compName: model.compName,
        error: r.error,
      })
    );
  }
  //CREATE
  else {
    yield sagaUtil.fetch(
      'taxesrate/create',
      taxrate,
      (r) => ({
        type: types.TAXRATE_SAVED,
        compName: model.compName,
        data: r.data,
      }),
      (r) => ({
        type: types.TAXRATE_SAVE_ERROR,
        compName: model.compName,
        error: r.error,
      })
    );
  }
}

function* getTaxRate(model) {
  yield sagaUtil.fetch(
    `taxesrate/${model.id}/${model.branchId}`,
    null,
    (r) => ({
      type: types.TAXRATE_GOT,
      taxrate: r.data,
      compName: model.compName,
    })
  );
}

function* getTaxesRate(model) {
  yield sagaUtil.fetch(`taxesrate/${model.branchId}`, null, (r) => ({
    type: types.TAXRATE_GOT_ALL,
    taxesrate: r.data,
  }));
}

//ORDER
function* getOpenOrders(model) {
  yield sagaUtil.fetch(
    `orders/open/${model.branchId}/${model.page}/${model.itemsPerPage}`,
    null,
    (r) => ({
      type: types.OPEN_ORDERS_GOT,
      data: r.data,
    }),
    (r) => ({
      type: types.OPEN_ORDERS_GET_ERROR,
      error: r.error,
    })
  );
}

function* getRecentOders(model) {
  yield sagaUtil.fetch(
    `orders/recent/${model.branchId}`,
    null,
    (r) => ({
      type: types.RECENT_ORDERS_GOT,
      data: r.data,
    }),
    (r) => ({
      type: types.RECENT_ORDERS_GET_ERROR,
      error: r.error,
    })
  );
}

function* getOldOpenOrders(model) {
  yield sagaUtil.fetch(
    `orders/getOldOpenOrders/${model.branchId}`,
    null,
    (r) => ({
      type: types.OLD_OPEN_ORDERS_GOT,
      oldOpenOrderIds: r.oldOpenOrderIds,
      openUnpaidOnlineOrderIds: r.openUnpaidOnlineOrderIds,
    }),
    (r) => ({
      type: types.OLD_OPEN_ORDERS_GET_ERROR,
      error: r.error,
    })
  );
}

function* getInventoryFlag({ branchId }) {
  yield sagaUtil.fetch(
    `pos/getInventoryFlag/${branchId}`,
    null,
    (r) => ({
      type: types.GET_INVENTORY_FLAG_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_INVENTORY_FLAG_FAIL,
      error: r ? r.error : "can't get inventory flag",
    })
  );
}

function* AddStoreToDoorDateTime({ model }) {
  yield sagaUtil.fetch(
    `storetodoor/LockDateAndTime/Create`,
    model,
    (r) => ({
      type: types.CREATE_STORE_TO_DOOR_DELIVERY_TIME_SUCCESS,
      data: r.data,
    }),
    (error) => ({
      type: types.CREATE_STORE_TO_DOOR_DELIVERY_TIME_FAILED,
      error: error.error,
    })
  );
}

function* GetAllStoreToDoorDateTime({ model }) {
  yield sagaUtil.fetch(
    `storetodoor/GetAll/${model.branchId}`,
    null,
    (r) => ({
      type: types.GET_ALL_STORE_TO_DOOR_DELIVERY_TIME_SUCCESS,
      data: r.data,
    }),
    () => ({
      type: types.GET_ALL_STORE_TO_DOOR_DELIVERY_TIME_FAILED,
    })
  );
}

function* DeleteStoreToDoorDateTime({ model }) {
  yield sagaUtil.fetch(
    `storetodoor/LockDateAndTime/Delete/${model.Id}`,
    null,
    (r) => ({
      type: types.DELETE_STORE_TO_DOOR_DELIVERY_TIME_SUCCESS,
      data: r.data,
    }),
    (error) => ({
      type: types.DELETE_STORE_TO_DOOR_DELIVERY_TIME_FAILED,
      error: error.error,
    })
  );
}

function* UpdateStoreToDoorDateTime({ model }) {
  yield sagaUtil.fetch(
    `storetodoor/LockDateAndTime/Update`,
    model,
    (r) => ({
      type: types.UPDATE_STORE_TO_DOOR_DELIVERY_TIME_SUCCESS,
      data: r.data,
      success: r.success,
    }),
    (error) => ({
      type: types.UPDATE_STORE_TO_DOOR_DELIVERY_TIME_FAILED,
      error: error.error,
    })
  );
}

function* clearInventoryFlag({ branchId, productId }) {
  yield sagaUtil.fetch(
    `pos/clearInventoryFlag/${branchId}/${productId}`,
    null,
    (r) => ({
      type: types.GET_INVENTORY_FLAG_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.CLEAR_INVENTORY_FLAG_FAIL,
      error: r.error,
    })
  );
}

function* cancelOpenOrders(model) {
  yield sagaUtil.fetch(
    `orders/cancelOpenOrders`,
    model.model,
    () => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: 'Cancel Open Orders Success!',
    }),
    () => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: 'Cancel Open Orders Fail!',
    })
  );
}

// BRANCH
function* getBranches() {
  yield sagaUtil.fetch(`branches`, null, (r) => ({
    type: types.BRANCHES_GOT,
    data: r.data,
  }));
}

//CAMPAIGN
function* getCampaigns({ model }) {
  yield sagaUtil.fetch(
    `campaigns/${model.branchId}/${model.page}/${model.itemsPerPage}`,
    null,
    (r) => ({
      type: types.CAMPAIGN_GOT_ALL,
      data: r.data,
    }),
    (r) => ({
      type: types.CAMPAIGN_GOT_ALL_ERROR,
      error: r.error,
    })
  );
}

function* getCampaign(model) {
  yield sagaUtil.fetch(
    `campaigns/${model.branchId}/${model.campaignId}`,
    null,
    (r) => ({
      type: types.CAMPAIGN_GOT,
      data: r.data,
      compName: model.compName,
    }),
    (r) => ({
      type: types.CAMPAIGN_GOT_ERROR,
      error: r,
    })
  );
}

function* deleteCampaign({ id, branchId }) {
  yield sagaUtil.fetch(
    `campaigns/delete/${id}/${branchId}`,
    null,
    (r) => ({
      type: types.CAMPAIGN_GOT_ALL,
      data: r.data,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: 'Unable to delete campaign',
    })
  );
}

function* deleteInactiveCarousel({ model }) {
  yield sagaUtil.fetch(
    `${model.branchId}/product/group/deleteCarousel/${model.carouselId}/${model.page}/${model.itemsPerPage}`,
    null,
    (r) => ({
      type: types.GOT_PRODUCT_GROUP_LIST,
      data: r.data,
    }),
    (r) => ({
      type: types.DIALOG_ALERT_OPEN,
      message: r.error,
    })
  );
}

function* saveBulkCampaign(model) {
  const campaign = model.model;
  //EDIT
  if (campaign.Id) {
    yield sagaUtil.fetch(
      'campaigns/update',
      campaign,
      (r) => ({
        type: types.CAMPAIGN_SAVED,
        compName: model.compName,
        data: r.data,
      }),
      (r) => ({
        type: types.CAMPAIGN_SAVED_ERROR,
        compName: model.compName,
        error: r.error,
      })
    );
  }
  //CREATE
  else {
    yield sagaUtil.fetch(
      'campaigns/CreateRange',
      campaign,
      (r) => ({
        type: types.CAMPAIGN_SAVED,
        compName: model.compName,
        data: r.data,
      }),
      (r) => ({
        type: types.CAMPAIGN_SAVED_ERROR,
        compName: model.compName,
        error: r.error,
      })
    );
  }
}

//COMBO

function* getCombos({ model }) {
  yield posSagaUtil.fetch(
    `${model.branchId}/combo/getAll/${model.onlyActive}`,
    null,
    (r) => ({
      type: types.COMBO_GET_ALL_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.COMBO_GET_ALL_FAIL,
      error: r.error,
    })
  );
}

function* getCombo(model) {
  yield sagaUtil.fetch(
    `${model.branchId}/combo/getById/${model.comboId}`,
    null,
    (r) => ({
      type: types.COMBO_GET_SUCCESS,
      data: r.data,
      compName: model.compName,
    }),
    (r) => ({
      type: types.COMBO_GET_FAIL,
      error: r,
    })
  );
}

function* saveCombo(model) {
  const combo = model.model;
  if (combo.Id) {
    yield sagaUtil.fetch(
      `${combo.BranchId}/combo/update`,
      combo,
      (r) => ({
        type: types.COMBO_SAVE_SUCCESS,
        compName: model.compName,
        data: r.data,
      }),
      (r) => ({
        type: types.COMBO_SAVE_FAIL,
        compName: model.compName,
        error: r.error,
      })
    );
  } else {
    yield sagaUtil.fetch(
      `${combo.BranchId}/combo/create`,
      combo,
      (r) => ({
        type: types.COMBO_SAVE_SUCCESS,
        compName: model.compName,
        data: r.data,
      }),
      (r) => ({
        type: types.COMBO_SAVE_FAIL,
        compName: model.compName,
        error: r.error,
      })
    );
  }
}

function* checkComboProductQuantity(model) {
  yield sagaUtil.fetch(
    `${model.branchId}/combo/checkQuantity/${model.comboId}/${model.comboProductClicked}/${model.quantityAddedBack}`,
    null,
    (r) => ({
      type: types.CHECK_COMBO_PRODUCT_QUANTITY_SUCCESS,
      data: r.data,
      compName: model.compName,
    }),
    (r) => ({
      type: types.CHECK_COMBO_PRODUCT_QUANTITY_FAILURE,
      error: r.error,
    })
  );
}

function* deleteCombo({ branchId, id }) {
  yield sagaUtil.fetch(
    `${branchId}/combo/delete/${id}`,
    null,
    (r) => ({
      type: types.COMBO_GET_ALL_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.DIALOG_ALERT_OPEN,
      message: r.error,
    })
  );
}

//DISCOUNT

function* getCustomizedDiscounts({ model }) {
  yield posSagaUtil.fetch(
    `${model.branchId}/customizedDiscount/getAll`,
    null,
    (r) => ({
      type: types.DISCOUNT_GET_ALL_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.DISCOUNT_GET_ALL_FAIL,
      error: r.error,
    })
  );
}

function* getCustomizedDiscount(model) {
  yield sagaUtil.fetch(
    `${model.branchId}/customizedDiscount/getById/${model.discountId}`,
    null,
    (r) => ({
      type: types.DISCOUNT_GET_SUCCESS,
      data: r.data,
      compName: model.compName,
    }),
    (r) => ({
      type: types.DISCOUNT_GET_FAIL,
      error: r.error,
    })
  );
}

function* saveCustomizedDiscount(model) {
  const discount = model.model;
  if (discount.Id) {
    yield sagaUtil.fetch(
      `${discount.BranchId}/customizedDiscount/update`,
      discount,
      (r) => ({
        type: types.DISCOUNT_SAVE_SUCCESS,
        compName: model.compName,
        data: r.data,
      }),
      (r) => ({
        type: types.DISCOUNT_SAVE_FAIL,
        compName: model.compName,
        error: r.error,
      })
    );
  } else {
    yield sagaUtil.fetch(
      `${discount.BranchId}/customizedDiscount/create`,
      discount,
      (r) => ({
        type: types.DISCOUNT_SAVE_SUCCESS,
        compName: model.compName,
        data: r.data,
      }),
      (r) => ({
        type: types.DISCOUNT_SAVE_FAIL,
        compName: model.compName,
        error: r.error,
      })
    );
  }
}

function* deleteCustomizedDiscount({ branchId, discountId }) {
  yield sagaUtil.fetch(
    `${branchId}/customizedDiscount/delete/${discountId}`,
    null,
    (r) => ({
      type: types.DISCOUNT_GET_ALL_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.DIALOG_ALERT_OPEN,
      message: r.error,
    })
  );
}

// APPLICATION SETTING
function* getApplicationSetting(model) {
  yield posSagaUtil.fetch(
    `application/${model.branchId}`,
    null,
    (r) => ({
      type: types.APPLICATION_SETTING_GOT,
      data: r.data,
      compName: model.compName,
    }),
    (r) => ({
      type: types.GET_APPLICATION_SETTING_ERROR,
      error: r.error,
    })
  );
}

function* getApplicationSettingIntegraion(model) {
  yield sagaUtil.fetch(
    `application/${model.branchId}/integration`,
    null,
    (r) => ({
      type: types.APPLICATION_SETTING_INTEGRATION_GOT,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_APPLICATION_SETTING_ERROR,
      error: r.error,
    })
  );
}

function* updateApplicationSetting(model) {
  yield sagaUtil.fetch(
    `application`,
    model.model,
    (r) => ({
      type: types.APPLICATION_SETTING_SAVED,
      data: r.data,
      compName: model.compName,
    }),
    (r) => ({
      type: types.SAVE_APPLICATION_SETTING_ERROR,
      error: r.error,
      compName: model.compName,
    })
  );
}

// CLOCK IN CLOCK OUT
function* saveClockInClockOut(model) {
  yield sagaUtil.fetch(
    `timesheets/register/${model.employeeId}`,
    {
      imageBase64: model.imageBase64,
      isClockIn: model.isClockIn,
      branchId: model.branchId,
      pinNumber: model.pinNumber,
      employeeId: model.employeeId,
    },
    (r) => ({
      type: types.CLOCKIN_CLOCKOUT_SAVED,
      data: r.data,
      compName: model.compName,
    }),
    (r) => ({
      type: types.SAVE_CLOCKIN_CLOCKOUT_ERROR,
      error: r
        ? r.error
        : "An error occurred while registering employee's information. Please try again later. If the error persists, please contact the store administrator.",
      compName: model.compName,
      branchInfo: r.branchInfo,
    })
  );
}

function* getShiftsFilter({ model }) {
  yield sagaUtil.fetch(
    `timesheets/filter`,
    model,
    (r) => ({
      type: types.SHIFTS_GOT_FILTER,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_SHIFTS_ERROR,
      error: r
        ? r.error
        : 'An error occurred while retriving timesheets information. Please try again later. If the error persists, please contact the store administrator.',
    })
  );
}

function* getEmmployeeShift({ model }) {
  yield sagaUtil.fetch(
    `timesheets/${model.employeeId}/${model.date}`,
    null,
    (r) => ({
      type: types.EMPLOYEE_SHIFT_GOT,
      data: r.data,
      compName: model.compName,
    }),
    (r) => ({
      type: types.GET_EMPLOYEE_SHIFT_ERROR,
      error: r
        ? r.error
        : 'An error occurred while retrieving timesheets information, please try again later. If the error persists, please contact the store administrator.',
      compName: model.compName,
    })
  );
}
function* getEmployeeShiftByStatus({ model }) {
  yield sagaUtil.fetch(
    `timesheets/${model.employeeId}/${model.date}/${model.status}`,
    null,
    (r) => ({
      type: types.EMPLOYEE_SHIFT_GOT,
      data: r.data,
      compName: model.compName,
    }),
    (r) => ({
      type: types.GET_EMPLOYEE_SHIFT_ERROR,
      error: r
        ? r.error
        : 'An error occurred while retrieving timesheets information, please try again later. If the error persists, please contact the store administrator.',
      compName: model.compName,
    })
  );
}

function* saveEmployeeShift(model) {
  yield sagaUtil.fetch(
    `timesheets/update`,
    model.model,
    (r) => ({
      type: types.EMPLOYEE_SHIFT_SAVED,
      data: r.data,
      compName: model.compName,
    }),
    (r) => ({
      type: types.SAVE_EMPLOYEE_SHIFT_ERROR,
      error: r
        ? r.error
        : 'An error occurred while saving timesheets information, please try again later. If the error persists, please contact the store administrator.',
      compName: model.compName,
    })
  );
}

function* saveShift(model) {
  yield sagaUtil.fetch(
    `timesheets/create`,
    model.model,
    (r) => ({
      type: types.SHIFT_SAVED,
      data: r.data,
      compName: model.compName,
    }),
    (r) => ({
      type: types.SAVE_SHIFT_ERROR,
      error: r
        ? r.error
        : 'An error occurred while creating timesheet information, please try again later. If the error persists, please contact the store administrator.',
      compName: model.compName,
    })
  );
}

// ORDERS
function* getOrderDetail(order) {
  yield sagaUtil.fetch(
    `orders/${order.orderId}`,
    null,
    (r) => ({
      type: types.ORDER_DETAIL_GOT,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_ORDER_DETAIL_ERROR,
      error: r
        ? r.error
        : `An error occurred while trying to retrive order ${order.orderId}, please try again later. If the error persists, please contact the store administrator.`,
    })
  );
}

function* getPatientOrders({ model }) {
  yield sagaUtil.fetch(
    `orders/getWithFilters`,
    model,
    (r) => ({
      type: types.ORDERS_PATIENT_GOT,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_ORDERS_PATIENT_ERROR,
      error: r
        ? r.error
        : `An error occurred while trying to retrive patient order, please try again later. If the error persists, please contact the store administrator.c`,
    })
  );
}

function* getOrderPatientReward(model) {
  yield sagaUtil.fetch(
    `orders/${model.orderId}/rewardPoints`,
    null,
    (r) => ({
      type: types.GET_ORDER_PATIENT_REWARD_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: `An error occurred while retrieving reward points.`,
    })
  );
}

//REPORTSs
function* getBudtenderAvgSales({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/budtenderaveragesales?beginDate=${model.beginDate}&endDate=${model.endDate}&branchIds=${model.branchIds}&pageNumber=${model.pageNumber}&itemsPerPage=${model.itemsPerPage}&employeeId=${model.employeeId}`,
    null,
    (r) => ({
      type: types.GOT_TRANSACTION_SUMMARY_BY_BUDTENDER,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_TRANSACTION_SUMMARY_BY_BUDTENDER_ERROR,
      error: r ? r.error : 'Could not retrive ButenderAvgSales Report',
    })
  );
}

function* getAnnualSales({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/annualsales?year=${model.year}&branch=${model.branch}`,
    null,
    (r) => ({
      type: types.GOT_ANNUAL_SALES,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_ANNUAL_SALES_ERROR,
      error: r ? r.error : 'Could not retrive Annual Sales Report',
    })
  );
}

function* getEmployeeActivity({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/employeeactivity?beginDate=${model.beginDate}&endDate=${model.endDate}&productid=${model.productid}&status=${model.status}&branch=${model.branch}&payment=${model.payment}&pageNumber=${model.pageNumber}&pageSize=${model.pageSize}&orderType=${model.orderType}&approvalStatus=${model.approvalType}`,
    null,
    (r) => ({
      type: types.GOT_EMPLOYEE_ACTIVITY,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_EMPLOYEE_ACTVITY_ERROR,
      error: r ? r.error : 'Could not retrive Employee Activity Report',
    })
  );
}

function* getProductSales({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/productsales?beginDate=${model.beginDate}&endDate=${model.endDate}&productid=${model.productid}&category=${model.category}&type=${model.type}&weightFilter=${model.weightFilter}&employeeId=${model.employee}&branchIds=${model.branchIds}&pageNumber=${model.pageNumber}&pageSize=${model.pageSize}&isCannabis=${model.isCannabis}&brandName=${model.brandName}`,
    null,
    (r) => ({
      type: types.GOT_PRODUCT_SALES,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_PRODUCT_SALES_ERROR,
      error: r ? r.error : 'Could not retrive Product Sales Report',
    })
  );
}

function* getProductRanking({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/productRaking?beginDate=${model.beginDate}&endDate=${model.endDate}&baseStore=${model.baseStore}&category=${model.category}&compareTo=${model.compareTo}&pageNumber=${model.pageNumber}`,
    null,
    (r) => ({
      type: types.GOT_PRODUCT_RANKING,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_PRODUCT_RANKING_ERROR,
      error: r ? r.error : 'Could not retrive Product Sales Report',
    })
  );
}

//Monthly Product Sales
function* getMonthlyProductSales({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/monthlyproductsales?year=${model.year}&pageNumber=${model.pageNumber}&pageSize=${model.pageSize}&branch=${model.branch}`,
    null,
    (r) => ({
      type: types.GOT_MONTHLY_PRODUCT_SALES,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_MONTHLY_PRODUCT_SALES_ERROR,
      error: r ? r.error : 'Could not retrive Montlhy Product Sales Report',
    })
  );
}

//Employee Timesheet
function* getEmployeeTimesheet({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/shiftbyemployeedetails`,
    model,
    (r) => ({
      type: types.GOT_EMPLOYEE_TIMESHEET,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_EMPLOYEE_TIMESHEET_ERROR,
      error: r ? r.error : 'Could not retrive Timesheets Report',
    })
  );
}

//Employee Hours
function* getEmployeeHours({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/shiftbyemployeesummaries`,
    model,
    (r) => ({
      type: types.GOT_EMPLOYEE_HOURS,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_EMPLOYEE_HOURS_ERROR,
      error: r ? r.error : 'Could not retrive Employee Hours Report',
    })
  );
}

function* getDailyCashSummary({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/dailycashsummary?beginDate=${model.beginDate}&endDate=${model.endDate}&pageNumber=${model.pageNumber}&pageSize=${model.pageSize}&branches=${model.branches}`,
    null,
    (r) => ({
      type: types.GOT_DAILY_CASH_SUMMARY,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_DAILY_CASH_SUMMARY_ERROR,
      error: r ? r.error : 'Could not retrive Daily Cash Summary Report',
    })
  );
}

function* getAggregateSales({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/aggregatesales?startdate=${model.beginDate}&endDate=${model.endDate}&groupby=${model.group}`,
    null,
    (r) => ({
      type: types.GOT_AGGREGATE_SALES,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_AGGREGATE_SALES_ERROR,
      error: r ? r.error : 'Could not retrive Daily Cash Summary Report',
    })
  );
}

function* getAggregateInventory({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/aggregatedInventory?selecteddate=${model.beginDate}`,
    null,
    (r) => ({
      type: types.GOT_AGGREGATE_INVENTORY,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_AGGREGATE_INVENTORY_ERROR,
      error: r ? r.error : 'Could not retrive Daily Cash Summary Report',
    })
  );
}

function* getInventoryLevel({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/inventorylevel?branch=${model.branch}&startDate=${model.startDate}&endDate=${model.endDate}&category=${model.category}&productId=${model.productId}&pageNumber=${model.pageNumber}&pageSize=${model.pageSize}`,
    null,
    (r) => ({
      type: types.GOT_INVENTORY_LEVEL,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_INVENTORY_LEVEL_ERROR,
      error: r ? r.error : 'Could not retrive Inventory Level Report',
    })
  );
}

function* getDemographicReport({ branch }) {
  yield reportsSagaUtil.fetch(
    `reports/demographic?branch=${branch}`,
    null,
    (r) => ({
      type: types.GOT_DEMOGRAPHIC_REPORT,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_INVENTORY_LEVEL_ERROR,
      error: r ? r.error : 'Could not retrive Inventory Level Report',
    })
  );
}

function* getRestockByCaps({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/restock?beginDate=${model.beginDate}&endDate=${model.endDate}&branch=${model.branch}&pageNumber=${model.pageNumber}&pageSize=${model.pageSize}&category=${model.category}&isCannabis=${model.isCannabis}`,
    null,
    (r) => ({
      type: types.GET_RESTOCK_BY_CAPS_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_RESTOCK_BY_CAPS_FAIL,
      error: r ? r.error : 'Could not retrive Restock By Caps Report',
    })
  );
}

function* getInventoryAge({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/inventoryAge?branch=${model.branch}&productName=${model.productName}&categoryName=${model.categoryName}&brandName=${model.brandName}&pageNumber=${model.pageNumber}&pageSize=${model.pageSize}&isCannabis=${model.isCannabis}&category=${model.category}`,
    null,
    (r) => ({
      type: types.GET_INVENTORY_AGE_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_INVENTORY_AGE_FAIL,
      error: r ? r.error : 'Could not retrive Inventory Age Report',
    })
  );
}

function* getPriceTracker({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/pricetracker?branch=${model.branch}&startDate=${model.startDate}&endDate=${model.endDate}&productId=${model.productId}&pageNumber=${model.pageNumber}&pageSize=${model.pageSize}`,
    null,
    (r) => ({
      type: types.GOT_PRICE_TRACKER,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_PRICE_TRACKER_ERROR,
      error: r ? r.error : 'Could not retrieve Price Tracking Information',
    })
  );
}

function* getTHCCBDTracker({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/thccbdtracker?branch=${model.branch}&startDate=${model.startDate}&endDate=${model.endDate}&productId=${model.productId}&pageNumber=${model.pageNumber}&pageSize=${model.pageSize}`,
    null,
    (r) => ({
      type: types.GOT_THCCBD_TRACKER,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_THCCBD_TRACKER_ERROR,
      error: r ? r.error : 'Could not retrieve THC Tracking Information',
    })
  );
}

function* getCustomerSales({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/patientorder?branch=${model.branch}&beginDate=${model.beginDate}&endDate=${model.endDate}&pageNumber=${model.pageNumber}&pageSize=${model.pageSize}&branchIds=${model.branchIds}&membershipType=${model.membershipType}&identificationType=${model.identificationType}&identificationNumber=${model.identificationNumber}`,
    null,
    (r) => ({
      type: types.GOT_CUSTOMER_SALES,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_CUSTOMER_SALES_ERROR,
      error: r ? r.error : 'Could not retrive Inventory Level Report',
    })
  );
}

function* getDailySalesReport({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/salesreport?branch=${model.branch}&beginDate=${model.beginDate}&endDate=${model.endDate}&pageNumber=${model.pageNumber}&pageSize=${model.pageSize}&timemodel=1`,
    null,
    (r) => ({
      type: types.GOT_SALES_DAILY_REPORT,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_SALES_DAILY_REPORT,
      error: r ? r.error : 'Could not retrive Inventory Level Report',
    })
  );
}

function* getMonthlySalesReport({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/salesreport?branch=${model.branch}&beginDate=${model.beginDate}&endDate=${model.endDate}&pageNumber=${model.pageNumber}&pageSize=${model.pageSize}&timemodel=2`,
    null,
    (r) => ({
      type: types.GOT_SALES_MONTHLY_REPORT,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_SALES_MONTHLY_REPORT_ERROR,
      error: r ? r.error : 'Could not retrive Inventory Level Report',
    })
  );
}
function* getPurchaseOrderReceiver({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/PurchaseOrderReceiver?branchId=${model.branch}&beginDate=${model.beginDate}&endDate=${model.endDate}&SKU=${model.SKU}&POID=${model.POID}&recordTypeSelect=${model.recordTypeSelect}&vendor=${model.vendor}&pageNumber=${model.pageNumber}&pageSize=${model.pageSize}`,
    null,
    (r) => ({
      type: types.GOT_PURCHASE_RECEIVER,
      data: r.data,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: 'Could not retrive Purchase Order Report',
    })
  );
}
function* getDailyProfitReport({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/filterprofitreport?branch=${model.branch}&beginDate=${model.beginDate}&endDate=${model.endDate}&pageNumber=${model.pageNumber}&pageSize=${model.pageSize}&timemodel=1`,
    null,
    (r) => ({
      type: types.GOT_PROFIT_DAILY_REPORT,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_SALES_DAILY_REPORT,
      error: r ? r.error : 'Could not retrive Inventory Level Report',
    })
  );
}

function* getMonthlyProfitReport({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/filterprofitreport?branch=${model.branch}&beginDate=${model.beginDate}&endDate=${model.endDate}&pageNumber=${model.pageNumber}&pageSize=${model.pageSize}&timemodel=2`,
    null,
    (r) => ({
      type: types.GOT_PROFIT_MONTHLY_REPORT,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_PROFIT_MONTHLY_REPORT_ERROR,
      error: r ? r.error : 'Could not retrive Inventory Level Report',
    })
  );
}

function* getYearlySalesReport({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/yearlysales?branch=${model.branch}&year=${model.year}`,
    null,
    (r) => ({
      type: types.GOT_SALES_YEARLY_REPORT,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_SALES_YEARLY_REPORT_ERROR,
      error: r ? r.error : 'Could not retrive Inventory Level Report',
    })
  );
}

function* getYearlyProfitReport({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/YearlyProfit?branch=${model.branch}&year=${model.year}`,
    null,
    (r) => ({
      type: types.GOT_PROFIT_YEARLY_REPORT,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_PROFIT_YEARLY_REPORT_ERROR,
      error: r ? r.error : 'Could not retrive Inventory Level Report',
    })
  );
}

function* getCategorySales({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/categorysales?beginDate=${model.beginDate}&EndDate=${model.endDate}&branchIds=${model.branchIds}&isCannabis=${model.isCannabis}&categoryId=${model.categoryId}&dateGroupBy=${model.dateGroupBy}&includeCategoryData=${model.includeCategoryData}&includeProductData=${model.includeProductData}`,
    null,
    (r) => ({
      type: types.GOT_CATEGORY_SALES,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_CATEGORY_SALES_ERROR,
      error: r ? r.error : 'Could not retrive Inventory Level Report',
    })
  );
}

function* getBudgetPlanner({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/budgetplanner?branchid=${model.branch}&budget=${model.budget}`,
    null,
    (r) => ({
      type: types.GOT_BUDGET_PLANNER_REPORT,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_BUDGET_PLANNER_REPORT_ERROR,
      error: r ? r.error : 'Could not retrive Inventory Level Report',
    })
  );
}

function* getInventorySnapShot({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/inventorySnapShot?branchIds=${model.branch}&selectedDate=${model.selectedDate}&productId=${model.productId}&species=${model.species}&category=${model.category}&weightoption=${model.weight}&iscannabis=${model.iscannabis}&showZeroQuantity=${model.showZeroQuantity}&range=${model.range}&selectedWarehouseType=${model.selectedWarehouseType}&pageNumber=${model.pageNumber}&pageSize=${model.pageSize}`,
    null,
    (r) => ({
      type: types.GOT_INVENTORY_SNAP_SHOT,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_INVENTORY_SNAP_SHOT_ERROR,
      error: r ? r.error : 'Could not retrive Inventory SnapShot Report',
    })
  );
}

function* getMonthlyInventory({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/monthlyinventory?branch=${model.branch}&year=${model.selectedYear}&month=${model.selectedMonth}&subcategoryId=${model.category}&iscannabis=${model.iscannabis}`,
    null,
    (r) => ({
      type: types.GOT_MONTHLY_INVENTORY,
      data: r.data,
    }),
    (r) => ({
      type: types.GOT_MONTHLY_INVENTORY_ERROR,
      error: r ? r.error : 'Could not retrive Monthly Inventory Report',
    })
  );
}

function* getInventorySnapShotProductView({ model }) {
  yield dashboardApi.fetch(
    `reports/inventorySnapShot?branchIds=${model.branch}&selectedDate=${model.selectedDate}&productId=${model.productId}&species=${model.species}&category=${model.category}&weightoption=${model.weight}&iscannabis=${model.iscannabis}&showZeroQuantity=${model.showZeroQuantity}&range=${model.range}&pageNumber=${model.pageNumber}&pageSize=${model.pageSize}`,
    'INVENTORYSNAPSHOT',
    (r) => ({
      type: types.GOT_INVENTORY_SNAP_SHOT_PRODUCT_VIEW,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_INVENTORY_SNAP_SHOT_PRODUCT_VIEW_ERROR,
      error: r ? r.error : 'Could not retrive Inventory SnapShot Report',
    })
  );
}

function* getAggregateInventoryLevel({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/aggregateInventoryLevel?productId=${model.productId}&pageNumber=${model.pageNumber}&pageSize=${model.pageSize}`,
    null,
    (r) => ({
      type: types.GET_AGGREGATE_INVENTORY_LEVEL_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_AGGREGATE_INVENTORY_LEVEL_FAIL,
      error: r ? r.error : 'Could not retrive Inventory Level Report',
    })
  );
}

function* getReorderReport({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/reorder?branch=${model.branch}&selectedDate=${model.selectedDate}&selectedcategory=${model.selectedcategory}&method=${model.method}&numOfWeeks=${model.numOfWeeks}&poFrequency=${model.poFrequency}&category=${model.category}&productId=${model.productId}&weightoption=${model.weight}&species=${model.species}&pageNumber=${model.pageNumber}&pageSize=${model.pageSize}&hideZero=${model.hideZero}`,
    null,
    (r) => ({
      type: types.GOT_REORDER_REPORT,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_REORDER_REPORT_ERROR,
      error: r ? r.error : 'Could not retrive Inventory SnapShot Report',
    })
  );
}

function* getEndOfDayReport({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/endOfDayReport?branchid=${model.branch}&beginDate=${model.beginDate}&endDate=${model.endDate}`,
    null,
    (r) => ({
      type: types.GOT_END_OF_DAY_REPORT,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_END_OF_DAY_REPORT_ERROR,
      error: r ? r.error : 'Could not retrive Inventory SnapShot Report',
    })
  );
}

function* getProductVelocity({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/productvelocity?branch=${model.branch}&startdate=${model.startDate}&endDate=${model.endDate}&productId=${model.productId}`,
    null,
    (r) => ({
      type: types.GOT_PRODUCT_VELOCITY,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_PRODUCT_VELOCITY_ERROR,
      error: r ? r.error : 'Could not retrive Inventory SnapShot Report',
    })
  );
}

function* getShoppingTrend({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/shoppingtrend?branch=${model.branch}&year=${model.year}`,
    null,
    (r) => ({
      type: types.GOT_SHOPPING_TREND,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_SHOPPING_TREND_ERROR,
      error: r ? r.error : 'Could not retrive Inventory SnapShot Report',
    })
  );
}

function* getHourlySales({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/hourlysales?branchid=${model.branch}&selectedDate=${model.selectedDate}`,
    null,
    (r) => ({
      type: types.GOT_HOURLY_SALES,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_HOURLY_SALES_ERROR,
      error: r ? r.error : 'Could not retrive Hourly Report',
    })
  );
}

function* getHourlySalesSecondary({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/hourlysalessecondary?branchid=${model.branch}&startDate=${model.startDate}&endDate=${model.endDate}`,
    null,
    (r) => ({
      type: types.GOT_HOURLY_SALES_SECONDARY,
      data: r.data,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: r ? r.error : 'Could not retrieve Hourly Report',
    })
  );
}

function* getHourlySalesDateRange({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/hourlysalesdaterange?branchid=${model.branch}&startDate=${model.startDate}&endDate=${model.endDate}&pageNumber=${model.pageNumber}&pageSize=${model.pageSize}`,
    null,
    (r) => ({
      type: types.GOT_HOURLY_SALES_DATE_RANGE,
      data: r.data,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: 'Unable to retrieve Hourly Sales',
    })
  );
}

function* getTaxSummary({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/taxsummary?beginDate=${model.beginDate}&endDate=${model.endDate}&pageNumber=${model.pageNumber}&pageSize=${model.pageSize}&branch=${model.branch}`,
    null,
    (r) => ({
      type: types.GOT_TAX_SUMMARY,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_TAX_SUMMARY_ERROR,
      error: r ? r.error : 'Could not retrive Tax Summary Report',
    })
  );
}

function* getSellThroughReport({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/sellthrough?beginDate=${model.beginDate}&endDate=${model.endDate}&pageNumber=${model.pageNumber}&pageSize=${model.pageSize}&branch=${model.branch}`,
    null,
    (r) => ({
      type: types.GOT_SELL_THROUGH_REPORT,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_SELL_THROUGH_REPORT_ERROR,
      error: r ? r.error : 'Could not retrive Tax Summary Report',
    })
  );
}

function* getGmroiReport({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/gmroiReport?selecteddate=${model.selectedDate}&branch=${model.branch}`,
    null,
    (r) => ({
      type: types.GOT_GMROI_REPORT,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_GMROI_REPORT_ERROR,
      error: r ? r.error : 'Could not retrive Tax Summary Report',
    })
  );
}

function* getSalesSummary({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/salesummary?branch=${model.branch}&selecteddate=${model.selectedDate}`,
    null,
    (r) => ({
      type: types.GOT_SALES_SUMMARY,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_SALES_SUMMARY_ERROR,
      error: r ? r.error : 'Could not retrive Sales Summary Report',
    })
  );
}

function* getCreditPayments({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/creditpayments?beginDate=${model.beginDate}&endDate=${model.endDate}&pageNumber=${model.pageNumber}&pageSize=${model.pageSize}&branch=${model.branch}&dateGroupBy=${model.dateGroupBy}`,
    null,
    (r) => ({
      type: types.GOT_CREDIT_PAYMENTS,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_CREDIT_PAYMENTS_ERROR,
      error: r ? r.error : 'Could not retrive Payment Report',
    })
  );
}

function* getGiftCardBalance({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/GiftCardBalance?endDate=${model.endDate}&pageNumber=${model.pageNumber}&pageSize=${model.pageSize}&branchIds=${model.branchIds}`,
    null,
    (r) => ({
      type: types.GOT_GIFT_CARD_BALANCE,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_GIFT_CARD_BALANCE_ERROR,
      error: r ? r.error : 'Could not retrive Gift Card Balance Report',
    })
  );
}

function* getTransactionSaleSummary({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/transactionsummary?beginDate=${model.beginDate}&endDate=${model.endDate}&pageNumber=${model.pageNumber}&pageSize=${model.pageSize}&branch=${model.branch}`,
    null,
    (r) => ({
      type: types.GOT_TRANSACTION_SALES_SUMMARY,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_TRANSACTION_SALES_SUMMARY_ERROR,
      error: r ? r.error : 'Could not retrive Transactions Summary Report',
    })
  );
}

function* getDestroyedProductReport({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/damagedreport?beginDate=${model.beginDate}&endDate=${model.endDate}&pageNumber=${model.pageNumber}&pageSize=${model.pageSize}&branch=${model.branch}`,
    null,
    (r) => ({
      type: types.GOT_DESTROYED_PRODUCT_REPORT,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_DESTROYED_PRODUCT_REPORT_ERROR,
      error: r ? r.error : 'Could not retrive Destroyed Product Report',
    })
  );
}

function* getDiscrepancyReport({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/agcoinventoryreport?beginDate=${model.beginDate}&pageNumber=${model.pageNumber}&pageSize=${model.pageSize}&branch=${model.branch}`,
    null,
    (r) => ({
      type: types.GOT_DISCREPANCY_REPORT,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_DISCREPANCY_REPORT_ERROR,
      error: r ? r.error : 'Could not retrive Destroyed Product Report',
    })
  );
}

function* getSalesByType({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/salesbytype?beginDate=${model.beginDate}&endDate=${model.endDate}&pageNumber=${model.pageNumber}&pageSize=${model.pageSize}&branch=${model.branch}`,
    null,
    (r) => ({
      type: types.GOT_SALES_BY_TYPE,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_SALES_BY_TYPE_ERROR,
      error: r ? r.error : 'Could not retrive Sales By Type Report',
    })
  );
}

function* getProfitReport({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/profitreport?beginDate=${model.beginDate}&endDate=${model.endDate}&pageNumber=${model.pageNumber}&pageSize=${model.pageSize}&branch=${model.branch}`,
    null,
    (r) => ({
      type: types.GOT_PROFIT_REPORT,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_PROFIT_REPORT_ERROR,
      error: r ? r.error : 'Could not retrive Profit Report',
    })
  );
}

function* getProductPriceChangeReport({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/productpricechangereport?beginDate=${model.beginDate}&endDate=${model.endDate}&pageNumber=${model.pageNumber}&pageSize=${model.pageSize}&sku=${model.sku}&branch=${model.branch}`,
    null,
    (r) => ({
      type: types.GOT_PRODUCT_PRICE_CHANGE_REPORT,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_PRODUCT_PRICE_CHANGE_REPORT_ERROR,
      error: r ? r.error : 'Could not retrive Product Price Change Report',
    })
  );
}

function* getCombinedSalesReport({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/combinedsales?beginDate=${model.beginDate}&endDate=${model.endDate}&branchId=${model.branch}&groupby=${model.groupby}&type=${model.type}&onlineType=${model.onlineType}&pageNumber=${model.pageNumber}&pageSize=${model.pageSize}`,
    null,
    (r) => ({
      type: types.GOT_COMBINED_SALES_REPORT,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_COMBINED_SALES_REPORT_ERROR,
      error: r ? r.error : 'Could not retrive Profit Report',
    })
  );
}

function* getAggregateBranchesReport({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/aggregatebranches?beginDate=${model.beginDate}&endDate=${model.endDate}&pageNumber=${model.pageNumber}&pageSize=${model.pageSize}`,
    null,
    (r) => ({
      type: types.GOT_AGGREGATE_BRANCHES_REPORT,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_AGGREGATE_BRANCHES_REPORT_ERROR,
      error: r ? r.error : 'Could not retrive Profit Report',
    })
  );
}

function* getDiscountReport({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/discountreport?beginDate=${model.beginDate}&endDate=${model.endDate}&employeeFirstName=${model.employeeFirstName}&employeeLastName=${model.employeeLastName}&pageNumber=${model.pageNumber}&manualPageNumber=${model.manualPageNumber}&customizedPageNumber=${model.customizedPageNumber}&campaignPageNumber=${model.campaignPageNumber}&loyaltyPageNumber=${model.loyaltyPageNumber}&pageSize=${model.pageSize}&branch=${model.branch}&orderType=${model.orderType}`,
    null,
    (r) => ({
      type: types.GOT_DISCOUNT_REPORT,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_DISCOUNT_REPORT_ERROR,
      error: r ? r.error : 'Could not retrive Profit Report',
    })
  );
}

function* getPurchaseOrderReport({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/purchaseorderreport?beginDate=${model.beginDate}&endDate=${model.endDate}&pageNumber=${model.pageNumber}&pageSize=${model.pageSize}&branch=${model.branch}`,
    null,
    (r) => ({
      type: types.GOT_PURCHASE_ORDER_REPORT,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_PURCHASE_ORDER_REPORT_ERROR,
      error: r ? r.error : 'Could not retrive Profit Report',
    })
  );
}

//GET ALL ONLINE CAMPAIGN
function* getAllOnlineCampaigns({ model }) {
  yield sagaUtil.fetch(
    `campaigns/getAllOnline/${model.branchId}`,
    null,
    (r) => ({
      type: types.CAMPAIGN_GOT_ALL,
      data: r.data,
    }),
    (r) => ({
      type: types.CAMPAIGN_GOT_ALL_ERROR,
      error: r.error,
    })
  );
}

function* getWarehouseTransferReport({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/warehouseexchange?beginDate=${model.beginDate}&endDate=${model.endDate}&pageNumber=${model.pageNumber}&pageSize=${model.pageSize}&fromBranchId=${model.fromBranch}&toBranchId=${model.toBranch}&transfer=${model.transfer}&warehouse=${model.warehouse}&reportaction=${model.action}&selectCannabis=${model.selectCannabis}`,
    null,
    (r) => ({
      type: types.GOT_WAREHOUSE_TRANSFER_REPORT,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_WAREHOUSE_TRANSFER_REPORT_ERROR,
      error: r ? r.error : 'Could not retrive Warehouse Transfer Report',
    })
  );
}

function* getGeneralReport({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/generalreport?beginDate=${model.beginDate}&endDate=${model.endDate}&branch=${model.branch}`,
    null,
    (r) => ({
      type: types.GOT_GENERAL_REPORT,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_GENERAL_REPORT_ERROR,
      error: r ? r.error : 'Could not retrive Profit Report',
    })
  );
}

function* getManualInvetoryChange({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/manualinventorychange?beginDate=${model.beginDate}&endDate=${model.endDate}&pageNumber=${model.pageNumber}&pageSize=${model.pageSize}&filterAction=${model.filterAction}&filterReason=${model.filterReason}&category=${model.category}&branch=${model.branch}&isCannabis=${model.isCannabis}`,
    null,
    (r) => ({
      type: types.GOT_MANUAL_INVENTORY_CHANGE,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_MANUAL_INVENTORY_CHANGE_ERROR,
      error: r ? r.error : 'Could not retrive Profit Report',
    })
  );
}

function* getRevenueReport({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/revenuereport?beginDate=${model.beginDate}&endDate=${model.endDate}&pageNumber=${model.pageNumber}&pageSize=${model.pageSize}&branch=${model.branch}&category=${model.category}&isCannabis=${model.isCannabis}`,
    null,
    (r) => ({
      type: types.GOT_REVENUE_REPORT,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_REVENUE_REPORT_ERROR,
      error: r ? r.error : 'Could not retrive Revenue Report',
    })
  );
}

function* getBrandSales({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/brandsales?beginDate=${model.beginDate}&endDate=${model.endDate}&branch=${model.branch}&pageNumber=${model.pageNumber}&pageSize=${model.pageSize}`,
    null,
    (r) => ({
      type: types.GOT_BRAND_SALES,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_BRAND_SALES_ERROR,
      error: r ? r.error : 'Could not retrieve Brand Sales',
    })
  );
}

function* getInstoreOnlineSales({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/instoreonlinesales?beginDate=${model.beginDate}&endDate=${model.endDate}&branch=${model.branch}&pageNumber=${model.pageNumber}&pageSize=${model.pageSize}&productId=${model.productId}`,
    null,
    (r) => ({
      type: types.GOT_INSTORE_ONLINE_SALES,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_INSTORE_ONLINE_SALES_ERROR,
      error: r ? r.error : 'Could not retrieve data for In-store/Online Sales',
    })
  );
}

function* getOrderList({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/orderlist?beginDate=${model.beginDate}&endDate=${model.endDate}&branchIds=${model.branchIds}&pageNumber=${model.pageNumber}&pageSize=${model.pageSize}&orderType=${model.orderType}&orderPlatform=${model.orderPlatform}&paymentDelivery=${model.paymentDelivery}`,
    null,
    (r) => ({
      type: types.GOT_ORDER_LIST_SALES,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_ORDER_LIST_SALES_ERROR,
      error: r ? r.error : 'Could not retrieve Sales',
    })
  );
}

function* getCategoryProducts({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/categoryproducts?branch=${model.branch}&date=${model.date}&pageNumber=${model.pageNumber}&pageSize=${model.pageSize}&isCannabis=${model.isCannabis}&selectedCategory=${model.selectedCategory}&comparisonDate=${model.comparisonDate}`,
    null,
    (r) => ({
      type: types.GOT_CATEGORY_PRODUCTS,
      data: r.data,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: 'Could not retrieve Category Products Report',
    })
  );
}

function* getDeliveryReport({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/delivery?branch=${model.branch}&date=${model.selectedDate}&pageNumber=${model.pageNumber}&pageSize=${model.pageSize}`,
    null,
    (r) => ({
      type: types.GOT_DELIVERY_REPORT,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_DELIVERY_REPORT_ERROR,
      error: r ? r.error : 'Could not retrive Delivery Report',
    })
  );
}

function* getGiftCardReport({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/giftcardhistory?branch=${model.branch}&beginDate=${model.beginDate}&endDate=${model.endDate}&pageNumber=${model.pageNumber}&pageSize=${model.pageSize}`,
    null,
    (r) => ({
      type: types.GOT_GIFT_CARD_REPORT,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_GIFT_CARD_REPORT_ERROR,
      message: 'Could not retrieve Gift Card History',
    })
  );
}

// Added for Shift by Employee Report (by Kate 2018-04-03 2:58PM)
function* getShiftByEmployee({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/shiftbyemployee?pageNumber=${model.pageNumber}&pageSize=${model.pageSize}&employeeId=${model.employeeId}&beginDate=${model.beginDate}&endDate=${model.endDate}&branchId=${model.branchId}`,
    null,
    (r) => ({
      type: types.GOT_SHIFT_BY_EMPLOYEE,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_SHIFT_BY_EMPLOYEE_ERROR,
      error: r ? r.error : 'Could not retrive Shift by Employee Report',
    })
  );
}

// Added for Shift by Day Report (by Kate 2018-04-02 1:44PM)
function* getShiftByDay({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/shiftbyday?pageNumber=${model.pageNumber}&pageSize=${model.pageSize}&employeeId=${model.employeeId}&beginDate=${model.beginDate}&endDate=${model.endDate}$branchId=${model.branchId}`,
    null,
    (r) => ({
      type: types.GOT_SHIFT_BY_DAY,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_SHIFT_BY_DAY_ERROR,
      error: r ? r.error : 'Could not retireve Shift by Date Report',
    })
  );
}

function* getInventoryMovementReport({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/inventoryMovement?branchId=${model.branchId}&startDate=${model.startDate}&endDate=${model.endDate}&pageNumber=${model.pageNumber}&pageSize=${model.pageSize}&productId=${model.productId}`,
    null,
    (r) => ({
      type: types.GET_INVENTORY_MOVEMENT_REPORT_SUCCESS,
      data: r.data,
      inventoryMovementProductInfo: r.inventoryMovementProductInfo,
    }),
    (r) => ({
      type: types.GET_INVENTORY_MOVEMENT_REPORT_ERROR,
      error: r ? r.error : 'Could not retireve inventory movenment report',
    })
  );
}

function* getInventoryLogReport({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/inventoryLog?branchId=${model.branchId}&beginDate=${model.beginDate}&endDate=${model.endDate}&pageNumber=${model.pageNumber}&pageSize=${model.pageSize}&productId=${model.productId}&isCannabis=${model.isCannabis}&categoryId=${model.categoryId}`,
    null,
    (r) => ({
      type: types.GET_INVENTORY_LOG_REPORT_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_INVENTORY_LOG_REPORT_ERROR,
      error: r ? r.error : 'Could not retireve inventory log report',
    })
  );
}

function* getSalesSummaryWithDetails({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/salesSummaryWithDetails?beginDate=${model.beginDate}&endDate=${model.endDate}&branchIds=${model.branchIds}&isCannabis=${model.isCannabis}&categoryId=${model.categoryId}&orderType=${model.orderType}&onlineOrderType=${model.onlineOrderType}&dateGroupBy=${model.dateGroupBy}&pageNumber=${model.pageNumber}&pageSize=${model.pageSize}`,
    null,
    (r) => ({
      type: types.GET_SALES_SUMMARY_WITH_DETAILS_SUCCESS,
      data: r.data,
      categoryFiltersSelected: r.categoryFiltersSelected,
      orderTypeFiltersSelected: r.orderTypeFiltersSelected,
    }),
    (r) => ({
      type: types.GET_SALES_SUMMARY_WITH_DETAILS_ERROR,
      error: r ? r.error : 'Could not retireve Sales Summary report',
    })
  );
}

function* GetAggregateBranchSalesInventory({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/aggregateBranchSalesInventory?beginDate=${model.beginDate}&endDate=${model.endDate}&branchIds=${model.branchIds}&dateGroupBy=${model.dateGroupBy}&selectedDateRangeType=${model.selectedDateRangeType}&includeInventoryValue=${model.includeInventoryValue}&pageNumber=${model.pageNumber}&pageSize=${model.pageSize}`,
    null,
    (r) => ({
      type: types.GET_AGGREGATE_BRANCH_SALES_INVENTORY_SUCCESS,
      data: r.data,
      prevPeriodData: r.prevPeriodData,
      selectedDateRangeType: r.selectedDateRangeType,
      includeInventoryValue: r.includeInventoryValue,
    }),
    (r) => ({
      type: types.GET_AGGREGATE_BRANCH_SALES_INVENTORY_ERROR,
      error: r ? r.error : 'Could not retireve Aggregate Branch',
    })
  );
}

function* getAuditReport({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/auditReport?beginDate=${model.beginDate}&endDate=${model.endDate}&branchIds=${model.branchIds}&pageNumber=${model.pageNumber}&pageSize=${model.pageSize}`,
    null,
    (r) => ({
      type: types.GET_AUDIT_REPORT_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_AUDIT_REPORT_ERROR,
      error: r ? r.error : 'Could not retrive Audit Report',
    })
  );
}

function* getUncountedReport({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/uncountedreport?selectedDate=${model.selectedDate}&branchIds=${model.branchIds}&numberOfDays=${model.numberofdays}&pageNumber=${model.pageNumber}&pageSize=${model.pageSize}`,
    null,
    (r) => ({
      type: types.GET_UNCOUNTED_REPORT_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_UNCOUNTED_REPORT_ERROR,
      error: r ? r.error : 'Could not retrive Audit Report',
    })
  );
}
function* getSageExportGuid({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/excel/hightideSageX3Export?beginDate=${model.beginDate}&endDate=${model.endDate}&branchIds=${model.branchIds}&reportType=${model.reportType}&version=${model.version}&companyCode=${model.companyCode}`,
    null,
    (r) => ({
      type: types.GET_SAGE_EXPORT_GUID_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: 'Could not retireve Sage Export',
    })
  );
}
function* getInventoryAtDateGuid({ model }) {
  yield reportsSagaUtil.fetch(
    `reports/excel/inventoryatdate?endDate=${model.endDate}&branchIds=${model.branchIds}&companyCode=${model.companyCode}`,
    null,
    (r) => ({
      type: types.GET_INVENTORY_AT_DATE_GUID_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: 'Could not retireve Inventory Valuation Report',
    })
  );
}

//MIXNMATCH
function* saveMixAndMatch({ model, compName }) {
  if (model.Id) {
    yield sagaUtil.fetch(
      `mixandmatches/update`,
      model,
      (r) => ({
        type: types.SAVE_MIX_AND_MATCH_SUCCESS,
        data: r.data,
        compName,
      }),
      (r) => ({
        type: types.SAVE_MIX_AND_MATCH_ERROR,
        error: r ? r.error : null,
        compName,
      })
    );
  } else {
    yield sagaUtil.fetch(
      `mixandmatches/create`,
      model,
      (r) => ({
        type: types.SAVE_MIX_AND_MATCH_SUCCESS,
        data: r.data,
        compName,
      }),
      (r) => ({
        type: types.SAVE_MIX_AND_MATCH_ERROR,
        error: r ? r.error : null,
        compName,
      })
    );
  }
}

function* getMixAndMatchById({ id, compName }) {
  yield sagaUtil.fetch(
    `mixandmatches/${id}`,
    null,
    (r) => ({
      type: types.MIX_AND_MATCH_BY_ID_GOT,
      data: r.data,
      compName,
    }),
    (r) => ({
      type: types.MIX_AND_MATCH_BY_ID_ERROR,
      error: r ? r.error : null,
      compName,
    })
  );
}

function* getMixAndMatches({ page, itemsPerPage, branchId }) {
  yield sagaUtil.fetch(
    `mixandmatches/${page}/${itemsPerPage}/${branchId}`,
    null,
    (r) => ({
      type: types.MIX_AND_MATCHES_GOT,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_MIX_AND_MATCHES_ERROR,
      error: r ? r.error : null,
    })
  );
}

//REWARD POINTS
function* setRewardPoint({ model, compName }) {
  yield sagaUtil.fetch(
    `patients/${model.model.patientId}/rewards`,
    model.model,
    (r) => ({
      type: types.REWARD_POINTS_GOT,
      data: r,
      compName: compName,
    }),
    (r) => ({
      type: types.REWARD_POINTS_ERROR,
      error: r ? r.error : null,
    })
  );
}

function* updateRewardPoint({ model, compName }) {
  yield sagaUtil.fetch(
    `patients/${model.model.patientId}/rewards`,
    model.model,
    (r) => ({
      type: types.SET_PATIENT_REWARD_SUCCESS,
      data: r,
      compName: compName,
    }),
    (r) => ({
      type: types.SET_PATIENT_REWARD_ERROR,
      error: r ? r.error : null,
    })
  );
}

function* updateVisitCount({ model }) {
  yield sagaUtil.fetch(
    `patients/${model.model.patientId}/visit`,
    model.model,
    (r) => ({
      type: types.SET_PATIENT_VISIT_SUCCESS,
    }),
    (r) => ({
      type: types.SET_PATIENT_VISIT_ERROR,
      error: r ? r.error : null,
    })
  );
}

function* getRewardPoint({ model }) {
  yield sagaUtil.fetch(
    `patients/${model.patientId}/rewards?page=${model.activePage}&itemsPerPage=${model.itemsPerPage}`,
    null,
    (r) => ({
      type: types.REWARD_POINTS_GOT,
      data: r,
    }),
    (r) => ({
      type: types.REWARD_POINTS_ERROR,
      error: r ? r.error : null,
    })
  );
}

//Ecommece Admin
function* getProductGroup({ branchId, page, itemsPerPage }) {
  yield sagaUtil.fetch(
    `${branchId}/product/group/menu/${page}/${itemsPerPage}`,
    null,
    (r) => ({
      type: types.GOT_PRODUCT_GROUP_LIST,
      data: r.data,
    })
  );
}

function* getProductGroupHome({ branchId, page, itemsPerPage }) {
  yield sagaUtil.fetch(
    `${branchId}/product/group/home/${page}/${itemsPerPage}`,
    null,
    (r) => ({
      type: types.GOT_PRODUCT_GROUP_LIST,
      data: r.data,
    })
  );
}

function* getStoreRules({ model }) {
  yield sagaUtil.fetch(`web/storerules/${model.branchId}`, null, (r) => ({
    type: types.GET_STORE_RULES_SUCCESS,
    data: r.data,
  }));
}

function* deleteStoreRules({ model }) {
  yield sagaUtil.fetch(
    `web/storerules/delete/${model.branchId}/${model.id}`,
    null,
    (r) => ({
      type: types.DELETE_STORE_RULES_SUCCESS,
      data: r.data,
    })
  );
}

function* getStoreRuleById({ model }) {
  yield sagaUtil.fetch(`web/storerules/getById/${model.id}`, null, (r) => ({
    type: types.GET_STORE_RULE_BY_ID_SUCCESS,
    data: r.data,
    compName: model.compName,
  }));
}

function* saveStoreRules({ model }) {
  yield sagaUtil.fetch(`web/storerules/${model.BranchId}`, model, (r) => ({
    type: types.SAVE_STORE_RULES_SUCCESS,
    data: r.data,
    compName: model.compName,
  }));
}

function* updateStoreRules({ model }) {
  yield sagaUtil.fetch(
    `web/storerules/update/${model.BranchId}`,
    model,
    (r) => ({
      type: types.SAVE_STORE_RULES_SUCCESS,
      data: r.data,
      compName: model.compName,
    })
  );
}

function* saveStoreRulesContent({ model }) {
  yield sagaUtil.fetch(`web/storerules/createContent`, model, (r) => ({
    type: types.SAVE_STORE_RULES_CONTENT_SUCCESS,
    data: r.data,
    compName: model.compName,
  }));
}

function* saveProductGroup({ model }) {
  yield sagaUtil.fetch(
    `${model.branchId}/product/group`,
    model.productGroupViewModel,
    (r) => ({
      type: types.PRODUCT_GROUP_SAVED,
      data: r.data,
      compName: model.compName,
    }),
    (r) => ({
      type: types.PRODUCT_GROUP_SAVE_ERROR,
      errors: r ? r.errors : null,
      compName: model.compName,
    })
  );
}

function* updateProductGroup({ model }) {
  yield sagaUtil.fetch(
    `${model.branchId}/product/group/update`,
    model.productGroupViewModel,
    (r) => ({
      type: types.UPDATE_PRODUCT_GROUP_SAVED,
      data: r.data,
      compName: model.compName,
    }),
    (r) => ({
      type: types.UPDATE_PRODUCT_GROUP_ERROR,
      errors: r ? r.errors : null,
      compName: model.compName,
    })
  );
}

function* getProductGroupById({ model }) {
  yield sagaUtil.fetch(
    `${model.branchId}/product/group/${model.id}`,
    null,
    (r) => ({
      type: types.GET_PRODUCT_GROUP_BY_ID_GOT,
      data: r.data,
      compName: model.compName,
    }),
    (r) => ({
      type: types.GET_PRODUCT_GROUP_BY_ID_ERROR,
      errors: r ? r.errors : null,
      compName: model.compName,
    })
  );
}

function* saveHomeSettings({ model }) {
  yield sagaUtil.fetch(
    `web/home/${model.branchId}`,
    model.settingViewModel,
    (r) => ({
      type: types.SAVE_HOME_SETTINGS_SUCCESS,
      data: r.data,
      compName: model.compName,
    }),
    (r) => ({
      type: types.SAVE_HOME_SETTINGS_ERROR,
      errors: r ? r.errors : null,
      compName: model.compName,
    })
  );
}

function* getHomeSettings({ branchId }) {
  yield sagaUtil.fetch(
    `web/home/${branchId}`,
    null,
    (r) => ({
      type: types.GET_HOME_SETTINGS_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_HOME_SETTINGS_ERROR,
      errors: r ? r.errors : null,
    })
  );
}

function* updateHomeSettings({ model }) {
  yield sagaUtil.fetch(
    `web/home/update/${model.branchId}`,
    model.settingViewModel,
    (r) => ({
      type: types.HOME_SETTINGS_UPDATE_SUCCESS,
      data: r.data,
      compName: model.compName,
    }),
    (r) => ({
      type: types.HOME_SETTINGS_UPDATE_FAIL,
      errors: r ? r.errors : null,
      compName: model.compName,
    })
  );
}

function* getWebUISettings({ branchId, compName }) {
  yield sagaUtil.fetch(
    `web/home/getUISetting/${branchId}`,
    null,
    (r) => ({
      type:
        compName == 'integrationOverview'
          ? types.GET_WEB_UI_SETTINGS_INTEGRATION_SUCCESS
          : types.GET_WEB_UI_SETTINGS_SUCCESS,
      data: r.data,
      compName,
    }),
    (r) => ({
      type: types.GET_WEB_UI_SETTINGS_FAIL,
      errors: r ? r.errors : null,
    })
  );
}

function* updateWebUISettings({ model }) {
  yield sagaUtil.fetch(
    `web/home/updateUISetting`,
    model.webUIModel,
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: 'Update Web UI Setting Success',
    }),
    (r) => ({
      type: types.SAVE_WEB_UI_SETTINGS_FAIL,
      errors: r ? r.errors : null,
    })
  );
}

function* getDeliveryZone({ model }) {
  yield sagaUtil.fetch(
    `DeliveryZone/GetAllCity/${model}`,
    null,
    (r) => ({
      type: types.GET_DELIVERY_ZONE_SUCCESS,
      data: r.data,
    }),
    () => ({
      type: types.GET_DELIVERY_ZONE_FAIL,
    })
  );
}

function* createDeliveryZone({ model }) {
  yield sagaUtil.fetch(
    `DeliveryZone/Create`,
    model,
    () => ({
      type: types.CREATE_DELIVERY_ZONE_SUCCESS,
    }),
    (r) => ({
      type: types.CREATE_DELIVERY_ZONE_FAIL,
      errors: r ? r.error : null,
    })
  );
}

function* deleteDeliveryZone({ model }) {
  yield sagaUtil.fetch(
    `DeliveryZone/Delete/${model}`,
    model,
    () => ({
      type: types.DELETE_DELIVERY_ZONE_SUCCESS,
    }),
    (r) => ({
      type: types.DELETE_DELIVERY_ZONE_FAIL,
      errors: r ? r.error : null,
    })
  );
}

function* updateDeliveryZone({ model }) {
  yield sagaUtil.fetch(
    `DeliveryZone/UpdatePrice`,
    model,
    () => ({
      type: types.UPDATE_DELIVERY_ZONE_SUCCESS,
    }),
    (r) => ({
      type: types.UPDATE_DELIVERY_ZONE_FAIL,
      errors: r ? r.error : null,
    })
  );
}

//TODO
//Check how to handle the Success and Error for PinPad
function* authenticatePin({ model }) {
  yield posSagaUtil.fetch(
    'employees/pinWithLog',
    model,
    (r) => ({
      type: types.AUTH_PIN_PASSWORD_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: r ? r.error : 'Pin login fail',
    })
  );
}

function* validatePin({ model }) {
  yield sagaUtil.fetch(
    'employees/validatePin',
    model,
    (r) => ({
      type: types.VALIDATE_PIN_PASSWORD_SUCCESS,
      data: r.success,
    }),
    (r) => ({
      type: types.VALIDATE_PIN_PASSWORD_FAIL,
      message: r ? r.error : 'Pin incorrect',
    })
  );
}

function* generateNewPin({ compName }) {
  yield sagaUtil.fetch(
    'employees/newPin',
    null,
    (r) => ({
      type: types.NEW_PIN_SUCCESS,
      pin: r.data,
      compName: compName,
    }),
    () => ({
      type: types.DIALOG_ALERT_OPEN,
      message:
        'A error occurred while generating a Pin. Try few minutes later.',
    })
  );
}

//CHECKIN
function* getCheckIn({ model }) {
  yield sagaUtil.fetch(
    `checkin/${model.page}/${model.itemsPerPage}`,
    null,
    (r) => ({
      type: types.GET_CHECK_IN_SUCCESS,
      data: r.data,
    }),
    () => ({
      type: types.GET_CHECK_IN_FAIL,
      message: '...',
    })
  );
}

function* addToCheckIn({ id }) {
  yield sagaUtil.fetch(`checkin/${id}`, id, (r) => ({
    type: types.ADD_CHECK_IN_SUCCESS,
    data: r.data,
  }));
}

function* removeCheckIn({ id }) {
  yield sagaUtil.fetch(
    `checkin/delete/${id}`,
    id,
    (r) => ({
      type: types.REMOVE_CHECK_IN_SUCCESS,
      data: r.data,
    }),
    () => ({
      type: types.REMOVE_CHECK_IN_ERROR,
    })
  );
}

function* checkinSearch({ model }) {
  yield sagaUtil.fetch(`patients/checkinSearch`, model, (r) => ({
    type: types.CHECK_IN_SEARCH_SUCCESS,
    patients: r.data,
  }));
}

function* getCheckInById({ id }) {
  yield sagaUtil.fetch(
    `checkin/${id}`,
    null,
    (r) => ({
      type: types.GET_CHECK_IN_BY_ID_SUCCESS,
      data: r.data,
    }),
    () => ({
      type: types.GET_CHECK_IN_BY_ID_FAIL,
      error: 'error',
    })
  );
}

// Dashboard APIs

function* getOrders({
  branchId,
  refreshCache
}) {
  yield dashboardApi.fetch(
    `dashboard/orders/${branchId}`,
    'ORDERS',
    (r) => ({
      type: types.DB_ORDERS_GOT,
      data: r.data
    }),
    () => ({
      type: types.DASHBOARD_FAIL,
      error: 'error'
    }),
    false,
    refreshCache
  );
}

function* getCashDrawer({
  branchId,
  refreshCache
}) {
  yield dashboardApi.fetch(
    `dashboard/cash-flows/${branchId}`,
    'CASHFLOW',
    (r) => ({
      type: types.DB_CASHDRAWER_GOT,
      data: r.data
    }),
    () => ({
      type: types.DASHBOARD_FAIL,
      error: "error"
    }),
    false,
    refreshCache
  );
}

function* getSales({
  model,
  refreshCache
}) {
  yield dashboardApi.fetch(
    `dashboard/sales/${model.periodFilter}/${model.branchId}`,
    "TOTALSALES",
    (r) => ({
      type: types.DB_SALES_GOT,
      data: r.data
    }),
    () => ({
      type: types.DASHBOARD_FAIL,
      error: "error"
    }),
    false,
    refreshCache
  );
}

function* getTopProductsSales({
  model,
  refreshCache
}) {
  yield dashboardApi.fetch(
    `dashboard/top-products/${model.periodFilter}/${model.branchId}`,
    'TOPPRODUCTS',
    (r) => ({
      type: types.DB_TOP_PRODUCTS_SALES_GOT,
      data: r.data
    }),
    () => ({
      type: types.DASHBOARD_FAIL,
      error: 'error'
    }),
    false,
    refreshCache
  );
}

function* getTopMembers() {
  yield dashboardApi.fetch(
    `dashboard/top-members`,
    'TOPMEMBERS',
    (r) => ({
      type: types.DB_TOP_MEMBERS_GOT,
      data: r.data,
    }),
    () => ({
      type: types.DASHBOARD_FAIL,
      error: 'error',
    })
  );
}

function* getTopSellers({
  model,
  refreshCache
}) {
  yield dashboardApi.fetch(
    `dashboard/top-sellers/${model.periodFilter}/${model.branchId}`,
    'TOPSELLERS',
    (r) => ({
      type: types.DB_TOP_SELLERS_GOT,
      data: r.data
    }),
    () => ({
      type: types.DASHBOARD_FAIL,
      error: 'error'
    }),
    false,
    refreshCache
  );
}

function* getTimesheet({
  branchId,
  refreshCache
}) {
  yield dashboardApi.fetch(
    `dashboard/timesheets/${branchId}`,
    'CLOCKIN',
    (r) => ({
      type: types.DB_TIMESHEET_GOT,
      data: r.data
    }),
    () => ({
      type: types.DASHBOARD_FAIL,
      error: 'error'
    }),
    false,
    refreshCache
  );
}

function* getPurchaseOrdersDb({
  branchId,
  refreshCache
}) {
  yield dashboardApi.fetch(
    `dashboard/purchase-orders/${branchId}`,
    'PO',
    (r) => ({
      type: types.DB_PURCHASE_ORDER_GOT,
      data: r.data
    }),
    () => ({
      type: types.DASHBOARD_FAIL,
      error: 'error'
    }),
    false,
    refreshCache
  );
}

function* getInvetory({
  model,
  refreshCache
}) {

  yield dashboardApi.fetch(
    `dashboard/inventory/${model.branchId}/${model.Category}`,
    'INVENTORY',
    (r) => ({
      type: types.DB_INVENTORY_GOT,
      data: r.data
    }),
    () => ({
      type: types.DASHBOARD_FAIL,
      error: 'error'
    }),
    false,
    refreshCache
  );
}

function* getCampaignDb({
  branchId,
  refreshCache
}) {
  yield dashboardApi.fetch(
    `dashboard/campaings/${branchId}`,
    'CAMPAINGS',
    (r) => ({
      type: types.DB_CAMPAIGN_GOT,
      data: r.data,
    }),
    () => ({
      type: types.DASHBOARD_FAIL,
      error: 'error',
    }),
    false,
    refreshCache
  );
}

function* removeCache() {
  yield dashboardApi.fetch(
    `dashboard/remove-cache`,
    null,
    (r) => ({
      type: types.REMOVE_CACHE_SUCCESS,
      data: r.data
    }),
    () => ({
      type: types.REMOVE_CACHE_FAIL,
      error: 'error'
    })
  );
}

function* getClassesOfCannabis() {
  yield sagaUtil.fetch(
    `classes-of-cannabis`,
    null,
    (r) => ({
      type: types.GET_CLASSES_OF_CANNABIS_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_CLASSES_OF_CANNABIS_FAIL,
      error: r.errors,
    })
  );
}

function* setPriceByCategory({ model }) {
  yield sagaUtil.fetch(
    'products/categories/setPriceByCategory',
    model,
    (r) => ({
      type: types.DIALOG_ALERT_OPEN,
      message: r.message,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: r ? r.error : 'Set Price By Category Fail',
    })
  );
}

function* saveProductCategoryTaxProvince({ model }) {
  yield sagaUtil.fetch(
    'products/categories/saveProductCategoryTaxProvince',
    model,
    (r) => ({
      type: types.SAVE_PRODUCT_CATEGORY_TAX_PROVINCE_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.SAVE_PRODUCT_CATEGORY_TAX_PROVINCE_FAIL,
      error: r ? r.error : 'Save Product Category Tax Province Fail',
    })
  );
}

function* getSchedules({ model }) {
  yield sagaUtil.fetch(
    `schedule/filter`,
    model,
    (r) => ({
      type: types.GOT_SCHEDULES,
      data: r.data,
    }),
    (r) => ({
      type: types.GOT_SCHEDULES_ERROR,
      data: r ? r.error : 'Not found',
    })
  );
}

function* getEmployeeSchedules({ model }) {
  yield sagaUtil.fetch(
    `schedule/employee/${model.branchId}/${model.employeeId}`,
    null,
    (r) => ({
      type: types.GOT_SCHEDULE_BY_EMPLOYEE,
      data: r.list,
    }),
    (r) => ({
      type: types.GOT_SCHEDULE_BY_EMPLOYEE_ERROR,
      data: r ? r.error : 'Not found',
    })
  );
}

//TODO - CHECK IF IT`S THE BEST WAY TO SHOW THE MESSAGES
function* createSchedule({ model }) {
  yield sagaUtil.fetch(
    `schedule/create`,
    model,
    (r) => ({
      type: types.CREATE_SCHEDULE_SUCCESS,
      data: r,
    }),
    (r) => ({
      type: types.DIALOG_ALERT_OPEN,
      message: r.error
        ? r.error
        : 'An error occurred while schedule information was created. Please try again later.',
    }),
    false,
    'Schedule created successfully.'
  );
}

function* createScheduleRecursive({ model }) {
  yield sagaUtil.fetch(
    `schedule/create/recursive`,
    model,
    (r) => ({
      type: types.CREATE_SCHEDULE_SUCCESS,
      data: r,
    }),
    (r) => ({
      type: types.DIALOG_ALERT_OPEN,
      message: r.error
        ? r.error
        : 'An error occurred while schedule information was created. Please try again later.',
    }),
    false,
    'Schedule created successfully.'
  );
}

function* getCustomTimeSlots({ model }) {
  yield sagaUtil.fetch(
    `schedule/precreatedSlots?branchId=${model.branchId}`,
    null,
    (r) => ({
      type: types.GOT_CUSTOM_TIME_SLOTS,
      data: r,
    }),
    (r) => ({
      type: types.DIALOG_ALERT_OPEN,
      message: r.error
        ? r.error
        : 'An error occurred while retrieving custom time slots. Please try again later.',
    })
  );
}

function* addNewTimeSlot({ model }) {
  yield sagaUtil.fetch(
    `schedule/precreatedSlots/create`,
    model,
    (r) => ({
      type: types.ADD_NEW_TIME_SLOT_SUCCESS,
      data: r,
    }),
    (r) => ({
      type: types.DIALOG_ALERT_OPEN,
      message: r.error
        ? r.error
        : 'An error occurred while adding time slot. Please try again later.',
    })
  );
}

function* removeTimeSlot({ model }) {
  yield sagaUtil.fetch(
    `schedule/precreatedSlots/remove?id=${model.Id}&branchId=${model.BranchId}`,
    null,
    (r) => ({
      type: types.REMOVE_TIME_SLOT_SUCCESS,
      data: r,
    }),
    (r) => ({
      type: types.DIALOG_ALERT_OPEN,
      message: r.error
        ? r.error
        : 'An error occurred while removing time slot. Please try again later.',
    })
  );
}

function* removeSchedule({ scheduleId }) {
  yield sagaUtil.fetch(
    `schedule/remove`,
    scheduleId,
    (r) => ({
      type: types.REMOVE_SCHEDULE_SUCCESS,
      data: r,
    }),
    (r) => ({
      type: types.DIALOG_ALERT_OPEN,
      message: r.error
        ? r.error
        : 'An error occurred while schedule information was created. Please try again later.',
    }),
    false,
    'Schedule created successfully.'
  );
}

function* removeScheduleRecursive({ scheduleRecursiveId }) {
  yield sagaUtil.fetch(
    `schedule/remove/recursive`,
    scheduleRecursiveId,
    (r) => ({
      type: types.REMOVE_SCHEDULE_SUCCESS,
      data: r,
    }),
    (r) => ({
      type: types.DIALOG_ALERT_OPEN,
      message: r.error
        ? r.error
        : 'An error occurred while schedule information was created. Please try again later.',
    }),
    false,
    'Schedule created successfully.'
  );
}

function* updateSchedule({ model }) {
  yield sagaUtil.fetch(
    `schedule/update`,
    model,
    (r) => ({
      type: types.UPDATE_SCHEDULE_SUCCESS,
      data: r,
    }),
    (r) => ({
      type: types.DIALOG_ALERT_OPEN,
      message: r.error
        ? r.error
        : 'An error occurred while schedule information was updated. Please try again later.',
    }),
    false,
    'Schedule updated successfully.'
  );
}

function* sendSchedule({ model }) {
  yield sagaUtil.fetch(
    `schedule/sendSchedule`,
    model,
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: `Schedules sent succesfully.`,
    }),
    (r) => ({
      type: types.DIALOG_ALERT_OPEN,
      message: r.error
        ? r.error
        : 'An error occurred while schedule information was sent. Please try again later.',
    }),
    false,
    'Schedule updated successfully.'
  );
}

function* getOnlineOrder({ model }) {
  yield sagaUtil.fetch(
    `onlineOrders/getAll`,
    model,
    (r) => ({
      type: types.GET_ONLINE_ORDER_SUCCESS,
      data: r.data,
      total: r.total,
    }),
    (r) => ({
      type: types.GET_ONLINE_ORDER_FAIL,
      error: r.errors,
    })
  );
}

function* clearUnprintedOrder({ branchId }) {
  yield sagaUtil.fetch(
    `unauthorized/clearUnprintedOrder/${branchId}`,
    null,
    (r) => ({
      type: types.DIALOG_ALERT_OPEN,
      message: r.message,
    }),
    (r) => ({
      type: types.DIALOG_ALERT_OPEN,
      message: r.error,
    })
  );
}

function* getOnlineOrderDetails({ orderId }) {
  yield posSagaUtil.fetch(
    `onlineOrders/details/${orderId}`,
    null,
    (r) => ({
      type: types.GET_ONLINE_ORDER_DETAILS_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_ONLINE_ORDER_DETAILS_FAIL,
      error: r.errors,
    })
  );
}

function* getOnlineOrderDetailsByCode({ model }) {
  yield sagaUtil.fetch(
    `onlineOrders/details/code/${model.branchId}/${model.code}/${model.type}`,
    null,
    (r) => ({
      type: types.GET_ONLINE_ORDER_DETAILS_BY_CODE_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_ONLINE_ORDER_DETAILS_BY_CODE_FAIL,
    })
  );
}

function* getPickUpOrderDetailsByOrderId({ model }) {
  yield sagaUtil.fetch(
    `orders/pickUpDetails/${model.branchId}/${model.id}`,
    null,
    (r) => ({
      type: types.GET_PICKUP_ORDER_DETAILS_BY_CODE_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_PICKUP_ORDER_DETAILS_BY_CODE_FAIL,
    })
  );
}

function* updateStatusOnlineOrder({ model }) {
  yield sagaUtil.fetch(
    `onlineOrders/update/status`,
    model,
    (r) => ({
      type: types.UPDATE_STATUS_ONLINE_ORDER_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.UPDATE_STATUS_ONLINE_ORDER_FAIL,
    })
  );
}

function* cancelOnlineOrder({ model }) {
  yield sagaUtil.fetch(
    `onlineOrders/cancel/${model.Id}`,
    model,
    (r) => ({
      type: types.CANCEL_ONLINE_ORDER_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: `Cancel Online order failed. ${r.error}`,
    })
  );
}

function* getOnlineOrdersQueue({ model }) {
  yield posSagaUtil.fetch(
    `onlineOrders/queue/${model.branchId}/${model.code}/${model.type}`,
    null,
    (r) => ({
      type: types.GET_ONLINE_ORDERS_QUEUE_SUCCESS,
      data: r.data,
      openQueuedOrdersCount: r.queuedOrders,
      openBuddiOrdersCount: r.buddiOrders,
      openLeaflyOrdersCount: r.leaflyOrders,
    }),
    (r) => ({
      type: types.GET_ONLINE_ORDERS_QUEUE_FAIL,
    })
  );
}

function* getPickUpOrdersQueue({ branchId }) {
  yield sagaUtil.fetch(
    `orders/pickUpQueue/${branchId}`,
    null,
    (r) => ({
      type: types.GET_PICKUP_ORDERS_QUEUE_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_PICKUP_ORDERS_QUEUE_FAIL,
    })
  );
}

function* generateOrderBasedOnlineOrder({ model }) {
  yield posSagaUtil.fetch(
    `onlineOrders/generate/sale`,
    model,
    (r) => ({
      type: types.GENERATE_ORDER_BASED_ONLINE_ORDER_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.GENERATE_ORDER_BASED_ONLINE_ORDER_FAIL,
      error: r.error,
    })
  );
}

function* getStoreToDoorPickupTime({
  branchId, pickupDate
}) {
  yield sagaUtil.fetch(
    `storetodoor/getPickupTimes/${branchId}/${pickupDate}`,
    null,
    (r) => ({
      type: types.GET_STORETODOOR_PICKUP_TIME_SUCCESS,
      data: r.data
    }),
    (r) => ({
      type: types.GET_STORETODOOR_PICKUP_TIME_FAIL,
      error: r.error
    })
  );
}

function* getStoreToDoorLocationInformation({ branchId }) {
  yield sagaUtil.fetch(
    `storetodoor/getLocationInformation/${branchId}`,
    null,
    (r) => ({
      type: types.GET_STORETODOOR_LOCATION_INFO_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_STORETODOOR_LOCATION_INFO_FAIL,
      error: r.error,
    })
  );
}

function* getPrescriptions({ patientId }) {
  yield sagaUtil.fetch(
    `patients/prescription/${patientId}`,
    null,
    (r) => ({
      type: types.GET_PRESCRIPTIONS_BY_PATIENT_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_PRESCRIPTIONS_BY_PATIENT_FAIL,
    })
  );
}

function* createPrescription({ model }) {
  yield sagaUtil.fetch(
    `patients/prescription`,
    model,
    (r) => ({
      type: types.CREATE_PRESCRIPTION_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.CREATE_PRESCRIPTION_FAIL,
    })
  );
}

function* cancelOpenOnlineOrders(model) {
  yield sagaUtil.fetch(
    `onlineOrders/cancelOpenOrders`,
    model.model,
    () => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: 'Cancel Open OnlineOrders Success!',
    }),
    () => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: 'Cancel Open OnlineOrders Fail!',
    })
  );
}

function* getOpenOnlineOrdersCount({ branchId }) {
  yield sagaUtil.fetch(
    `onlineOrders/getOpenOnlineOrdersCount/${branchId}`,
    null,
    (r) => ({
      type: types.GET_OPEN_ONLINE_ORDERS_COUNT_SUCCESS,
      openQueuedOrdersCount: r.queuedOrders,
      openBuddiOrdersCount: r.buddiOrders,
      openLeaflyOrdersCount: r.leaflyOrders,
    }),
    (r) => ({
      type: types.GET_OPEN_ONLINE_ORDERS_COUNT_FAIL,
    }),
    false,
    null,
    false
  );
}

function* getWordpressOrdersUpdate({ branchId }) {
  yield sagaUtil.fetch(
    `wp/Order/updatelist/${branchId}`,
    null,
    (r) => ({
      type: types.GET_WORDPRESS_ORDER_LIST_UPDATE_SUCCESS,
      model,
    }),
    (r) => ({
      type: types.GET_WORDPRESS_ORDER_LIST_UPDATE_FAIL,
    }),
    false,
    null,
    false
  );
}

function* getManualWordpressOrdersUpdate({ branchId }) {
  yield sagaUtil.fetch(
    `wp/Order/updatelist/${branchId}`,
    null,
    (r) => ({
      type: types.GET_MANUAL_WORDPRESS_ORDER_LIST_UPDATE_SUCCESS,
      model,
    }),
    (r) => ({
      type: types.GET_MANUAL_WORDPRESS_ORDER_LIST_UPDATE_FAIL,
    }),
    false,
    null,
    true
  );
}

function* getMonerisReceiptByOrderId({ model }) {
  yield sagaUtil.fetch(
    `moneris/getReceiptByOrderId/${model.orderId}`,
    null,
    (r) => ({
      type: types.GET_MONERIS_RECEIPT_BY_ORDERID_SUCCESS,
      data: r.data,
      receiptType: model.type,
    }),
    (r) => ({
      type: types.GET_MONERIS_RECEIPT_BY_ORDERID_FAIL,
    })
  );
}

function* syncProductsToLeafly({ branchId }) {
  yield sagaUtil.fetch(
    `warehouses/syncDataToleaflyFromServer/${branchId}`,
    null,
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: 'Push Warehouse to Leafly Success',
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: r.error,
    })
  );
}

function* syncProductsToWeedmaps({ branchId }) {
  yield put({
    type: types.SNACKBAR_SHOW_MESSAGE,
    message: 'Weedmaps is working in the back',
  });

  yield sagaUtil.fetch(
    `warehouses/syncDataToWeedmapsFromServer/${branchId}`,
    null,
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: 'Push Warehouse to Weedmaps Success',
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: r.error,
    }),
    false,
    null,
    false
  );
}

function* trackingDrawerOpen({ model }) {
  yield sagaUtil.fetch(
    `cashflows/drawerOpenTrack/${model.branchId}/${model.cashflowId}/${model.orderId}`,
    null,
    () => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: 'Open Drawer Success',
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: 'Open Drawer Fail',
    })
  );
}

function* signUpOnlineUser({ model }) {
  yield sagaUtil.fetch(
    `accounts/onlineUserSignUp`,
    model,
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: r.message,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: r.error,
    })
  );
}

function* giftCardCreateOrReload({ model }) {
  const giftCardProductId = yield select(
    (state) => state.form.currentGiftCardActive
  );
  yield sagaUtil.fetch(
    `GiftCard/Create`,
    model,
    (r) => ({
      type: types.GIFT_CARD_CREATE_RELOAD_SUCCESS,
      data: r.data,
      giftCardProductId,
    }),
    (r) => ({
      type: types.GIFT_CARD_CREATE_RELOAD_FAIL,
      data: r.error,
    })
  );
}

function* giftCardcheckingBalance({ model }) {
  yield sagaUtil.fetch(
    `GiftCard/GetByCardNumber/${model.cardNumber}`,
    null,
    (r) => ({
      type: types.GIFT_CARD_BALANCE_PAGE_CHECK_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.GIFT_CARD_BALANCE_PAGE_CHECK_FAIL,
      data: r.error,
    })
  );
}

function* chargeGiftCard({ model }) {
  yield sagaUtil.fetch(
    `GiftCard/purchase`,
    model,
    (r) => ({
      type: types.CHARGE_GIFT_CARD_TO_ORDER_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.CHARGE_GIFT_CARD_TO_ORDER_FAIL,
      data: r.error,
    })
  );
}

function* giftCardInitialization({ model }) {
  yield sagaUtil.fetch(
    `monerisGiftCard/initialize`,
    model,
    (r) => ({
      type: types.GIFT_CARD_INITIALIZATION_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.GIFT_CARD_INITIALIZATION_FAIL,
      message: r.error,
    })
  );
}

function* giftCardDataInquiry({ model }) {
  yield sagaUtil.fetch(
    `monerisGiftCard/dataInquiry`,
    model,
    (r) => ({
      type: types.GIFT_CARD_DATA_INQUIRY_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: r.error,
    })
  );
}

function* giftCardPurchase({ model }) {
  yield sagaUtil.fetch(
    `monerisGiftCard/purchase`,
    model,
    (r) => ({
      type: types.GIFT_CARD_PURCHASE_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.GIFT_CARD_PURCHASE_FAIL,
      data: r.data,
    })
  );
}

function* giftCardRefund({ model }) {
  yield sagaUtil.fetch(
    `monerisGiftCard/refund`,
    model,
    (r) => ({
      type: types.GIFT_CARD_REFUND_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: r.error,
    })
  );
}

function* giftCardActivation({ model }) {
  yield sagaUtil.fetch(
    `monerisGiftCard/activate`,
    model,
    (r) => ({
      type: types.GIFT_CARD_ACTIVATION_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.GIFT_CARD_ACTIVATION_FAIL,
      data: r.data,
    })
  );
}

function* giftCardDeactivation({ model }) {
  yield sagaUtil.fetch(
    `monerisGiftCard/deactivate`,
    model,
    (r) => ({
      type: types.GIFT_CARD_DEACTIVATION_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: r.error,
    })
  );
}

function* importProductsFromCatalog({ branchId }) {
  yield sagaUtil.fetch(
    `products/importProductsFromCatalog/${branchId}`,
    null,
    (r) => ({
      type: types.IMPORT_PRODUCTS_FROM_CATALOG_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.IMPORT_PRODUCTS_FROM_CATALOG_FAIL,
      error: r.error,
    })
  );
}

function* syncFromCatalog({ model }) {
  yield sagaUtil.fetch(
    `products/massUpdateProductInfo`,
    model,
    (r) => ({
      type: types.SYNC_FROM_CATALOG_SUCCESS,
      success: r.success,
    }),
    (r) => ({
      type: types.SYNC_FROM_CATALOG_FAILED,
      error: r.error,
    })
  );
}

function* importAccessoryFromCatalog({ vendorId }) {
  yield sagaUtil.fetch(
    `products/importProductsFromCatalog/1/${true}/${vendorId}`,
    null,
    (r) => ({
      type: types.IMPORT_PRODUCTS_FROM_CATALOG_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.IMPORT_PRODUCTS_FROM_CATALOG_FAIL,
      error: r.error,
    })
  );
}

function* updateBCClosingInventory({ model }) {
  yield sagaUtil.fetch(
    `federalReport/bcclosingInventory`,
    model,
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: 'upload success!',
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: 'upload fail!',
    })
  );
}

function* updateClosingInventory({ model }) {
  yield sagaUtil.fetch(
    `federalReport/productClosingInventory`,
    model,
    (r) =>
      r.data.message
        ? {
          type: types.DIALOG_ALERT_OPEN,
          message: r.data.message,
        }
        : {
          type: types.SNACKBAR_SHOW_MESSAGE,
          message: 'upload success!',
        },
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: 'upload fail!',
    })
  );
}

function* getClosingInventoryStatus({ model }) {
  yield sagaUtil.fetch(
    `federalReport/getClosingInventoryStatus/${model.branchId}/${model.year}/${model.month}`,
    null,
    (r) => ({
      type: types.GET_CLOSING_INVENTORY_PRODUCT_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_CLOSING_INVENTORY_PRODUCT_FAIL,
      data: r.data,
    }),
    false,
    null,
    false
  );
}

function* birchmountGiftCardOperation({ model }) {
  yield sagaUtil.fetch(
    `birchmountGiftCard/operate`,
    model,
    (r) => ({
      type: types.BIRCHMOUNT_GIFTCARD_OPERATION_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.DIALOG_ALERT_OPEN,
      message:
        r.data && r.data.response && r.data.response.msg
          ? r.data.response.msg
          : r.error,
    })
  );
}

function* birchmountGiftCardPurchase({ model }) {
  yield sagaUtil.fetch(
    `birchmountGiftCard/operate`,
    model,
    (r) => ({
      type: types.BIRCHMOUNT_GIFT_CARD_PURCHASE_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.DIALOG_ALERT_OPEN,
      message:
        r.data && r.data.response && r.data.response.msg
          ? r.data.response.msg
          : r.error,
    })
  );
}

function* birchmountGiftCardRefund({ model }) {
  yield sagaUtil.fetch(
    `birchmountGiftCard/operate`,
    model,
    (r) => ({
      type: types.BIRCHMOUNT_GIFT_CARD_REFUND_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.DIALOG_ALERT_OPEN,
      message:
        r.data && r.data.response && r.data.response.msg
          ? r.data.response.msg
          : r.error,
    })
  );
}

function* paystoneGiftCardOperation({ model }) {
  yield sagaUtil.fetch(
    `paystoneGiftCard/operate`,
    model,
    (r) => ({
      type: types.PAYSTONE_GIFTCARD_OPERATION_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: r.error,
    })
  );
}

function* paystoneGiftCardPurchase({ model }) {
  yield sagaUtil.fetch(
    `paystoneGiftCard/operate`,
    model,
    (r) => ({
      type: types.PAYSTONE_GIFTCARD_PURCHASE_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: r.error,
    })
  );
}

function* paystoneGiftCardRefund({ model }) {
  yield sagaUtil.fetch(
    `paystoneGiftCard/operate`,
    model,
    (r) => ({
      type: types.PAYSTONE_GIFTCARD_REFUND_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: r.error,
    })
  );
}

function* sendMessageBy(model) {
  let branchId = parseInt(localStorage.getItem('TECHPOS_SELECTED_BRANCH'));
  model.model.BranchId = branchId;
  yield sagaUtil.fetch(
    `patients/sendMessage`,
    model.model,
    (r) => ({
      type: types.SEND_MESSAGE_SUCCESS,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: r.error,
    })
  );
}

function* sendTestMessage({ model }) {
  yield sagaUtil.fetch(
    `patients/sendTestMessage`,
    model,
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: 'Message sent',
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: r.error,
    })
  );
}

function* updateTwilioInfo({ model }) {
  yield sagaUtil.fetch(
    `patients/updateTwilioInfo`,
    model,
    (r) => ({
      type: types.UPDATE_TWILIO_INFO_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: r.error,
    })
  );
}

function* uploadImage({ model }) {
  yield sagaUtil.fetch(
    `patients/uploadimage`,
    model,
    (r) => ({
      type: types.UPLOAD_IMAGE_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: r.error,
    })
  );
}
function* uploadexcel({ model }) {
  yield sagaUtil.fetch(
    `bulkpriceupdate/uploadExcel`,
    model,
    (r) => ({
      type: types.UPLOAD_EXCEL_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: r.message,
    }),
    false,
    null,
    true
  );
}
//GET Method
function* getBulkPriceUpdateSchedular({ branchId, page, itemsPerPage }) {
  yield sagaUtil.fetch(
    `bulkpriceupdate/getBulkPriceUpdateSchedular/${branchId}/${page}/${itemsPerPage}`,
    null,
    (r) => ({
      type: types.GET_BULK_PRICE_SCHEDULAR_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: r.error,
    })
  );
}

//GET Method
function* deleteBulkPriceList({ schedularId }) {
  yield sagaUtil.fetch(
    `bulkpriceupdate/deleteBulkPriceList/${schedularId}`,
    null,
    (r) => ({
      type: types.DELETE_BULK_PRICE_LIST_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: r.error,
    })
  );
}
//GET Method
function* updateBulkPriceList() {
  yield sagaUtil.fetch(
    `bulkpriceupdate/updateBulkPriceList`,
    null,
    (r) => ({
      type: types.UPDATE_BULK_PRICE_LIST_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: r.error,
    })
  );
}

function* inventoryAdjustRoundPrices({ model }) {
  yield sagaUtil.fetch(
    `products/inventoryadjustroundprices/${model.branchId}`,
    model,
    (r) => ({
      type: types.INVENTORY_ADJUST_ROUND_PRICES_SUCCESS,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: r.error,
    })
  );
}

function* bulkUpdateMemberPrice({ model }) {
  yield sagaUtil.fetch(
    `products/bulkUpdateMemberPrice/${model.branchId}/${model.percentageDiscount}`,
    model,
    (r) => ({
      type: types.BULK_UPDATE_MEMBER_PRICE_SUCCESS,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: r.error,
    })
  );
}
function* getBulkMemberPriceHistory({ branchId }) {
  yield sagaUtil.fetch(
    `products/getBulkMemberPriceHistory/${branchId}`,
    null,
    (r) => ({
      type: types.GET_BULK_MEMBER_PRICE_HISTORY_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_BULK_MEMBER_PRICE_HISTORY_FAIL,
      error: r.error,
    })
  );
}
function* categoryUpdateMemberPrice({ model }) {
  yield sagaUtil.fetch(
    `products/categories/setMemberPrice`,
    model,
    (r) => ({
      type: types.CATEGORY_UPDATE_MEMBER_PRICE_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: r.error,
    })
  );
}
function* getBulkMemberPriceCategoryHistory({ branchId }) {
  yield sagaUtil.fetch(
    `products/getBulkMemberPriceCategoryHistory/${branchId}`,
    null,
    (r) => ({
      type: types.GET_BULK_MEMBER_PRICE_CATEGORY_HISTORY_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_BULK_MEMBER_PRICE_CATEGORY_HISTORY_FAIL,
      error: r.error,
    })
  );
}
function* getProductCategoryBulkUpdatePriceHistory({ branchId, categoryId }) {
  yield sagaUtil.fetch(
    `products/categories/getBulkUpdatePriceHistory/${branchId}/${categoryId}`,
    null,
    (r) => ({
      type: types.GET_PRODUCT_CATEGORY_BULK_UPDATE_PRICE_HISTORY_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_PRODUCT_CATEGORY_BULK_UPDATE_PRICE_HISTORY_FAIL,
      error: r.error,
    })
  );
}
function* getSpringbigOffers({ model }) {
  yield sagaUtil.fetch(
    `springbig/offers/${model.patientId}/${model.branchId}`,
    model,
    (r) => ({
      type: types.GET_SPRINGBIG_OFFERS_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: r ? r.error : 'Could not retrive SpringBig Offers',
    })
  );
}

function* getSpringbigRewards({ model }) {
  yield sagaUtil.fetch(
    `springbig/rewards/${model.branchId}`,
    model,
    (r) => ({
      type: types.GET_SPRINGBIG_REWARDS_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: r ? r.error : 'Could not retrive SpringBig Rewards',
    })
  );
}

function* getSpringbigMemberPoints({ model }) {
  const url = `springbig/memberpoints/${model.branchId}/${model.patientId}/${model.patientPhoneNumber}`;

  yield sagaUtil.fetch(
    url,
    model,
    (r) => ({
      type: types.GET_SPRINGBIG_MEMBERPOINTS_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: r ? r.error : 'Could not retrieve SpringBig Member Points',
    })
  );
}

function* postSpringbigOfferDiscount(model) {
  yield sagaUtil.fetch(
    `orders/${model.model.Id}/springbigoffer`,
    model.model,
    (r) => ({
      type: types.SET_ORDER_DISCOUNT_SUCCESS,
      data: r.data,
      compName: model.compName,
      currentCashFlow:
        r.data && r.data.currentCashFlow ? r.data.currentCashFlow : null,
    }),
    (r) => ({
      type: types.SET_ORDER_DISCOUNT_ERROR,
      error: r,
      compName: model.compName,
    })
  );
}

function* postSpringbigRewardDiscount(model) {
  yield sagaUtil.fetch(
    `orders/${model.model.Id}/springbigreward`,
    model.model,
    (r) => ({
      type: types.SET_ORDER_DISCOUNT_SUCCESS,
      data: r.data,
      compName: model.compName,
      currentCashFlow:
        r.data && r.data.currentCashFlow ? r.data.currentCashFlow : null,
    }),
    (r) => ({
      type: types.SET_ORDER_DISCOUNT_ERROR,
      error: r,
      compName: model.compName,
    })
  );
}

function* alpineIQverifyWallet({ model }) {
  yield sagaUtil.fetch(
    `alpineiq/verifywallet`,
    model,
    (r) => ({
      type: types.ALPINEIQ_VERIFY_WALLET_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: r ? r.error : 'Could not verify wallet',
    })
  );
}

function* alpineIQregister({ model }) {
  yield sagaUtil.fetch(
    `alpineiq/register`,
    model,
    (r) => ({
      type: types.ALPINEIQ_VERIFY_WALLET_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: 'Could not register with AlpineIQ',
    })
  );
}

function* alpineIQviewWallet({ model }) {
  yield sagaUtil.fetch(
    `alpineiq/viewwallet/`,
    model,
    (r) => ({
      type: types.ALPINEIQ_VIEW_WALLET_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: r.error ? r.error : 'Could not retrieve Alpine IQ Rewards',
    })
  );
}

function* postAlpineIQDiscount(model) {
  yield sagaUtil.fetch(
    `orders/${model.model.Id}/alpineiqdiscount`,
    model.model,
    (r) => ({
      type: types.SET_ORDER_DISCOUNT_SUCCESS,
      data: r.data,
      compName: model.compName,
      currentCashFlow:
        r.data && r.data.currentCashFlow ? r.data.currentCashFlow : null,
    }),
    (r) => ({
      type: types.SET_ORDER_DISCOUNT_ERROR,
      error: r,
      compName: model.compName,
    })
  );
}

function* alpineIQCheckIn(model) {
  yield sagaUtil.fetch(
    `alpineiq/checkin`,
    model.model,
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: 'Visit Registerred',
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: 'Unable to register visit',
    })
  );
}

function* addMood(model) {
  yield sagaUtil.fetch(
    `mood/add/${model.name}/${model.branchId}`,
    null,
    (r) => ({
      type: types.ADD_MOOD_SUCCESS,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: r.message,
    })
  );
}

function* assignMood(model) {
  yield sagaUtil.fetch(
    `mood/assign/${model.productId}/${model.moodId}/${model.branchId}`,
    null,
    (r) => ({
      type: types.ASSIGN_MOOD_SUCCESS,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: 'Unable to assign Mood',
    })
  );
}

function* getProductMoods(model) {
  yield sagaUtil.fetch(
    `mood/${model.productId}`,
    null,
    (r) => ({
      type: types.GET_PRODUCT_MOODS_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: 'Unable to get Moods',
    })
  );
}

function* getMoods() {
  yield sagaUtil.fetch(
    `mood/all`,
    null,
    (r) => ({
      type: types.GET_MOODS_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: 'Unable to get Moods',
    })
  );
}

function* deleteMood(model) {
  yield sagaUtil.fetch(
    `mood/delete/${model.productId}/${model.moodId}`,
    null,
    (r) => ({
      type: types.ASSIGN_MOOD_SUCCESS,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: 'Unable to remove Mood from list',
    })
  );
}

function* addTerpene(model) {
  yield sagaUtil.fetch(
    `terpene/add/${model.name}/${model.branchId}`,
    null,
    (r) => ({
      type: types.ADD_TERPENE_SUCCESS,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: r.message,
    })
  );
}

function* assignTerpene(model) {
  yield sagaUtil.fetch(
    `terpene/assign/${model.productId}/${model.terpeneId}`,
    null,
    (r) => ({
      type: types.ASSIGN_TERPENE_SUCCESS,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: 'Unable to assign Terpene',
    })
  );
}

function* getProductTerpenes(model) {
  yield sagaUtil.fetch(
    `terpene/${model.productId}`,
    null,
    (r) => ({
      type: types.GET_PRODUCT_TERPENES_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: 'No Terpenes currently assigned',
    })
  );
}

function* getTerpenes() {
  yield sagaUtil.fetch(
    `terpene/all`,
    null,
    (r) => ({
      type: types.GET_TERPENES_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: r.message,
    })
  );
}

function* deleteTerpene(model) {
  yield sagaUtil.fetch(
    `terpene/delete/${model.productId}/${model.terpeneId}`,
    null,
    (r) => ({
      type: types.ASSIGN_TERPENE_SUCCESS,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: 'Unable to remove Terpene from list',
    })
  );
}

function* saveTerpene(model) {
  yield sagaUtil.fetch(
    `terpene/save/${model.productId}/${model.terpeneId}/${model.min}/${model.max}`,
    null,
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: 'Terpene ranges updated',
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: 'Unable to update Terpene ranges',
    })
  );
}

function* addMinorCanabinoid(model) {
  yield sagaUtil.fetch(
    `minorcanabinoid/add/${model.name}/${model.abbrev}/${model.branchId}`,
    null,
    (r) => ({
      type: types.ADD_MINORCANABINOID_SUCCESS,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: r.message,
    })
  );
}

function* assignMinorCanabinoid(model) {
  yield sagaUtil.fetch(
    `minorcanabinoid/assign/${model.productId}/${model.minorCanabinoidId}`,
    null,
    (r) => ({
      type: types.ASSIGN_MINORCANABINOID_SUCCESS,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: 'Unable to assign MinorCanabinoid',
    })
  );
}

function* getProductMinorCanabinoids(model) {
  yield sagaUtil.fetch(
    `minorcanabinoid/${model.productId}`,
    null,
    (r) => ({
      type: types.GET_PRODUCT_MINORCANABINOIDS_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: 'No MinorCanabinoids currently assigned',
    })
  );
}

function* getMinorCanabinoids() {
  yield sagaUtil.fetch(
    `minorcanabinoid/all`,
    null,
    (r) => ({
      type: types.GET_MINORCANABINOIDS_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: 'Unable to get MinorCanabinoids',
    })
  );
}

function* deleteMinorCanabinoid(model) {
  yield sagaUtil.fetch(
    `minorcanabinoid/delete/${model.productId}/${model.minorCanabinoidId}`,
    null,
    (r) => ({
      type: types.ASSIGN_MINORCANABINOID_SUCCESS,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: 'Unable to remove MinorCanabinoid from list',
    })
  );
}

function* saveMinorCanabinoid(model) {
  yield sagaUtil.fetch(
    `minorcanabinoid/save/${model.productId}/${model.minorCanabinoidId}/${model.min}/${model.max}`,
    null,
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: 'MinorCanabinoid ranges updated',
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: 'Unable to update MinorCanabinoid ranges',
    })
  );
}

function* GetProductInventoryLog({ model }) {
  yield sagaUtil.fetch(
    `warehouses/GetProductInventoryLog`,
    model,
    (r) => ({
      type: types.GOT_PRODUCT_INVENTORY_BY_BRANCH_DATE,
      data: r.data,
    }),
    () => ({
      type: types.GOT_PRODUCT_INVENTORY_BY_BRANCH_DATE_FAIL,
    })
  );
}

function* getMultiBranchInventory({ model }) {
  yield sagaUtil.fetch(
    `warehouses/GetMultiBranchInventory`,
    model,
    (r) => ({
      type: types.GOT_MULTI_BRANCH_INVENTORY,
      data: r.data,
    }),
    () => ({
      type: types.GOT_MULTI_BRANCH_INVENTORY_FAIL,
    })
  );
}

function* setRestockQty({ model }) {
  yield sagaUtil.fetch(
    `warehouses/SetRestockValue`,
    model,
    (r) => ({
      type: types.SET_RESTOCK_QTY_SUCCESS,
      data: r.data,
    }),
    () => ({
      type: types.SET_RESTOCK_QTY_FAIL,
    })
  );
}

function* getSingleBranchInventory({ model }) {
  yield sagaUtil.fetch(
    `warehouses/GetMultiBranchInventory`,
    model,
    (r) => ({
      type: types.GOT_SINGLE_PRODUCT_INVENTORY,
      data: r.data.list[0].singleBranchInventoryDTO,
    }),
    () => ({
      type: types.GOT_SINGLE_PRODUCT_INVENTORY_FAIL,
    })
  );
}

function* submitReportAutomation({ model }) {
  const { APIUrl, ...restModel } = model;
  yield sagaUtil.fetch(
    `${APIUrl}`,
    restModel,
    (r) => ({
      type: types.SEND_REPORT_AUTOMATION_SUCCESS,
      data: r.data,
    }),
    () => ({
      type: types.SEND_REPORT_AUTOMATION_FAILED,
    })
  );
}

function* getReportAutomationInfo({ model }) {
  yield sagaUtil.fetch(
    `ReportEmailAutomation/${model}`,
    null,
    (r) => ({
      type: types.GET_REPORT_AUTOMATION_INFO_SUCCESS,
      data: r.data,
    }),
    () => ({
      type: types.GET_REPORT_AUTOMATION_INFO_FAILED,
    })
  );
}

function* updateReportAutomationInfo({ model }) {
  yield sagaUtil.fetch(
    `ReportEmailAutomation/Update`,
    model,
    (r) => ({
      type: types.UPDATE_REPORT_AUTOMATION_INFO_SUCCESS,
      data: r.data,
    }),
    () => ({
      type: types.UPDATE_REPORT_AUTOMATION_INFO_FAILED,
    })
  );
}

function* deleteReportAutomationInfo({ model }) {
  yield sagaUtil.fetch(
    'ReportEmailAutomation/Delete',
    model.reportIds,
    (r) => ({
      type: types.DELETE_REPORT_AUTOMATION_SUCCESS,
    }),
    () => ({
      type: types.DELETE_REPORT_AUTOMATION_FAILED,
    })
  );
}

function* getStoreLockDateNTime({ branchId }) {
  yield sagaUtil.fetch(
    `StoreLockDateAndTime/${branchId}`,
    null,
    (r) => ({
      type: types.GET_STORE_LOCK_DATE_AND_TIME_SUCCESS,
      data: r.data,
    }),
    () => ({
      type: types.GET_STORE_LOCK_DATE_AND_TIME_FAILED,
    })
  );
}

function* AddStoreLockDateNTime({ model }) {
  yield sagaUtil.fetch(
    `StoreLockDateAndTime/Create`,
    model,
    () => ({
      type: types.CREATE_STORE_LOCK_DATE_AND_TIME_SUCCESS,
    }),
    () => ({
      type: types.CREATE_STORE_LOCK_DATE_AND_TIME_FAILED,
    })
  );
}

function* deleteStoreLockDateNTime({ model }) {
  yield sagaUtil.fetch(
    `StoreLockDateAndTime/Delete`,
    model,
    (r) => ({
      type: types.DELETE_STORE_LOCK_DATE_AND_TIME_SUCCESS,
      data: r.data,
    }),
    (error) => ({
      type: types.DELETE_STORE_LOCK_DATE_AND_TIME_FAILED,
      error: error.error,
    })
  );
}

function* updateStoreLockDateNTime({ model }) {
  yield sagaUtil.fetch(
    `StoreLockDateAndTime/Update`,
    model,
    () => ({
      type: types.UPDATE_STORE_LOCK_DATE_AND_TIME_SUCCESS,
    }),
    () => ({
      type: types.UPDATE_STORE_LOCK_DATE_AND_TIME_FAILED,
    })
  );
}

// REPORT
function* getCsvReport(model) {
  if (model.mode == 'get') {
    yield reportsUtil.get(model.url, model.name);
  } else {
    yield reportsUtil.getWithStatus(model.url, model.name);
  }
}

function* getStoreSEOSettings() {
  yield sagaUtil.fetch(
    `seo`,
    null,
    (r) => ({
      type: types.GET_STORE_SEO_SETTINGS_SUCCESS,
      data: r.data,
    }),
    () => ({
      type: types.GET_STORE_SEO_SETTINGS_FAILED,
    })
  );
}

function* updateStoreSEOSettings(model) {
  yield sagaUtil.fetch(
    `seo/updateSEOSettings`,
    { ...model.model },
    (r) => ({
      type: types.UPDATE_STORE_SEO_SETTINGS_SUCCESS,
      data: r.data,
    }),
    () => ({
      type: types.UPDATE_STORE_SEO_SETTINGS_FAILED,
    })
  );
}

// Product Group Image
function* getProductGroupImage(model) {
  yield sagaUtil.fetch(
    `productGroupImage/GetByProductGroup/${model.groupId}`,
    null,
    (r) => ({
      type: types.GET_PRODUCT_GROUP_IMAGE_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_PRODUCT_GROUP_IMAGE_FAILED,
      data: r,
    })
  );
}

function* postNewProductGroupImage(model) {
  try {
    yield sagaUtil.fetch(`productGroupImage/AddImage`, { ...model.model });
    yield put({
      type: types.ADD_PRODUCT_GROUP_IMAGE_SUCCESS,
    });
  } catch (r) {
    yield put({
      type: types.ADD_PRODUCT_GROUP_IMAGE_FAILED,
      data: r,
    });
  }
}

function* deleteProductGroupImage(model) {
  try {
    const response = yield sagaUtil.fetch(
      `productGroupImage/RemoveImage`,
      model.model.ID
    );
    yield put({
      type: types.DELETE_PRODUCT_GROUP_IMAGE_SUCCESS,
    });
  } catch (r) {
    yield put({
      type: types.DELETE_PRODUCT_GROUP_IMAGE_FAILED,
      data: r,
    });
  }
}

function* adyenPaymentRequest(model) {
  try {
    yield sagaUtil.fetch(
      `adyen/paymentRequest`,
      model.model,
      (r) => ({
        type: types.ADYEN_PAYMENT_SUCCESS,
        data: r.data
      }),
      (r) => ({
        type: types.ADYEN_PAYMENT_FAILED,
        data: r
      }), false, null, false
    );
  } catch (r) {
    yield put({
      type: types.ADYEN_PAYMENT_FAILED
    });
  }
}

function* adyenRefundRequest(model) {
  try {
    yield sagaUtil.fetch(
      `adyen/reversalRequest`,
      model.model,
      (r) => ({
        type: types.ADYEN_REFUND_SUCCESS,
        data: r.data
      }),
      (r) => ({
        type: types.ADYEN_REFUND_FAILED,
        data: r
      }), false, null, false
    );
  } catch (r) {
    yield put({
      type: types.ADYEN_REFUND_FAILED
    });
  }
}

function* getAllBanners() {
  yield sagaUtil.fetch(
    `banners`,
    null,
    (r) => ({
      type: types.GET_ALL_BANNER_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: 'Unable to get banners',
    })
  );
}

function* addBanner(action) {
  const { model } = action;
  yield sagaUtil.fetch(
    'banners/add',
    model,
    (r) => ({
      type: types.ADD_BANNER_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.ADD_BANNER_FAILED,
      data: r,
    })
  );
}

function* getBannerById(action) {
  yield sagaUtil.fetch(
    `banners/${action.bannerId}`,
    null,
    (r) => ({
      type: types.GET_BANNER_BY_ID_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.GET_BANNER_BY_ID_FAILED,
      data: r,
    })
  );
}

function* updateBanner(action) {
  const { model } = action;
  yield sagaUtil.fetch(
    'banners/add',
    model,
    (r) => ({
      type: types.UPDATE_BANNER_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.UPDATE_BANNER_FAILED,
      data: r,
    })
  );
}
function* removeBannerImage(action) {
  const { model } = action;
  try {
    const response = yield sagaUtil.fetch('banners/remove-image', model);
    yield put({
      type: types.SNACKBAR_SHOW_MESSAGE,
      message: 'The item was successfully deleted',
    });
  } catch (error) {
    yield put({
      type: types.SNACKBAR_SHOW_MESSAGE,
      data: error.response?.data || error.message,
      message:
        'An error occurred while removing time slot. Please try again later.',
    });
  }
}
function* deleteBanner(action) {
  yield sagaUtil.fetch(
    `banners/delete/${action.bannerId}`,
    null,
    (r) => ({
      type: types.REMOVE_BANNER_SUCCESS,
      data: r.data,
    }),
    (r) => ({
      type: types.REMOVE_BANNER_FAILED,
      data: r,
    })
  );
}
export function* watchEntity() {
  //LOGIN
  yield throttle(2000, types.LOGIN_REQUEST, login),
    yield throttle(2000, types.CREATE_USER, createUser),
    yield throttle(2000, types.CHANGE_USER_PASSWORD, changePassword),
    yield throttle(2000, types.RESETPASSWORD_USER, resetPassword),
    yield throttle(
      2000,
      types.CHANGE_EMPLOYEE_PASSWORD,
      changeEmployeePassword
    ),
    yield throttle(2000, types.FORGETPASSWORD_USER, forgetPassword),
    yield throttle(2000, types.GET_USER_ROLES, getRoles),
    yield throttle(2000, types.GET_ROLE, getRole),
    yield throttle(2000, types.SAVE_ROLE, saveRole),
    yield throttle(2000, types.UPDATE_ROLE, updateRole),
    yield throttle(2000, types.DELETE_ROLE, deleteRole),
    yield throttle(2000, types.GET_POLICIES, getPolicies),
    yield throttle(2000, types.USERROLE_REPORT_GET, getUserReportRole),
    yield throttle(2000, types.USERROLE_PAGE_GET, getUserPageRole),
    yield throttle(
      2000,
      types.USERROLE_REPORT_GETBYNAME,
      getUserRoleReportByName
    ),
    yield throttle(2000, types.USERROLE_PAGE_GETBYNAME, getUserRolePageByName),
    yield throttle(2000, types.USERROLE_REPORT_SAVE, saveUserReportRole),
    yield throttle(2000, types.USERROLE_PAGE_SAVE, saveUserPageRole),
    yield throttle(2000, types.GET_USER_BRANCHES, getUserBranches),
    yield throttle(2000, types.UNLOCK_ACCOUNT, unlockAccount),
    yield throttle(2000, types.UNLOCK_PATIENT_ACCOUNT, unlockPatientAccount),
    yield throttle(2000, types.PATIENT_ACCOUNT_UNLOCKED, handlePatientUnlock),
    yield throttle(2000, types.VERIFY_CREDENTIAL, verifyCredential),
    //Carousel
    yield throttle(2000, types.CAROUSEL_DELETE, deleteInactiveCarousel),
    //PRODUCT
    yield throttle(2000, types.GET_PRODUCTS, getProducts),
    yield throttle(2000, types.GET_PRODUCTS_CAMPAIGN, getProductsCampaign),
    yield throttle(2000, types.GET_PRODUCTS_CAROUSEL, getProductsCarousel),
    yield throttle(2000, types.GET_PRODUCT, getProduct),
    yield throttle(2000, types.GET_PRODUCT_BY_ID, getProductById),
    yield throttle(2000, types.EDIT_PRODUCT_UPC, editProductUPC),
    yield throttle(
      2000,
      types.UPDATE_UNIT_PRICE_DATABASE,
      updateUnitPriceDatabase
    ),
    yield throttle(2000, types.UNRECEIVE_PO_PRODUCT, unreceivePOProduct),
    yield throttle(2000, types.UNRECEIVE_ALL, unreceiveAll),
    yield throttle(2000, types.DELETE_PO, deletePO),
    yield throttle(2000, types.CREATE_PRODUCT, saveProduct),
    yield throttle(2000, types.CREATE_CATEGORY, createCategory),
    yield throttle(2000, types.PRODUCT_TYPES_GET, getProductTypes),
    yield throttle(2000, types.GET_PRODUCT_LOCATIONS, getProductLocations),
    yield throttle(2000, types.GET_PRODUCTS_BY_CATEGORY, getProductsByCategory),
    yield throttle(2000, types.GET_PRODUCTS_CATEGORIES, getProductCategories),
    yield throttle(
      2000,
      types.GET_PRODUCTS_CATEGORIES_DROPDOWN,
      getProductCategoriesDropdown
    ),
    yield throttle(2000, types.GET_PRODUCT_ORDERS, getProductOrders),
    yield throttle(2000, types.GET_CAMPAIGN_LIST, getCampaignList),
    yield throttle(2000, types.GET_PURCHASE_ORDER_LIST, getPurchaseOrderList),
    yield throttle(2000, types.GET_PRODUCT_BY_BARCODE, getProductBarcode),
    yield throttle(2000, types.DELETE_PRODUCT, deleteProduct),
    yield throttle(2000, types.UPLOAD_PRODUCT, uploadProducts),
    yield throttle(
      2000,
      types.INVENTORY_ADJUST_ROUND_PRICES,
      inventoryAdjustRoundPrices
    ),
    yield throttle(2000, types.BULK_UPDATE_MEMBER_PRICE, bulkUpdateMemberPrice),
    yield throttle(
      2000,
      types.CATEGORY_UPDATE_MEMBER_PRICE,
      categoryUpdateMemberPrice
    ),
    yield throttle(
      2000,
      types.GET_BULK_MEMBER_PRICE_HISTORY,
      getBulkMemberPriceHistory
    ),
    yield throttle(
      2000,
      types.GET_BULK_MEMBER_PRICE_CATEGORY_HISTORY,
      getBulkMemberPriceCategoryHistory
    ),
    yield throttle(
      2000,
      types.GET_PRODUCT_CATEGORY_BULK_UPDATE_PRICE_HISTORY,
      getProductCategoryBulkUpdatePriceHistory
    ),
    yield throttle(2000, types.SYNC_FROM_CATALOG, syncFromCatalog),
    yield throttle(2000, types.GET_PRODUCT_CATALOG_LIST, getProductCatalogList),
    //PRODUCT IMAGE
    yield throttle(2000, types.POST_NEW_PRODUCT_IMAGE, postNewProductImage),
    yield throttle(
      2000,
      types.DELETE_PRODUCT_IMAGE_REQUEST,
      deleteProductImage
    ),
    yield throttle(2000, types.GET_PRODUCT_INFO_REQUEST, getProductInfo),
    // PRODUCT CATEGORY
    yield throttle(2000, types.GET_PRODUCT_CATEGORIES, getCategories),
    yield throttle(
      2000,
      types.GET_PRODUCT_CATEGORIES_BYBRANCHS,
      getAllByBranches
    ),
    yield throttle(2000, types.GET_CATEGORY_TREE, getCategoryTree),
    yield throttle(2000, types.GET_PRODUCT_CATEGORY, getCategory),
    yield throttle(2000, types.SAVE_PRODUCT_CATEGORY, saveCategory),
    yield throttle(2000, types.GET_CLASSES_OF_CANNABIS, getClassesOfCannabis),
    yield throttle(2000, types.SET_PRICE_BY_CATEGORY, setPriceByCategory),
    yield throttle(2000, types.SAVE_PRODUCT_CATEGORY_TAX_PROVINCE, saveProductCategoryTaxProvince),
    //VENDOR
    yield throttle(2000, types.SAVE_VENDOR, saveVendor),
    yield throttle(2000, types.GET_VENDORS, getVendors),
    yield throttle(
      2000,
      types.GET_VENDORS_BY_COUNTRY_STATE,
      getVendorsByCountryState
    ),
    yield throttle(2000, types.GET_VENDOR, getVendor),
    yield throttle(2000, types.GET_ACCESSORY_VENDORS, getAccessoryVendors),
    //PATIENT
    yield throttle(2000, types.SAVE_PATIENT, savePatient),
    yield throttle(2000, types.PATIENT_FORM_LOAD, getPatient),
    yield throttle(2000, types.PATIENT_LIST_LOAD, getPatients),
    yield throttle(2000, types.GET_PATIENT_DETAIL, getPatientDetails),
    yield throttle(2000, types.SEND_MERMBER_MERGE, sendMemberMerge),
    yield throttle(
      2000,
      types.SPRING_BIG_NOTIFICATIONS,
      getPatientSpringBigNotifications
    ),
    yield throttle(2000, types.EDIT_ELITE_MEMBERSHIP, editEliteMembership),
    //DOCTOR
    yield throttle(2000, types.DOCTOR_SAVE, saveDoctor),
    yield throttle(2000, types.DOCTOR_EDIT_LOAD, getDoctor),
    yield throttle(2000, types.DOCTOR_LIST_LOAD, getDoctors),
    yield throttle(2000, types.DOCTOR_INACTIVATE, inactivateDoctor),
    yield throttle(2000, types.DOCTOR_ACTIVATE, activateDoctor),
    //EMPLOYEE
    yield throttle(2000, types.EMPLOYEE_LIST_LOAD, getEmployees),
    yield throttle(2000, types.EMPLOYEE_SAVE, saveEmployee),
    yield throttle(2000, types.EMPLOYEE_GET, getEmployee),
    yield throttle(2000, types.GET_ALL_EMPLOYEES, getAllEmployees),
    yield throttle(
      2000,
      types.GET_ACTIVE_EMPLOYEE_BY_BRANCH,
      getactiveEmployeesOfBranch
    ),
    yield throttle(
      2000,
      types.GET_AUTHENTICATED_EMPLOYEE,
      getAuthenticatedEmployee
    ),
    yield throttle(2000, types.EMPLOYEE_GET_DETAILS, getEmployeeDetails),
    yield throttle(2000, types.GET_EMPLOYEE_BY_FILTER, getEmployeesByFilter),
    //PURCHASE ORDER
    yield throttle(2000, types.SAVE_PURCHASE_ORDER, savePurchaseOrder),
    yield throttle(2000, types.PURCHASE_ORDER_LOAD, getPurchaseOrder),
    yield throttle(2000, types.PURCHASE_ORDER_PRODUCT, getPurchaseOrderProduct),
    yield throttle(2000, types.PO_LIST_LOAD, getPurchaseOrders),
    yield throttle(
      2000,
      types.PO_FOR_BULK_TRANSFER,
      getPurchaseOrderForBulkTransfer
    ),
    yield throttle(2000, types.PURCHASE_ORDER_OPEN, openPurchaseOrder),
    yield throttle(2000, types.PURCHASE_ORDER_CANCEL, cancelPurchaseOrder),
    yield throttle(2000, types.PURCHASE_ORDER_ONORDER, onOrderPurchaseOrder),
    yield throttle(2000, types.PURCHASE_ORDER_IMPORT, importPO),
    yield throttle(
      2000,
      types.PURCHASE_ORDER_IMPORT_TEMPLATE,
      importPOTemplate
    ),
    yield throttle(
      2000,
      types.PURCHASE_ORDER_IMPORT_TEMPLATE_SUCCESS,
      importPOTemplateSuccess
    ),
    yield throttle(
      2000,
      types.PURCHASE_ORDER_CANNABIS_TEMPLATE,
      importPOCannabisTemplate
    ),
    yield throttle(
      2000,
      types.PURCHASE_ORDER_VAPE_TEMPLATE,
      importPOVapeTemplate
    ),
    yield throttle(
      2000,
      types.POS_ORDER_IMPORT_TEMPLATE,
      importPOSOrderTemplate
    ),
    //TRANSFERPRODUCT
    yield throttle(2000, types.WAREHOUSES_GET, getWarehouses),
    yield throttle(
      2000,
      types.PRODUCTWAREHOUSE_LIST_LOAD,
      getProductsFromWarehouse
    ),
    yield throttle(
      2000,
      types.PRODUCTWAREHOUSE_GROUPED_LIST_LOAD,
      getProductsGroupedFromWarehouse
    ),
    yield throttle(2000, types.SEND_BULK_TRANSFER, sendBulkTransfer),
    yield throttle(
      2000,
      types.PRODUCTWAREHOUSE_AUTOCOMPLETE_LIST_LOAD,
      getProductsAutocompleteFromWarehouse
    ),
    yield throttle(
      2000,
      types.BULK_TRANSFER_EXCEL_SEARCH,
      getProductsFromExcelBulkTransfer
    ),
    yield throttle(2000, types.BULK_TRANSFER_LIST_LOAD, getBulkTransfers),
    yield throttle(2000, types.BULK_TRANSFER_By_ID, getBulkTransferById),
    yield throttle(
      2000,
      types.BULK_TRANSFER_PPRODUCT_QUANTITY,
      getProductQuantity
    ),
    yield throttle(2000, types.BULK_TRANSFER_CONFIRM, confirmBulkTransfers),
    yield throttle(
      2000,
      types.GET_PENDING_BULK_TRANSFER_PRODUCTS,
      getPendingBulkTransferProducts
    ),
    yield throttle(2000, types.RECEIVE_PRODUCT_PO, receiveProduct),
    yield throttle(2000, types.PRODUCTS_IN_TRANSIT_LOAD, getProductsInTransit),
    yield throttle(
      2000,
      types.TRANSFER_PRODUCT_WAREHOUSE,
      transferProductToWarehouse
    ),
    yield throttle(
      2000,
      types.PRODUCT_WAREHOUSE_TRANSFERED,
      transferProductToWarehouseSuccess
    ),
    yield throttle(2000, types.MERGE_PRODUCT_WAREHOUSE, mergeProductWarehouse),
    yield throttle(
      2000,
      types.PRODUCT_WAREHOUSE_MERGED,
      mergeProductWarehouseSuccess
    ),
    yield throttle(2000, types.CONVERT_BULK_TO_UNIT, convertBulkToUnit),
    yield throttle(2000, types.CLEAR_ONHOLD_QTY, clearOnHoldQty),
    yield throttle(
      2000,
      types.GET_PRODUCT_INVENTORY_BY_BRANCH,
      getProductInventoryByBranch
    ),
    yield throttle(
      2000,
      types.WORDPRESS_SYNC_ALL_PRODUCTS,
      WpInventorySyncronization
    ),
    yield throttle(
      2000,
      types.WORDPRESS_LOOKUP_UNMAPPED_PRODUCTS,
      lookupWordpressUnmappedProducts
    ),
    yield throttle(2000, types.ADJUST_PRODUCT_QTY, adjustProductQty),
    yield throttle(
      2000,
      types.ADJUST_PRODUCT_WAREHOUSE,
      adjustProductWarehouse
    ),
    yield throttle(
      2000,
      types.ADJUST_PRODUCT_WAREHOUSE_SUCCESS,
      adjustProductWarehouseSuccess
    ),
    yield throttle(
      2000,
      types.GET_PRODUCT_BARCODE_INVENTORY_AUDIT,
      getProductsBarcodeInventoryAudit
    ),
    // WEIGHT
    yield throttle(2000, types.WEIGHT_SETTING_SAVE, saveWeightSetting),
    yield throttle(2000, types.WEIGHT_SETTING_GET, getWeightSetting),
    yield throttle(2000, types.WEIGHT_SETTING_GET_ALL, getWeightSettings),
    // PRICE MATRIX
    yield throttle(2000, types.PRICE_MATRIX_GET_ALL, getPriceMatrices),
    yield throttle(2000, types.PRICE_MATRIX_GET, getPriceMatrix),
    yield throttle(2000, types.PRICE_MATRIX_SAVE, savePriceMatrix),
    yield throttle(
      2000,
      types.PRICE_MATRIX_PRODUCTS_APPLY,
      applyPriceMatrixToProducts
    ),
    // POS
    yield throttle(2000, types.GET_POS, getPOS),
    yield throttle(2000, types.GET_SELLABLE_PRODUCTS, getSellableProducts),
    yield throttle(
      2000,
      types.GET_SELLABLE_PRODUCT_BY_ID,
      getSellableProductById
    ),
    yield throttle(2000, types.GET_POS_PATIENTS, getPOSPatients),
    yield throttle(2000, types.SEND_ORDER_EMAIL_RECEIPT, posEmailReceipt),
    yield throttle(2000, types.SEND_ORDER_SMS_RECEIPT, posSMSReceipt),
    yield throttle(2000, types.SAVE_POS_ORDER, saveOrder),
    yield throttle(2000, types.VOID_POS_ORDER_PRODUCT, voidOrderProduct),
    yield throttle(2000, types.ADD_PAYMENT_POS_ORDER, addPaymentToOrder),
    yield throttle(2000, types.CHECK_ORDER_UPDATE_TIME, checkOrderUpdateTime),
    yield throttle(2000, types.CLEAR_TAX_POS_ORDER, clearTax),
    yield throttle(2000, types.ADD_SHIPPING_COST, addShippingCost),
    yield throttle(2000, types.ADD_TIP_AMOUNT, addTipAmount),
    yield throttle(2000, types.GET_POS_ORDER, getOrder),
    yield throttle(2000, types.CANCEL_POS_ORDER, cancelOrder),
    yield throttle(2000, types.SET_ORDER_DISCOUNT, setDiscount),
    yield throttle(2000, types.SET_ORDER_VISIT_DISCOUNT, setVisitDiscount),
    yield throttle(2000, types.SET_ORDER_PRODUCT_DISCOUNT, setProductsDiscount),
    yield throttle(2000, types.REMOVE_ORDER_DISCOUNT, removeDiscountOrder),
    yield throttle(
      2000,
      types.REMOVE_ORDER_PRODUCT_DISCOUNT,
      removeDiscountProductOrder
    ),
    yield throttle(2000, types.FINALIZE_POS_ORDER, finalizeOrder),
    yield throttle(2000, types.CHECK_PRICE_ESTIMATION, checkPriceEstimation),
    yield throttle(
      2000,
      types.SEND_ORDER_TO_FULFILLMENT,
      sendOrderToFulFillment
    ),
    yield throttle(2000, types.MANAGER_APPROVAL, getManagerApproval),
    yield throttle(2000, types.ADD_REFUND_ORDER, addRefundOrder),
    yield throttle(2000, types.GET_DEVICE_BY_IP, getDeviceByIP),
    yield throttle(2000, types.ASSIGN_MEMBER, assignMember),
    yield throttle(2000, types.POS_ORDER_SAVED, clearTempModel),
    yield throttle(2000, types.SAVE_POS_ORDER_ERROR, clearTempModel),
    yield throttle(
      2000,
      types.ADD_DUTCHIE_OR_LEAFLY_AS_ONLINE_ORDER,
      addDutchieOrLeaflyAsOnlineOrder
    ),
    yield throttle(2000, types.GET_PRODUCT_SUGGESTION, getProductSuggestion),
    // DEVICE
    yield throttle(2000, types.DEVICE_SAVE, saveDevice),
    yield throttle(2000, types.DEVICE_GET, getDevice),
    yield throttle(2000, types.DEVICE_GET_ALL, getDevices),
    yield throttle(2000, types.UPDATE_DEVICE_IP, updateDeviceIp),
    //STORE LIST
    yield throttle(2000, types.STORE_GET_ALL, getStores),
    // DEVICE TYPE
    yield throttle(2000, types.DEVICETYPE_GET_ALL, getDeviceTypes),
    // DEVICE ROLE
    yield throttle(2000, types.DEVICEROLE_GET_ALL, getDeviceRoles),
    yield throttle(2000, types.SAVE_DEVICEROLE, saveDeviceRole),
    // DEVICE WORKSTATION
    yield throttle(
      2000,
      types.DEVICEWORKSTATION_GET_ALL,
      getDeviceWorkStations
    ),
    yield throttle(2000, types.DEVICEWORKSTATION_SAVE, saveDeviceWorkStation),
    // BANK DEPOSITS
    yield throttle(2000, types.BANKDEPOSITS_GET_ALL, getBankDeposits),
    yield throttle(2000, types.BANKDEPOSITS_GET, getBankDeposit),
    yield throttle(2000, types.BANKDEPOSITS_INSERT, insertBankDeposit),
    yield throttle(2000, types.BANKDEPOSITS_UPDATE, updateBankDeposit),
    //SAFE MANAGEMENT
    yield throttle(2000, types.SAFEMANAGEMENT_GET_ALL, getSafeManagements),
    yield throttle(2000, types.SAFEMANAGEMENT_INSERT, saveSafeManagement),
    // CASH FLOW
    yield throttle(2000, types.CASHFLOW_SAVE_CASHIN, cashInAmount),
    yield throttle(2000, types.CASHFLOW_SAVE_CASHOUT, cashOutAmount),
    yield throttle(2000, types.CASHFLOW_GET, getCashFlow),
    yield throttle(2000, types.CASHFLOW_GET_ALL, getCashFlows),
    yield throttle(2000, types.CASHFLOW_CLOSEREGISTER, closeRegister),
    yield throttle(2000, types.CASHFLOW_SAVE_CASHDROP, cashDrop),
    yield throttle(2000, types.CASHFLOW_ORDERS_GET, getCashFlowOrders),
    yield throttle(2000, types.CASHFLOW_VERIFY_CASHOUT, verifyCashOut),
    yield throttle(2000, types.CASHFLOW_NOT_VERIFY_CASHOUT, notVerifyCashOut),
    yield throttle(2000, types.CASHFLOW_CLOSE_REGISTERS, closeRegisters),
    yield throttle(
      2000,
      types.CASHFLOW_CLOSEINPROGRESS_REGISTERS,
      closeClosingInProgressRegisters
    ),
    yield throttle(2000, types.CASHFLOW_NOTES, cashFlowNotes),
    yield throttle(
      2000,
      types.CASHFLOW_REGISTER_COUNT_SAVE,
      cashFlowRegisterCountSave
    ),
    yield throttle(
      2000,
      types.CASHFLOW_REGISTER_COUNT_GET,
      cashFlowRegisterCountGet
    ),
    //PAYMENT
    yield throttle(2000, types.PAYMENT_SAVE, savePayment),
    yield throttle(2000, types.PAYMENT_GET, getPayment),
    yield throttle(2000, types.PAYMENT_GET_ALL, getPayments),
    //TAXRATE
    yield throttle(2000, types.TAXRATE_SAVE, saveTaxRate),
    yield throttle(2000, types.TAXRATE_GET, getTaxRate),
    yield throttle(2000, types.TAXRATE_GET_ALL, getTaxesRate),
    //ORDER
    yield throttle(2000, types.OPEN_ORDERS_GET, getOpenOrders),
    yield throttle(2000, types.RECENT_ORDERS_GET, getRecentOders),
    yield throttle(2000, types.OLD_OPEN_ORDERS_GET, getOldOpenOrders),
    yield throttle(2000, types.CANCEL_OPEN_ORDERS, cancelOpenOrders),
    yield throttle(2000, types.CANCEL_ALL_OPEN_ORDERS, cancelAllOpenOrders),
    yield throttle(2000, types.GET_INVENTORY_FLAG, getInventoryFlag),
    yield throttle(2000, types.CLEAR_INVENTORY_FLAG, clearInventoryFlag),
    // BRANCH
    yield throttle(2000, types.BRANCHES_GET, getBranches),
    //CAMPAIGN
    yield throttle(2000, types.CAMPAIGN_GET_ALL, getCampaigns),
    yield throttle(2000, types.CAMPAIGN_GET_ALL_ONLINE, getAllOnlineCampaigns),
    yield throttle(2000, types.CAMPAIGN_GET, getCampaign),
    yield throttle(2000, types.CAMPAIGN_DELETE, deleteCampaign),
    yield throttle(2000, types.CAMPAIGN_SAVE, saveBulkCampaign),
    //COMBO
    yield throttle(2000, types.COMBO_GET_ALL, getCombos),
    yield throttle(2000, types.COMBO_GET, getCombo),
    yield throttle(2000, types.COMBO_SAVE, saveCombo),
    yield throttle(
      2000,
      types.CHECK_COMBO_PRODUCT_QUANTITY,
      checkComboProductQuantity
    ),
    yield throttle(2000, types.COMBO_DELETE, deleteCombo),
    //DISCOUNT
    yield throttle(2000, types.DISCOUNT_GET_ALL, getCustomizedDiscounts),
    yield throttle(2000, types.DISCOUNT_GET, getCustomizedDiscount),
    yield throttle(2000, types.DISCOUNT_SAVE, saveCustomizedDiscount),
    yield throttle(2000, types.DISCOUNT_DELETE, deleteCustomizedDiscount),
    // APPLICATION SETTINGS
    yield throttle(2000, types.GET_APPLICATION_SETTING, getApplicationSetting),
    yield throttle(
      2000,
      types.GET_APPLICATION_SETTING_INTEGRATION,
      getApplicationSettingIntegraion
    ),
    yield throttle(
      2000,
      types.SAVE_APPLICATION_SETTING,
      updateApplicationSetting
    ),
    // CLOCK IN
    yield throttle(2000, types.SAVE_CLOCKIN_CLOCKOUT, saveClockInClockOut),
    // SHIFT
    yield throttle(2000, types.GET_SHIFTS_FILTER, getShiftsFilter),
    yield throttle(2000, types.GET_EMPLOYEE_SHIFT, getEmmployeeShift),
    yield throttle(
      2000,
      types.GET_EMPLOYEE_SHIFT_BY_STATUS,
      getEmployeeShiftByStatus
    ),
    yield throttle(2000, types.SAVE_EMPLOYEE_SHIFT, saveEmployeeShift),
    yield throttle(2000, types.SAVE_SHIFT, saveShift),
    //ORDER
    yield throttle(2000, types.GET_ORDER_DETAIL, getOrderDetail),
    yield throttle(2000, types.GET_PATIENT_ORDERS, getPatientOrders),
    yield throttle(2000, types.GET_ORDER_PATIENT_REWARD, getOrderPatientReward),
    yield throttle(
      2000,
      types.GET_CASHFLOW_ORDERS_DETAIL,
      getCashFlowOrderDetail
    ),
    //BULK PRICE UPDATE
    yield throttle(2000, types.BULK_PRICE_UPDATE_BY_EXCEL, uploadexcel),
    yield throttle(
      2000,
      types.GET_BULK_PRICE_UPDATE_SCHEDULAR,
      getBulkPriceUpdateSchedular
    ),
    yield throttle(2000, types.DELETE_BULK_PRICE_LIST, deleteBulkPriceList),
    yield throttle(2000, types.UPDATE_BULK_PRICE_LIST, updateBulkPriceList),
    //REPORTS
    yield throttle(
      2000,
      types.GET_TRANSACTION_SUMMARY_BY_BUDTENDER,
      getBudtenderAvgSales
    ),
    yield throttle(2000, types.GET_ANNUAL_SALES, getAnnualSales),
    yield throttle(2000, types.GET_EMPLOYEE_ACTVITY, getEmployeeActivity),
    yield throttle(2000, types.GET_PRODUCT_SALES, getProductSales),
    yield throttle(2000, types.GET_PRODUCT_RANKING, getProductRanking),
    yield throttle(
      2000,
      types.GET_MONTHLY_PRODUCT_SALES,
      getMonthlyProductSales
    ),
    yield throttle(2000, types.GET_EMPLOYEE_TIMESHEET, getEmployeeTimesheet),
    yield throttle(2000, types.GET_EMPLOYEE_HOURS, getEmployeeHours),
    yield throttle(2000, types.GET_DAILY_CASH_SUMMARY, getDailyCashSummary),
    yield throttle(2000, types.GET_INVENTORY_LEVEL, getInventoryLevel),
    yield throttle(2000, types.GET_DEMOGRAPHIC_REPORT, getDemographicReport),
    yield throttle(2000, types.GET_INVENTORY_AGE, getInventoryAge),
    yield throttle(2000, types.GET_RESTOCK_BY_CAPS, getRestockByCaps),
    yield throttle(2000, types.GET_PRICE_TRACKER, getPriceTracker),
    yield throttle(2000, types.GET_THCCBD_TRACKER, getTHCCBDTracker),
    yield throttle(2000, types.GET_INVENTORY_SNAP_SHOT, getInventorySnapShot),
    yield throttle(2000, types.GET_MONTHLY_INVENTORY, getMonthlyInventory),
    yield throttle(
      2000,
      types.GET_INVENTORY_SNAP_SHOT_PRODUCT_VIEW,
      getInventorySnapShotProductView
    ),
    yield throttle(
      2000,
      types.GET_AGGREGATE_INVENTORY_LEVEL,
      getAggregateInventoryLevel
    ),
    yield throttle(
      2000,
      types.GET_TRANSACTION_SALES_SUMMARY,
      getTransactionSaleSummary
    ),
    yield throttle(
      2000,
      types.GET_DESTROYED_PRODUCT_REPORT,
      getDestroyedProductReport
    ),
    yield throttle(
      2000,
      types.GET_PURCHASE_ORDER_REPORT,
      getPurchaseOrderReport
    ),
    yield throttle(2000, types.GET_GENERAL_REPORT, getGeneralReport),
    yield throttle(2000, types.GET_SALES_DAILY_REPORT, getDailySalesReport),
    yield throttle(2000, types.GET_SALES_MONTHLY_REPORT, getMonthlySalesReport),
    yield throttle(2000, types.GET_SALES_YEARLY_REPORT, getYearlySalesReport),
    yield throttle(2000, types.GET_PROFIT_YEARLY_REPORT, getYearlyProfitReport),
    yield throttle(2000, types.GET_PROFIT_DAILY_REPORT, getDailyProfitReport),
    yield throttle(
      2000,
      types.GET_PROFIT_MONTHLY_REPORT,
      getMonthlyProfitReport
    ),
    yield throttle(2000, types.GET_SALES_BY_TYPE, getSalesByType),
    yield throttle(2000, types.GET_PROFIT_REPORT, getProfitReport),
    yield throttle(
      2000,
      types.GET_PRODUCT_PRICE_CHANGE_REPORT,
      getProductPriceChangeReport
    ),
    yield throttle(
      2000,
      types.GET_AGGREGATE_BRANCHES_REPORT,
      getAggregateBranchesReport
    ),
    yield throttle(2000, types.GET_DISCOUNT_REPORT, getDiscountReport),
    yield throttle(2000, types.GET_DISCREPANCY_REPORT, getDiscrepancyReport),
    yield throttle(2000, types.GET_SELL_THROUGH_REPORT, getSellThroughReport),
    yield throttle(2000, types.GET_SHOPPING_TREND, getShoppingTrend),
    yield throttle(2000, types.GET_BUDGET_PLANNER_REPORT, getBudgetPlanner),
    yield throttle(2000, types.GET_CREDIT_PAYMENTS, getCreditPayments),
    yield throttle(2000, types.GET_GIFT_CARD_BALANCE, getGiftCardBalance),
    yield throttle(
      2000,
      types.GET_MANUAL_INVENTORY_CHANGE,
      getManualInvetoryChange
    ),
    yield throttle(2000, types.GET_TAX_SUMMARY, getTaxSummary),
    yield throttle(
      2000,
      types.GET_COMBINED_SALES_REPORT,
      getCombinedSalesReport
    ),
    yield throttle(
      2000,
      types.GET_WAREHOUSE_TRANSFER_REPORT,
      getWarehouseTransferReport
    ),
    yield throttle(2000, types.GET_SALES_SUMMARY, getSalesSummary),
    yield throttle(2000, types.GET_SHIFT_BY_EMPLOYEE, getShiftByEmployee),
    yield throttle(2000, types.GET_END_OF_DAY_REPORT, getEndOfDayReport),
    yield throttle(2000, types.GET_SHIFT_BY_DAY, getShiftByDay),
    yield throttle(
      2000,
      types.GET_INVENTORY_MOVEMENT_REPORT,
      getInventoryMovementReport
    ),
    yield throttle(2000, types.GET_INVENTORY_LOG_REPORT, getInventoryLogReport),
    yield throttle(2000, types.GET_REVENUE_REPORT, getRevenueReport),
    yield throttle(2000, types.GET_CUSTOMER_SALES, getCustomerSales),
    yield throttle(2000, types.GET_PRODUCT_VELOCITY, getProductVelocity),
    yield throttle(2000, types.GET_REORDER_REPORT, getReorderReport),
    yield throttle(2000, types.GET_CATEGORY_SALES, getCategorySales),
    yield throttle(2000, types.GET_HOURLY_SALES, getHourlySales),
    yield throttle(
      2000,
      types.GET_HOURLY_SALES_DATE_RANGE,
      getHourlySalesDateRange
    ),
    yield throttle(
      2000,
      types.GET_HOURLY_SALES_SECONDARY,
      getHourlySalesSecondary
    ),
    yield throttle(2000, types.GET_GMROI_REPORT, getGmroiReport),
    yield throttle(2000, types.GET_AGGREGATE_SALES, getAggregateSales),
    yield throttle(2000, types.GET_AGGREGATE_INVENTORY, getAggregateInventory),
    yield throttle(2000, types.GET_BRAND_SALES, getBrandSales),
    yield throttle(2000, types.GET_INSTORE_ONLINE_SALES, getInstoreOnlineSales),
    yield throttle(2000, types.GET_ORDER_LIST_SALES, getOrderList),
    yield throttle(2000, types.GET_CATEGORY_PRODUCTS, getCategoryProducts),
    yield throttle(2000, types.GET_DELIVERY_REPORT, getDeliveryReport),
    yield throttle(2000, types.GET_GIFT_CARD_REPORT, getGiftCardReport),
    yield throttle(2000, types.GET_PURCHASE_RECEIVER, getPurchaseOrderReceiver),
    yield throttle(
      2000,
      types.GET_SALES_SUMMARY_WITH_DETAILS,
      getSalesSummaryWithDetails
    ),
    yield throttle(
      2000,
      types.GET_AGGREGATE_BRANCH_SALES_INVENTORY,
      GetAggregateBranchSalesInventory
    ),
    yield throttle(2000, types.GET_AUDIT_REPORT, getAuditReport),
    yield throttle(2000, types.GET_UNCOUNTED_REPORT, getUncountedReport),
    yield throttle(2000, types.GET_SAGE_EXPORT_GUID, getSageExportGuid),
    yield throttle(
      2000,
      types.GET_INVENTORY_AT_DATE_GUID,
      getInventoryAtDateGuid
    ),
    yield throttle(2000, types.GET_CSV_REPORT, getCsvReport),
    // MIX AND MATCH
    yield throttle(2000, types.SAVE_MIX_AND_MATCH, saveMixAndMatch),
    yield throttle(2000, types.GET_MIX_AND_MATCH_BY_ID, getMixAndMatchById),
    yield throttle(2000, types.GET_MIX_AND_MATCHES, getMixAndMatches),
    //REWARD POINTS
    yield throttle(2000, types.SAVE_PATIENT_REWARD, setRewardPoint),
    yield throttle(2000, types.GET_REWARD_POINTS, getRewardPoint),
    yield throttle(2000, types.UPDATE_PATIENT_REWARD, updateRewardPoint),
    yield throttle(2000, types.UPDATE_PATIENT_VISIT_COUNT, updateVisitCount),
    //Ecommerce Admin
    yield throttle(2000, types.GET_PRODUCT_GROUP_LIST, getProductGroup),
    yield throttle(2000, types.SAVE_PRODUCT_GROUP, saveProductGroup),
    yield throttle(2000, types.UPDATE_PRODUCT_GROUP, updateProductGroup),
    yield throttle(2000, types.GET_PRODUCT_GROUP_BY_ID, getProductGroupById),
    yield throttle(2000, types.SAVE_HOME_SETTINGS, saveHomeSettings),
    yield throttle(2000, types.GET_HOME_SETTINGS, getHomeSettings),
    yield throttle(2000, types.UPDATE_HOME_SETTINGS, updateHomeSettings),
    yield throttle(2000, types.GET_WEB_UI_SETTINGS, getWebUISettings),
    yield throttle(2000, types.SAVE_WEB_UI_SETTINGS, updateWebUISettings),
    yield throttle(2000, types.GET_DELIVERY_ZONE, getDeliveryZone),
    yield throttle(2000, types.CREATE_DELIVERY_ZONE, createDeliveryZone),
    yield throttle(2000, types.DELETE_DELIVERY_ZONE, deleteDeliveryZone),
    yield throttle(2000, types.UPDATE_DELIVERY_ZONE, updateDeliveryZone),
    yield throttle(2000, types.GET_PRODUCT_GROUP_HOME, getProductGroupHome),
    yield throttle(2000, types.GET_STORE_RULES, getStoreRules),
    yield throttle(2000, types.DELETE_STORE_RULES, deleteStoreRules),
    yield throttle(2000, types.GET_STORE_RULE_BY_ID, getStoreRuleById),
    yield throttle(2000, types.SAVE_STORE_RULES, saveStoreRules),
    yield throttle(2000, types.UPDATE_STORE_RULES, updateStoreRules),
    yield throttle(2000, types.SAVE_STORE_RULES_CONTENT, saveStoreRulesContent),
    //PIN
    yield throttle(2000, types.AUTH_PIN_PASSWORD, authenticatePin),
    yield throttle(2000, types.VALIDATE_PIN_PASSWORD, validatePin),
    yield throttle(2000, types.NEW_PIN, generateNewPin),
    //CHECKIN
    yield throttle(2000, types.GET_CHECK_IN, getCheckIn),
    yield throttle(2000, types.REMOVE_CHECK_IN, removeCheckIn),
    yield throttle(2000, types.CHECK_IN_SEARCH, checkinSearch),
    yield throttle(2000, types.ADD_CHECK_IN, addToCheckIn),
    yield throttle(2000, types.GET_CHECK_IN_BY_ID, getCheckInById),
    //DASHBOARD
    yield throttle(2000, types.GET_ORDERS, getOrders),
    yield throttle(2000, types.GET_CASHDRAWER, getCashDrawer),
    yield throttle(2000, types.GET_SALES, getSales),
    yield throttle(2000, types.GET_TOP_PRODUCTS_SALES, getTopProductsSales),
    yield throttle(2000, types.GET_TOP_MEMBERS, getTopMembers),
    yield throttle(2000, types.GET_TOP_SELLERS, getTopSellers),
    yield throttle(2000, types.GET_TIMESHEET, getTimesheet),
    yield throttle(2000, types.GET_PURCHASE_ORDER, getPurchaseOrdersDb),
    yield throttle(2000, types.GET_INVENTORY, getInvetory),
    yield throttle(2000, types.GET_CAMPAIGN, getCampaignDb),
    yield throttle(2000, types.REMOVE_CACHE, removeCache),

    //SCHEDULE
    yield throttle(2000, types.GET_SCHEDULES, getSchedules),
    yield throttle(2000, types.GET_SCHEDULE_BY_EMPLOYEE, getEmployeeSchedules),
    yield throttle(2000, types.CREATE_SCHEDULE, createSchedule),
    yield throttle(
      2000,
      types.CREATE_SCHEDULE_RECURSIVE,
      createScheduleRecursive
    ),
    yield throttle(2000, types.REMOVE_SCHEDULE, removeSchedule),
    yield throttle(
      2000,
      types.REMOVE_SCHEDULE_RECURSIVE,
      removeScheduleRecursive
    ),
    yield throttle(2000, types.UPDATE_SCHEDULE, updateSchedule),
    yield throttle(2000, types.SEND_SCHEDULE, sendSchedule),
    yield throttle(2000, types.GET_CUSTOM_TIME_SLOTS, getCustomTimeSlots),
    yield throttle(2000, types.ADD_NEW_TIME_SLOT, addNewTimeSlot),
    yield throttle(2000, types.REMOVE_TIME_SLOT, removeTimeSlot),
    //ONLINE ORDER
    yield throttle(2000, types.GET_ONLINE_ORDER, getOnlineOrder),
    yield throttle(2000, types.CLEAR_UNPRINTED_ORDER, clearUnprintedOrder),
    yield throttle(2000, types.GET_ONLINE_ORDER_DETAILS, getOnlineOrderDetails),
    yield throttle(
      2000,
      types.GET_ONLINE_ORDER_DETAILS_BY_CODE,
      getOnlineOrderDetailsByCode
    ),
    yield throttle(2000, types.GET_ONLINE_ORDERS_QUEUE, getOnlineOrdersQueue),
    yield throttle(2000, types.GET_PICKUP_ORDERS_QUEUE, getPickUpOrdersQueue),
    yield throttle(
      2000,
      types.GET_PICKUP_ORDER_DETAILS_BY_CODE,
      getPickUpOrderDetailsByOrderId
    ),
    yield throttle(
      2000,
      types.UPDATE_STATUS_ONLINE_ORDER,
      updateStatusOnlineOrder
    ),
    yield throttle(2000, types.CANCEL_ONLINE_ORDER, cancelOnlineOrder),
    yield throttle(
      2000,
      types.GENERATE_ORDER_BASED_ONLINE_ORDER,
      generateOrderBasedOnlineOrder
    ),
    yield throttle(
      2000,
      types.GET_STORETODOOR_PICKUP_TIME,
      getStoreToDoorPickupTime
    ),
    yield throttle(
      2000,
      types.GET_STORETODOOR_LOCATION_INFO,
      getStoreToDoorLocationInformation
    ),
    yield throttle(2000, types.GET_PRESCRIPTIONS_BY_PATIENT, getPrescriptions),
    yield throttle(2000, types.CREATE_PRESCRIPTION, createPrescription),
    yield throttle(
      2000,
      types.CANCEL_OPEN_ONLINE_ORDERS,
      cancelOpenOnlineOrders
    ),
    yield throttle(
      2000,
      types.GET_OPEN_ONLINE_ORDERS_COUNT,
      getOpenOnlineOrdersCount
    ),
    yield throttle(
      2000,
      types.GET_WORDPRESS_ORDER_LIST_UPDATE,
      getWordpressOrdersUpdate
    ),
    yield throttle(
      2000,
      types.GET_MANUAL_WORDPRESS_ORDER_LIST_UPDATE,
      getManualWordpressOrdersUpdate
    ),
    //Card Payment
    yield throttle(
      2000,
      types.GET_MONERIS_RECEIPT_BY_ORDERID,
      getMonerisReceiptByOrderId
    ),
    //INVENTROY ADJUST
    yield throttle(2000, types.GET_INVENTORY_ADJUST, getInventoryAdjust),
    yield throttle(2000, types.SAVE_INVENTORY_ADJUST, saveInventoryAdjust),
    //LEAFLY INTEGRATION
    yield throttle(2000, types.SYNC_PRODUCTS_TO_LEAFLY, syncProductsToLeafly),
    yield throttle(2000, types.TRACK_DRAWER_OPEN, trackingDrawerOpen),
    yield throttle(2000, types.SIGN_UP_ONLINE_USER, signUpOnlineUser),
    //WEEDMAPS INTEGRATION
    yield throttle(
      2000,
      types.SYNC_PRODUCTS_TO_WEEDMAPS,
      syncProductsToWeedmaps
    ),
    // SEND MESSAGE
    yield throttle(2000, types.SEND_MESSAGE, sendMessageBy),
    yield throttle(2000, types.SEND_TEST_MESSAGE, sendTestMessage),
    yield throttle(2000, types.UPDATE_TWILIO_INFO, updateTwilioInfo),
    yield throttle(2000, types.UPLOAD_IMAGE, uploadImage),
    //GIFT CARD
    yield throttle(
      2000,
      types.GIFT_CARD_INITIALIZATION,
      giftCardInitialization
    ),
    yield throttle(2000, types.GIFT_CARD_DATA_INQUIRY, giftCardDataInquiry),
    yield throttle(2000, types.GIFT_CARD_PURCHASE, giftCardPurchase),
    yield throttle(2000, types.GIFT_CARD_ACTIVATION, giftCardActivation),
    yield throttle(2000, types.GIFT_CARD_DEACTIVATION, giftCardDeactivation),
    yield throttle(2000, types.GIFT_CARD_REFUND, giftCardRefund),
    yield throttle(
      2000,
      types.IMPORT_PRODUCTS_FROM_CATALOG,
      importProductsFromCatalog
    ),
    yield throttle(
      2000,
      types.IMPORT_ACCESSORY_FROM_CATALOG,
      importAccessoryFromCatalog
    ),
    yield throttle(
      2000,
      types.UPDATE_BC_CLOSING_INVENTORY,
      updateBCClosingInventory
    ),
    yield throttle(
      2000,
      types.UPDATE_CLOSING_INVENTORY,
      updateClosingInventory
    ),
    yield throttle(
      2000,
      types.GET_CLOSING_INVENTORY_PRODUCT,
      getClosingInventoryStatus
    ),
    yield throttle(
      2000,
      types.BIRCHMOUNT_GIFTCARD_OPERATION,
      birchmountGiftCardOperation
    ),
    yield throttle(
      2000,
      types.BIRCHMOUNT_GIFT_CARD_PURCHASE,
      birchmountGiftCardPurchase
    ),
    yield throttle(
      2000,
      types.BIRCHMOUNT_GIFT_CARD_REFUND,
      birchmountGiftCardRefund
    ),
    yield throttle(
      2000,
      types.PAYSTONE_GIFTCARD_OPERATION,
      paystoneGiftCardOperation
    ),
    yield throttle(
      2000,
      types.PAYSTONE_GIFTCARD_PURCHASE,
      paystoneGiftCardPurchase
    ),
    yield throttle(
      2000,
      types.PAYSTONE_GIFTCARD_REFUND,
      paystoneGiftCardRefund
    ),
    yield throttle(2000, types.GIFT_CARD_CREATE_RELOAD, giftCardCreateOrReload),
    yield throttle(
      2000,
      types.GIFT_CARD_BALANCE_PAGE_CHECK,
      giftCardcheckingBalance
    ),
    yield throttle(2000, types.CHARGE_GIFT_CARD_TO_ORDER, chargeGiftCard),
    //SPRING BIG
    yield throttle(2000, types.GET_SPRINGBIG_OFFERS, getSpringbigOffers),
    yield throttle(2000, types.GET_SPRINGBIG_REWARDS, getSpringbigRewards),
    yield throttle(
      2000,
      types.GET_SPRINGBIG_MEMBERPOINTS,
      getSpringbigMemberPoints
    ),
    yield throttle(
      2000,
      types.POST_SPRINGBIG_OFFER_DISCOUNT,
      postSpringbigOfferDiscount
    ),
    yield throttle(
      2000,
      types.POST_SPRINGBIG_REWARD_DISCOUNT,
      postSpringbigRewardDiscount
    ),
    //ALPINEIQ
    yield throttle(2000, types.ALPINEIQ_VERIFY_WALLET, alpineIQverifyWallet),
    yield throttle(2000, types.ALPINEIQ_REGISTER, alpineIQregister),
    yield throttle(2000, types.ALPINEIQ_VIEW_WALLET, alpineIQviewWallet),
    yield throttle(2000, types.POST_ALPINEIQ_DISCOUNT, postAlpineIQDiscount),
    yield throttle(2000, types.ALPINEIQ_CHECKIN, alpineIQCheckIn),
    //AUDIT
    yield throttle(2000, types.GET_AUDIT, getAudit),
    yield throttle(2000, types.GET_AUDITS, getAudits),
    yield throttle(2000, types.AUDIT_SAVE, saveAudit),
    yield throttle(2000, types.AUDIT_DELETE, deleteAudit),
    yield throttle(2000, types.FILTER_AUDIT_LIST_STATUS, filterAuditListStatus),
    yield throttle(2000, types.AUDIT_PRODUCT_REMOVE, removeProductInAduit),
    yield throttle(2000, types.AUDIT_PRODUCT_ADD, addProductsToAduit),
    yield throttle(2000, types.AUDIT_UPDATE_NAME, updateAuditName),
    yield throttle(
      2000,
      types.AUDIT_PRODUCT_UPDATE_QUANTITY,
      updateAuditProductQuantity
    ),
    yield throttle(
      2000,
      types.AUDIT_PRODUCT_UPDATE_EXPECTED_QTY,
      updateAuditProductExpectedQuantity
    ),
    yield throttle(
      2000,
      types.AUDIT_PRODUCT_UPDATE_DIFF_QTY,
      updateAuditProductDiffQty
    ),
    yield throttle(
      2000,
      types.AUDIT_PRODUCT_UPDATE_NOTES,
      updateAuditProductNotes
    ),
    yield throttle(2000, types.AUDIT_WAREHOUSES, getAuditWarehouses),
    yield throttle(2000, types.AUDIT_COMPLETE, completeAudit),
    yield throttle(2000, types.AUDIT_VERIFY, verifyAudit),
    yield throttle(2000, types.AUDIT_RECOUNT, recountAudit),
    yield throttle(2000, types.AUDIT_PRODUCTS, getAuditProducts),
    yield throttle(2000, types.AUDIT_CATEGORY, getAuditCategory),
    yield throttle(2000, types.GET_BRANDS, getBrands),
    yield throttle(2000, types.AUDIT_BRAND, getAuditBrand),
    yield throttle(2000, types.AUDIT_UNCOUNTED, getUncountedByCategory),
    yield throttle(2000, types.AUDIT_CATEGORIES, getAuditCategories),
    //MOOD
    yield throttle(2000, types.ADD_MOOD, addMood),
    yield throttle(2000, types.ASSIGN_MOOD, assignMood),
    yield throttle(2000, types.GET_PRODUCT_MOODS, getProductMoods),
    yield throttle(2000, types.GET_MOODS, getMoods),
    yield throttle(2000, types.DELETE_MOOD, deleteMood),
    //TERPENE
    yield throttle(2000, types.ADD_TERPENE, addTerpene),
    yield throttle(2000, types.ASSIGN_TERPENE, assignTerpene),
    yield throttle(2000, types.GET_PRODUCT_TERPENES, getProductTerpenes),
    yield throttle(2000, types.GET_TERPENES, getTerpenes),
    yield throttle(2000, types.DELETE_TERPENE, deleteTerpene),
    yield throttle(2000, types.SAVE_TERPENE, saveTerpene),
    //MINOR CANABINOID
    yield throttle(2000, types.ADD_MINORCANABINOID, addMinorCanabinoid),
    yield throttle(2000, types.ASSIGN_MINORCANABINOID, assignMinorCanabinoid),
    yield throttle(
      2000,
      types.GET_PRODUCT_MINORCANABINOIDS,
      getProductMinorCanabinoids
    ),
    yield throttle(2000, types.GET_MINORCANABINOIDS, getMinorCanabinoids),
    yield throttle(2000, types.DELETE_MINORCANABINOID, deleteMinorCanabinoid),
    yield throttle(2000, types.SAVE_MINORCANABINOID, saveMinorCanabinoid),
    //MULTI STORE INVENTORY
    yield throttle(
      2000,
      types.GET_PRODUCT_INVENTORY_BY_BRANCH_DATE,
      GetProductInventoryLog
    ),
    yield throttle(
      2000,
      types.GET_MULTI_BRANCH_INVENTORY,
      getMultiBranchInventory
    ),
    yield throttle(2000, types.SET_RESTOCK_QTY, setRestockQty),
    yield throttle(
      2000,
      types.GET_SINGLE_PRODUCT_INVENTORY,
      getSingleBranchInventory
    ),
    //REPORT AUTOMATION
    yield throttle(2000, types.SEND_REPORT_AUTOMATION, submitReportAutomation),
    yield throttle(
      2000,
      types.GET_REPORT_AUTOMATION_INFO,
      getReportAutomationInfo
    ),
    yield throttle(
      2000,
      types.UPDATE_REPORT_AUTOMATION_INFO,
      updateReportAutomationInfo
    ),
    yield throttle(
      2000,
      types.DELETE_REPORT_AUTOMATION,
      deleteReportAutomationInfo
    ),
    //STORE LOCK DATE AND TIME
    yield throttle(
      2000,
      types.CREATE_STORE_LOCK_DATE_AND_TIME,
      AddStoreLockDateNTime
    ),
    yield throttle(
      2000,
      types.GET_STORE_LOCK_DATE_AND_TIME,
      getStoreLockDateNTime
    ),
    yield throttle(
      2000,
      types.DELETE_STORE_LOCK_DATE_AND_TIME,
      deleteStoreLockDateNTime
    ),
    yield throttle(
      2000,
      types.UPDATE_STORE_LOCK_DATE_AND_TIME,
      updateStoreLockDateNTime
    ),
    //STORE SEO SETTINGS
    yield throttle(
      2000,
      types.GET_STORE_SEO_SETTINGS_REQUEST,
      getStoreSEOSettings
    ),
    yield throttle(
      2000,
      types.UPDATE_STORE_SEO_SETTINGS_REQUEST,
      updateStoreSEOSettings
    ),
    //STORE TO DOOR
    yield throttle(
      2000,
      types.CREATE_STORE_TO_DOOR_DELIVERY_TIME,
      AddStoreToDoorDateTime
    ),
    yield throttle(
      2000,
      types.GET_ALL_STORE_TO_DOOR_DELIVERY_TIME,
      GetAllStoreToDoorDateTime
    ),
    yield throttle(
      2000,
      types.DELETE_STORE_TO_DOOR_DELIVERY_TIME,
      DeleteStoreToDoorDateTime
    ),
    yield throttle(
      2000,
      types.UPDATE_STORE_TO_DOOR_DELIVERY_TIME,
      UpdateStoreToDoorDateTime
    ),
    //PRODUCT GROUP IMAGE
    yield throttle(
      2000,
      types.GET_PRODUCT_GROUP_IMAGE_REQUEST,
      getProductGroupImage
    ),
    yield throttle(
      2000,
      types.ADD_PRODUCT_GROUP_IMAGE_REQUEST,
      postNewProductGroupImage
    ),
    yield throttle(
      2000,
      types.DELETE_PRODUCT_GROUP_IMAGE_REQUEST,
      deleteProductGroupImage
    );
    //ADYEN PAYMENT
    yield throttle(2000, types.ADYEN_PAYMENT_REQUEST, adyenPaymentRequest),
    yield throttle(2000, types.ADYEN_REFUND_REQUEST, adyenRefundRequest)

    //BANNER
    yield throttle(2000, types.GET_ALL_BANNER_REQUEST, getAllBanners),
    yield throttle(2000, types.ADD_BANNER_REQUEST, addBanner),
    yield throttle(2000, types.GET_BANNER_BY_ID_REQUEST, getBannerById),
    yield throttle(2000, types.UPDATE_BANNER_REQUEST, updateBanner),
    yield throttle(2000, types.REMOVE_BANNER_IMAGE_REQUEST, removeBannerImage),
    yield throttle(2000, types.REMOVE_BANNER_BY_ID_REQUEST, deleteBanner);
}
